/** @type {Record<string, DeviceModelData>} */
export default {
  "ART10AKPL": {
    "series": "ART10",
    "broadcast": "atsc",
    "machine": "lm21ut",
    "codename": "kisscurl",
    "otaId": "HE_DTV_N21D_AFAAATAA",
    "sizes": [
      27
    ],
    "regions": [
      "KR",
      "TR",
      "UK",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "ART10CKPL": {
    "series": "ART10",
    "broadcast": "atsc",
    "machine": "lm21ut",
    "codename": "kisscurl",
    "otaId": "HE_DTV_N21D_AFAAATAA",
    "sizes": [
      27
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "ART10CMPL": {
    "series": "ART10",
    "broadcast": "atsc",
    "machine": "lm21ut",
    "codename": "kisscurl",
    "otaId": "HE_DTV_N21D_AFAAATAA",
    "sizes": [
      27
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "ART10DKPL": {
    "series": "ART10",
    "broadcast": "atsc",
    "machine": "lm21ut",
    "codename": "kisscurl",
    "otaId": "HE_DTV_N21D_AFAAATAA",
    "sizes": [
      27
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "ART10DQPL": {
    "series": "ART10",
    "broadcast": "atsc",
    "machine": "lm21ut",
    "codename": "kisscurl",
    "otaId": "HE_DTV_N21D_AFAAATAA",
    "sizes": [
      27
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "ART10DSPL": {
    "series": "ART10",
    "broadcast": "atsc",
    "machine": "lm21ut",
    "codename": "kisscurl",
    "otaId": "HE_DTV_N21D_AFAAATAA",
    "sizes": [
      27
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "ART90E6QA": {
    "series": "ART90",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "BE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "ART90E9QA": {
    "series": "ART90",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      65
    ],
    "regions": [
      "AT",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "ART90EJQA": {
    "series": "ART90",
    "broadcast": "arib",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABJAAA",
    "sizes": [
      65
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "ART90EKPA": {
    "series": "ART90",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "ART90EKPB": {
    "series": "ART90",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "ART90EKPC": {
    "series": "ART90",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "ART90ESQA": {
    "series": "ART90",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "MX",
      "NZ",
      "SG",
      "TW"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "EC9300": {
    "series": "EC93",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      55
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1M_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "EC930T": {
    "series": "EC93",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      55
    ],
    "regions": [
      "AE",
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "ZA"
    ]
  },
  "EC930V": {
    "series": "EC93",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      55
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "EC9310": {
    "series": "EC93",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_WT1M_AFAAJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "EC9700": {
    "series": "EC97",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "sizes": [
      65
    ],
    "regions": [
      "CA",
      "KR",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1H_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "EC970T": {
    "series": "EC97",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "MY",
      "NZ",
      "SG",
      "TH"
    ]
  },
  "EC970V": {
    "series": "EC97",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "EC980V": {
    "series": "EC98",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "NL",
      "PL",
      "RU",
      "TR",
      "UK"
    ]
  },
  "EF9500": {
    "series": "EF95",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "KR",
      "US"
    ]
  },
  "EF9509": {
    "series": "EF95",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL",
      "SE"
    ]
  },
  "EF950T": {
    "series": "EF95",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "EF950V": {
    "series": "EF95",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "RU",
      "SE",
      "UK"
    ]
  },
  "EG9100": {
    "series": "EG91",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      55
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15M_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W15M_AFAAJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "EG9109": {
    "series": "EG91",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "EG910T": {
    "series": "EG91",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      55
    ],
    "regions": [
      "AE",
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "ZA"
    ]
  },
  "EG910V": {
    "series": "EG91",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      55
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "EG9200": {
    "series": "EG92",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      55
    ],
    "regions": [
      "BR",
      "CA",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15A_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "EG9209": {
    "series": "EG92",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "IT"
    ]
  },
  "EG920T": {
    "series": "EG92",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".ATB",
    "sizes": [
      55
    ],
    "regions": [
      "AE",
      "PH",
      "SA",
      "SG",
      "TH"
    ]
  },
  "EG920V": {
    "series": "EG92",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "EG9350": {
    "series": "EG93",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "EG9370": {
    "series": "EG93",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "EG9450": {
    "series": "EG94",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "EG9470": {
    "series": "EG94",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "EG9600": {
    "series": "EG96",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "KR",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15U_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W15U_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "EG9609": {
    "series": "EG96",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "PL",
      "PT"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA"
      }
    ]
  },
  "EG960T": {
    "series": "EG96",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "ZA"
    ]
  },
  "EG960V": {
    "series": "EG96",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "machine": "lm14a",
        "otaId": "HE_DTV_W15A_AFADABAA"
      }
    ]
  },
  "EG9650": {
    "series": "EG96",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "EG965T": {
    "series": "EG96",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".ATT",
    "sizes": [
      65
    ],
    "regions": [
      "ID",
      "PH",
      "TW",
      "VN"
    ]
  },
  "EG9700": {
    "series": "EG97",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1H_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "EG970T": {
    "series": "EG97",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      77
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SG"
    ]
  },
  "EG9770": {
    "series": "EG97",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "EG9A7K": {
    "series": "EG9A",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "EG9A7L": {
    "series": "EG9A",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "EG9A7P": {
    "series": "EG9A",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "EG9A7V": {
    "series": "EG9A",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      55
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "JL9000": {
    "series": "JL90",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      60
    ],
    "regions": [
      "UK"
    ]
  },
  "JL9100": {
    "series": "JL91",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      40,
      49,
      55
    ],
    "regions": [
      "UK"
    ]
  },
  "LB6300": {
    "series": "LB63",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "suffix": ".AUSS",
    "sizes": [
      42,
      47,
      50,
      55,
      60,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "LB630V": {
    "series": "LB63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "LB6310": {
    "series": "LB63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "AU",
      "ID",
      "NZ",
      "PH"
    ]
  },
  "LB631T": {
    "series": "LB63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ATC",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "ID",
      "SG",
      "VN"
    ]
  },
  "LB631V": {
    "series": "LB63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ADGZ",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "LB6330": {
    "series": "LB63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AFD",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "AE",
      "ZA"
    ]
  },
  "LB633T": {
    "series": "LB63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AFB",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "AE",
      "ZA"
    ]
  },
  "LB6350": {
    "series": "LB63",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "suffix": ".ACCS",
    "sizes": [
      47,
      55
    ],
    "regions": [
      "CA"
    ]
  },
  "LB639V": {
    "series": "LB63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ARUB",
    "sizes": [
      42
    ],
    "regions": [
      "RU"
    ]
  },
  "LB6500": {
    "series": "LB65",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      39,
      42,
      47,
      50,
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "ID",
      "KR",
      "MX",
      "PE",
      "PH",
      "SG",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1M_AFAAABAA",
        "suffix": ".AAU",
        "sizes": [
          32,
          42,
          47,
          50,
          55,
          60
        ],
        "regions": [
          "AU",
          "HK",
          "NZ"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_WT1M_AFAAJAAA",
        "suffix": ".AJL",
        "sizes": [
          32,
          60
        ],
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "LB65006LA": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AEI",
    "sizes": [
      43
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "KZ",
      "NL",
      "PT",
      "UK"
    ]
  },
  "LB6500KNB": {
    "series": "LB65",
    "broadcast": "atsc",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "sizes": [
      43
    ],
    "regions": [
      "KR"
    ]
  },
  "LB6500PSB": {
    "series": "LB65",
    "broadcast": "isdb",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      43
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX"
    ]
  },
  "LB650B6LA": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AEK",
    "sizes": [
      32
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "LB650BCNA": {
    "series": "LB65",
    "broadcast": "atsc",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LB650BENA": {
    "series": "LB65",
    "broadcast": "atsc",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LB650BGNA": {
    "series": "LB65",
    "broadcast": "atsc",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LB650BKNA": {
    "series": "LB65",
    "broadcast": "atsc",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LB650BPSA": {
    "series": "LB65",
    "broadcast": "isdb",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AWR",
    "sizes": [
      32
    ],
    "regions": [
      "BR",
      "CL",
      "MX",
      "PE"
    ]
  },
  "LB650BPUA": {
    "series": "LB65",
    "broadcast": "atsc",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "LB650T": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AWC",
    "sizes": [
      32,
      39,
      42,
      47,
      50,
      55,
      60,
      65
    ],
    "regions": [
      "CO",
      "ID",
      "SG",
      "TH",
      "VN"
    ]
  },
  "LB650V": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32,
      39,
      42,
      47,
      50,
      55,
      60,
      70
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "LB6520": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AFD",
    "sizes": [
      32,
      42,
      47,
      50,
      55,
      60
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "LB652T": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AFB",
    "sizes": [
      42,
      47,
      50,
      55,
      60
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "LB652V": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      32,
      42,
      47,
      55
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "TR"
    ]
  },
  "LB653V": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ADGZ",
    "sizes": [
      32,
      42,
      47,
      50,
      55
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "LB6550PSA": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".ATM",
    "sizes": [
      43
    ],
    "regions": [
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "LB655BPCA": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AHKG",
    "sizes": [
      32
    ],
    "regions": [
      "HK"
    ]
  },
  "LB655BPSA": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AAU",
    "sizes": [
      32
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "TH",
      "VN"
    ]
  },
  "LB6560": {
    "series": "LB65",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      47,
      50,
      55,
      60
    ],
    "regions": [
      "AE",
      "KR",
      "SA"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1M_AFAAABAA",
        "suffix": ".AAU",
        "sizes": [
          70
        ],
        "regions": [
          "AU",
          "NZ"
        ]
      }
    ]
  },
  "LB656T": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ATC",
    "sizes": [
      70
    ],
    "regions": [
      "AE",
      "ID",
      "SG",
      "TH",
      "ZA"
    ]
  },
  "LB656V": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      32,
      42,
      47,
      55,
      70
    ],
    "regions": [
      "AT",
      "AU",
      "DE",
      "NZ"
    ]
  },
  "LB6580": {
    "series": "LB65",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      47,
      50,
      55,
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "LB658V": {
    "series": "LB65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ARUB",
    "sizes": [
      42
    ],
    "regions": [
      "RU"
    ]
  },
  "LB660BPSB": {
    "series": "LB66",
    "broadcast": "atsc",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AWM",
    "sizes": [
      32
    ],
    "regions": [
      "MX"
    ]
  },
  "LB6700": {
    "series": "LB67",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      47,
      50,
      55
    ],
    "regions": [
      "AE",
      "ID",
      "KR",
      "PH",
      "SA"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1M_AFAAABAA",
        "suffix": ".AAU",
        "sizes": [
          42,
          47,
          50,
          55
        ],
        "regions": [
          "AU",
          "HK",
          "NZ",
          "PH"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_WT1M_AFAAJAAA",
        "suffix": ".AJL",
        "sizes": [
          42,
          47,
          55
        ],
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "LB670T": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ATC",
    "sizes": [
      42,
      47,
      50,
      55
    ],
    "regions": [
      "ID",
      "SG",
      "TH"
    ]
  },
  "LB670V": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEE",
    "sizes": [
      42,
      47,
      50,
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR"
    ]
  },
  "LB671V": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      47,
      50,
      55
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE"
    ]
  },
  "LB673V": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ADGZ",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "LB674V": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      47,
      50,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "PL"
    ]
  },
  "LB675V": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ADRB",
    "sizes": [
      42,
      47,
      50,
      55
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "LB676V": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      47,
      50,
      55
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "LB677V": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ADRB",
    "sizes": [
      42,
      47,
      50
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "LB6780": {
    "series": "LB67",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      47,
      50,
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "LB678V": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "NL",
      "PL"
    ]
  },
  "LB679V": {
    "series": "LB67",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "KZ",
      "PL",
      "RU"
    ]
  },
  "LB6800": {
    "series": "LB68",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      47,
      50,
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "LB680V": {
    "series": "LB68",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ADGZ",
    "sizes": [
      42,
      47,
      55,
      60,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "LB689V": {
    "series": "LB68",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ARUB",
    "sizes": [
      42
    ],
    "regions": [
      "RU"
    ]
  },
  "LB690V": {
    "series": "LB69",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ADK",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "LB7000": {
    "series": "LB70",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "LB70006LA": {
    "series": "LB70",
    "broadcast": "dvb",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AEI",
    "sizes": [
      24,
      27
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "LB7000PCA": {
    "series": "LB70",
    "broadcast": "dvb",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AHKG",
    "sizes": [
      24,
      27
    ],
    "regions": [
      "HK"
    ]
  },
  "LB7000PUA": {
    "series": "LB70",
    "broadcast": "atsc",
    "machine": "lm24f",
    "codename": "queue",
    "otaId": "HE_DTV_W26L_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      24,
      27
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "LB700V": {
    "series": "LB70",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "LB7050": {
    "series": "LB70",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      47,
      55
    ],
    "regions": [
      "BR",
      "PE"
    ]
  },
  "LB7100": {
    "series": "LB71",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      60,
      65,
      70
    ],
    "regions": [
      "CA",
      "KR",
      "US"
    ]
  },
  "LB7200": {
    "series": "LB72",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      42,
      47,
      55,
      60,
      65,
      70
    ],
    "regions": [
      "AE",
      "BR",
      "CL",
      "MX",
      "PE",
      "SA",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1M_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "LB720T": {
    "series": "LB72",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AFB",
    "sizes": [
      47,
      55,
      60,
      65,
      70
    ],
    "regions": [
      "CO",
      "ZA"
    ]
  },
  "LB720V": {
    "series": "LB72",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ADK",
    "sizes": [
      42,
      47,
      55,
      60
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "LB7300": {
    "series": "LB73",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      47,
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "LB730V": {
    "series": "LB73",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      47,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "LB731V": {
    "series": "LB73",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      47,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "PL",
      "SE",
      "UK"
    ]
  },
  "LB7500": {
    "series": "LB75",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      47,
      55
    ],
    "regions": [
      "ID",
      "KR"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1M_AFAAABAA",
        "suffix": ".AAU",
        "sizes": [
          55,
          60,
          65
        ],
        "regions": [
          "AU",
          "NZ"
        ]
      }
    ]
  },
  "LB750T": {
    "series": "LB75",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ATA",
    "sizes": [
      42,
      47,
      55,
      60,
      65
    ],
    "regions": [
      "MY",
      "SG",
      "TH"
    ]
  },
  "LB7570": {
    "series": "LB75",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      70
    ],
    "regions": [
      "KR"
    ]
  },
  "LB8600": {
    "series": "LB86",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "sizes": [
      55,
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "LB860V": {
    "series": "LB86",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".ADRB",
    "sizes": [
      49,
      55,
      60
    ],
    "regions": [
      "RU"
    ]
  },
  "LB8700": {
    "series": "LB87",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAATAA",
    "suffix": ".AWF",
    "sizes": [
      49,
      55,
      60
    ],
    "regions": [
      "CL",
      "HK",
      "MX",
      "PE"
    ]
  },
  "LB870V": {
    "series": "LB87",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "afro",
    "otaId": "HE_DTV_WT1M_AFAAABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55,
      60
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR"
    ]
  },
  "LF5800": {
    "series": "LF58",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      32,
      42,
      50,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "ES",
      "FR",
      "IT",
      "KR",
      "MX",
      "PT"
    ]
  },
  "LF5900": {
    "series": "LF59",
    "broadcast": "atsc",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "HK",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15L_AFAAABAA",
        "suffix": ".AAU",
        "regions": [
          "AU",
          "IN",
          "NZ",
          "PH"
        ]
      }
    ]
  },
  "LF5909": {
    "series": "LF59",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "DE"
    ]
  },
  "LF590T": {
    "series": "LF59",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".AWC",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "CO",
      "ID",
      "MY",
      "SA",
      "SG",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "LF590V": {
    "series": "LF59",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "LF5929": {
    "series": "LF59",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      55
    ],
    "regions": [
      "DE"
    ]
  },
  "LF592U": {
    "series": "LF59",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".AEE",
    "sizes": [
      32
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL",
      "PT",
      "RU",
      "SE"
    ]
  },
  "LF592V": {
    "series": "LF59",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".AEN",
    "sizes": [
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "PL",
      "SE"
    ]
  },
  "LF5950": {
    "series": "LF59",
    "broadcast": "atsc",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAATAA",
    "suffix": ".ACC",
    "sizes": [
      55
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15L_AFAAABAA",
        "suffix": ".ANR",
        "regions": [
          "AU",
          "NZ",
          "PH"
        ]
      }
    ]
  },
  "LF595B": {
    "series": "LF59",
    "broadcast": "atsc",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "BR",
      "CA",
      "MX",
      "PE",
      "SG",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15L_AFAAABAA",
        "suffix": ".ATR",
        "regions": [
          "IN",
          "PH"
        ]
      }
    ]
  },
  "LF595D": {
    "series": "LF59",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".ATI",
    "sizes": [
      32
    ],
    "regions": [
      "CO",
      "ID",
      "SG",
      "TH",
      "VN"
    ]
  },
  "LF595T": {
    "series": "LF59",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".ATI",
    "sizes": [
      55
    ],
    "regions": [
      "AE",
      "ID",
      "MY",
      "SA",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "LF6300": {
    "series": "LF63",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "CA",
      "KR",
      "MX",
      "US",
      "VN"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15M_AFAAABAA",
        "suffix": ".AAU",
        "sizes": [
          32,
          40,
          43,
          49,
          55,
          60,
          65
        ],
        "regions": [
          "AU",
          "IN",
          "NZ",
          "PH",
          "ZA"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W15M_AFAAJAAA",
        "suffix": ".AJL",
        "sizes": [
          32,
          43,
          49,
          55
        ],
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "LF6309": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      32,
      40,
      43,
      49,
      55
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "LF630T": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".ATA",
    "sizes": [
      32,
      40,
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "ID",
      "MY",
      "SA",
      "SG",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "LF630V": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32,
      40,
      43,
      49,
      55,
      60
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "LF6310": {
    "series": "LF63",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      60,
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15M_AFAAABAA",
        "suffix": ".ATR",
        "sizes": [
          32,
          43,
          49
        ],
        "regions": [
          "HK",
          "IN"
        ]
      }
    ]
  },
  "LF6319": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      32,
      40,
      43,
      49,
      55
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "LF631V": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      32,
      40,
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "VN"
    ]
  },
  "LF6329": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      32,
      40,
      43,
      49,
      55
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "LF632T": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".ATV",
    "sizes": [
      40,
      43,
      49,
      55,
      60
    ],
    "regions": [
      "VN"
    ]
  },
  "LF632V": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      32,
      40,
      43,
      49,
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "NL",
      "PL",
      "PT",
      "SE"
    ]
  },
  "LF634V": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".ADRB",
    "sizes": [
      40,
      43,
      49
    ],
    "regions": [
      "RU"
    ]
  },
  "LF6350": {
    "series": "LF63",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ]
  },
  "LF635T": {
    "series": "LF63",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AWC",
    "sizes": [
      40,
      43,
      49,
      60
    ],
    "regions": [
      "CO"
    ]
  },
  "LF6380": {
    "series": "LF63",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "LF6390": {
    "series": "LF63",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      60,
      65
    ],
    "regions": [
      "CA",
      "KR"
    ]
  },
  "LF6399": {
    "series": "LF63",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "LF6400": {
    "series": "LF64",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      42,
      49
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "LF640V": {
    "series": "LF64",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".ADGZ",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "LF6410": {
    "series": "LF64",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      50,
      55,
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "LF6450": {
    "series": "LF64",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      42,
      49
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "LF6500": {
    "series": "LF65",
    "broadcast": "atsc",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAATAA",
    "sizes": [
      42,
      50,
      55,
      60
    ],
    "regions": [
      "AE",
      "BR",
      "CL",
      "KR",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15M_AFAAABAA",
        "suffix": ".ATA",
        "regions": [
          "HK",
          "IN"
        ]
      }
    ]
  },
  "LF6509": {
    "series": "LF65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      32
    ],
    "regions": [
      "DE"
    ]
  },
  "LF650T": {
    "series": "LF65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AWC",
    "sizes": [
      42,
      50,
      55,
      60
    ],
    "regions": [
      "AE",
      "CO",
      "SA",
      "ZA"
    ]
  },
  "LF650V": {
    "series": "LF65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32,
      42,
      50,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "LF6529": {
    "series": "LF65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      50,
      55
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "LF652V": {
    "series": "LF65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32,
      42,
      50,
      55
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "LF653V": {
    "series": "LF65",
    "broadcast": "dvb",
    "machine": "m14tv",
    "codename": "beehive",
    "otaId": "HE_DTV_W15M_AFAAABAA",
    "suffix": ".ADRB",
    "sizes": [
      32,
      42,
      50,
      55
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "LH560T": {
    "series": "LH56",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".AFB",
    "sizes": [
      43
    ],
    "regions": [
      "ZA"
    ]
  },
  "LH560V": {
    "series": "LH56",
    "broadcast": "dvb",
    "machine": "mtka5lr",
    "codename": "beehive",
    "otaId": "HE_DTV_W15L_AFAAABAA",
    "suffix": ".AEE",
    "sizes": [
      43
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "LH590T": {
    "series": "LH59",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".APH",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "PH",
      "TH",
      "VN"
    ]
  },
  "LH590U": {
    "series": "LH59",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "KZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "LH590V": {
    "series": "LH59",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "VN",
      "ZA"
    ]
  },
  "LH591D": {
    "series": "LH59",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".ATM",
    "sizes": [
      32
    ],
    "regions": [
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "LH595T": {
    "series": "LH59",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      43
    ],
    "regions": [
      "IN"
    ]
  },
  "LH595U": {
    "series": "LH59",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".ARUB",
    "sizes": [
      32
    ],
    "regions": [
      "RU"
    ]
  },
  "LH595V": {
    "series": "LH59",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".ARUB",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "AE",
      "RU",
      "SA",
      "ZA"
    ]
  },
  "LH6000": {
    "series": "LH60",
    "broadcast": "atsc",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "BR",
      "CL",
      "MX",
      "PE",
      "PH"
    ]
  },
  "LH600T": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "AU",
      "CO",
      "IN",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "LH600V": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "LH602D": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LH602V": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".AMA",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "LH6040": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      32,
      43
    ],
    "regions": [
      "HK"
    ]
  },
  "LH6047": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".AEE",
    "sizes": [
      32,
      43,
      49,
      55
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "LH604B": {
    "series": "LH60",
    "broadcast": "atsc",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAATAA",
    "suffix": ".APH",
    "sizes": [
      32
    ],
    "regions": [
      "PH"
    ]
  },
  "LH604D": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".ATV",
    "sizes": [
      32
    ],
    "regions": [
      "VN"
    ]
  },
  "LH604T": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      32
    ],
    "regions": [
      "AU",
      "IN",
      "NZ",
      "PH",
      "SG"
    ]
  },
  "LH604V": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32,
      43,
      49,
      55
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "LH605T": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".ATV",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "VN"
    ]
  },
  "LH609V": {
    "series": "LH60",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".ARUB",
    "sizes": [
      32,
      43,
      49,
      55
    ],
    "regions": [
      "RU"
    ]
  },
  "LH630V": {
    "series": "LH63",
    "broadcast": "dvb",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "PL",
      "PT"
    ]
  },
  "LH6600": {
    "series": "LH66",
    "broadcast": "atsc",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAATAA",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "LH6610": {
    "series": "LH66",
    "broadcast": "atsc",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAATAA",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "LH6680": {
    "series": "LH66",
    "broadcast": "atsc",
    "machine": "m2",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16R_AFAAATAA",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "LJ5400": {
    "series": "LJ54",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "suffix": ".AWFQ",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "CL",
      "MX",
      "PE"
    ]
  },
  "LJ540V": {
    "series": "LJ54",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ARU",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "RU",
      "ZA"
    ]
  },
  "LJ5500": {
    "series": "LJ55",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17R_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "LJ550B": {
    "series": "LJ55",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "suffix": ".AUSQ",
    "sizes": [
      32
    ],
    "regions": [
      "BR",
      "CA",
      "MX",
      "PE",
      "PH",
      "US"
    ]
  },
  "LJ550D": {
    "series": "LJ55",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      32
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "LJ550M": {
    "series": "LJ55",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "suffix": ".AUSQ",
    "sizes": [
      32,
      43,
      49,
      55
    ],
    "regions": [
      "US"
    ]
  },
  "LJ550T": {
    "series": "LJ55",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "LJ550V": {
    "series": "LJ55",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AMA",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "LJ553T": {
    "series": "LJ55",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATV",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "VN"
    ]
  },
  "LJ554T": {
    "series": "LJ55",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "IN"
    ]
  },
  "LJ5550": {
    "series": "LJ55",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "suffix": ".BWZ",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "BR",
      "MX",
      "PE"
    ]
  },
  "LJ570B": {
    "series": "LJ57",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      32
    ],
    "regions": [
      "HK"
    ]
  },
  "LJ571D": {
    "series": "LJ57",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATV",
    "sizes": [
      32
    ],
    "regions": [
      "VN"
    ]
  },
  "LJ573D": {
    "series": "LJ57",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LJ590U": {
    "series": "LJ59",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AEKQ",
    "sizes": [
      32
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "LJ594U": {
    "series": "LJ59",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ADK",
    "sizes": [
      32
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "LJ594V": {
    "series": "LJ59",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "LJ595V": {
    "series": "LJ59",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "RU"
    ]
  },
  "LJ600B": {
    "series": "LJ60",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      32
    ],
    "regions": [
      "BR"
    ]
  },
  "LJ600U": {
    "series": "LJ60",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ADK",
    "sizes": [
      32
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "LJ6100": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      32
    ],
    "regions": [
      "HK"
    ]
  },
  "LJ610D": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      32
    ],
    "regions": [
      "AU",
      "NZ",
      "SG",
      "TH"
    ]
  },
  "LJ610V": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32,
      43,
      49
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK"
    ]
  },
  "LJ6130": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      43
    ],
    "regions": [
      "HK"
    ]
  },
  "LJ6140": {
    "series": "LJ61",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "PH"
    ]
  },
  "LJ614T": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATV",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "VN"
    ]
  },
  "LJ614V": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "NL",
      "PL",
      "SE",
      "UK"
    ]
  },
  "LJ615V": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      55
    ],
    "regions": [
      "AE",
      "AT",
      "CZ",
      "DE",
      "ES",
      "IT",
      "PL",
      "PT",
      "SA",
      "SE",
      "UK"
    ]
  },
  "LJ616D": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATA",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LJ617T": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "IN"
    ]
  },
  "LJ617V": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      49
    ],
    "regions": [
      "IN"
    ]
  },
  "LJ618U": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LJ619V": {
    "series": "LJ61",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      43
    ],
    "regions": [
      "IN"
    ]
  },
  "LJ622V": {
    "series": "LJ62",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".ADR",
    "sizes": [
      32,
      43,
      49,
      55
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "LJ624V": {
    "series": "LJ62",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "LJ625V": {
    "series": "LJ62",
    "broadcast": "dvb",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      55
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "IT",
      "PL",
      "PT",
      "UK"
    ]
  },
  "LJ6400": {
    "series": "LJ64",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "LJ6420": {
    "series": "LJ64",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "LJ6800": {
    "series": "LJ68",
    "broadcast": "atsc",
    "machine": "m2r",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17R_AFAAATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "LK5400BUA": {
    "series": "LK54",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".ACCQ",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CA"
    ]
  },
  "LK5400PLA": {
    "series": "LK54",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ADKB",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "LK5400PSA": {
    "series": "LK54",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".AWFQ",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "LK5400PTA": {
    "series": "LK54",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "LK5400PUA": {
    "series": "LK54",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".ACCQ",
    "sizes": [
      43
    ],
    "regions": [
      "CA"
    ]
  },
  "LK540BBUA": {
    "series": "LK54",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".ACCQ",
    "sizes": [
      32
    ],
    "regions": [
      "CA"
    ]
  },
  "LK540BPLA": {
    "series": "LK54",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ADKB",
    "sizes": [
      32
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "LK540BPSA": {
    "series": "LK54",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".AWFQ",
    "sizes": [
      32
    ],
    "regions": [
      "PE"
    ]
  },
  "LK540BPTA": {
    "series": "LK54",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".APH",
    "sizes": [
      32
    ],
    "regions": [
      "ID",
      "PH",
      "TH",
      "VN"
    ]
  },
  "LK540BPUA": {
    "series": "LK54",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".AWM",
    "sizes": [
      32
    ],
    "regions": [
      "MX",
      "US"
    ]
  },
  "LK5700PCA": {
    "series": "LK57",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      43
    ],
    "regions": [
      "HK"
    ]
  },
  "LK5700PDC": {
    "series": "LK57",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AWCD",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CO"
    ]
  },
  "LK5700PSC": {
    "series": "LK57",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".BWZ",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "LK5700PTA": {
    "series": "LK57",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ATV",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "SG",
      "TH",
      "VN"
    ]
  },
  "LK5700PUA": {
    "series": "LK57",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "US"
    ]
  },
  "LK5700PWA": {
    "series": "LK57",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".STTWLJK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "TW"
    ]
  },
  "LK571C": {
    "series": "LK57",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".BWZ",
    "sizes": [
      43
    ],
    "regions": [
      "BR"
    ]
  },
  "LK5730PVC": {
    "series": "LK57",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AMA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "LK5750PSA": {
    "series": "LK57",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".BWZ",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR"
    ]
  },
  "LK5760PTA": {
    "series": "LK57",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "IN",
      "SG"
    ]
  },
  "LK5900PLA": {
    "series": "LK59",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "PL",
      "PT",
      "RU",
      "TR",
      "UK"
    ]
  },
  "LK5910PLC": {
    "series": "LK59",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ADG",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "LK5990PLE": {
    "series": "LK59",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ARU",
    "sizes": [
      43
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "LK6000PLF": {
    "series": "LK60",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AMCB",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "LK6100PCA": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      43
    ],
    "regions": [
      "HK"
    ]
  },
  "LK6100PCB": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      32
    ],
    "regions": [
      "HK"
    ]
  },
  "LK6100PLA": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "RU"
    ]
  },
  "LK6100PLB": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32,
      43,
      49
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "LK610BBUA": {
    "series": "LK61",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "US"
    ]
  },
  "LK610BPLB": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "UK"
    ]
  },
  "LK610BPSA": {
    "series": "LK61",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      32
    ],
    "regions": [
      "BR"
    ]
  },
  "LK610BPTB": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      32
    ],
    "regions": [
      "AU",
      "NZ",
      "SG"
    ]
  },
  "LK610BPUA": {
    "series": "LK61",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "MX",
      "US"
    ]
  },
  "LK610BPVA": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AFFZ",
    "sizes": [
      32
    ],
    "regions": [
      "AE",
      "ZA"
    ]
  },
  "LK6120PTC": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "IN"
    ]
  },
  "LK615BPLB": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ADR",
    "sizes": [
      32
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "LK615BPSB": {
    "series": "LK61",
    "broadcast": "atsc",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      32
    ],
    "regions": [
      "BR"
    ]
  },
  "LK616BPTB": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LK6190PLA": {
    "series": "LK61",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ADR",
    "sizes": [
      32
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "LK6200PLA": {
    "series": "LK62",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "LK6200PLD": {
    "series": "LK62",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ADG",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "LK628BPTF": {
    "series": "LK62",
    "broadcast": "dvb",
    "machine": "m3",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LM5700PTC": {
    "series": "LM57",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".APH",
    "sizes": [
      43
    ],
    "regions": [
      "ID",
      "MY",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "LM5700PUA": {
    "series": "LM57",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      43
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "LM570BPTC": {
    "series": "LM57",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".ATI",
    "sizes": [
      32
    ],
    "regions": [
      "ID",
      "VN"
    ]
  },
  "LM570BPUA": {
    "series": "LM57",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "LM5760PTC": {
    "series": "LM57",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      43
    ],
    "regions": [
      "IN"
    ]
  },
  "LM576BPTC": {
    "series": "LM57",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LM577BPUA": {
    "series": "LM57",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "MX",
      "US"
    ]
  },
  "LM577BZUA": {
    "series": "LM57",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "US"
    ]
  },
  "LM620BPSA": {
    "series": "LM62",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      32
    ],
    "regions": [
      "BR"
    ]
  },
  "LM620BPUA": {
    "series": "LM62",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "LM625BPSB": {
    "series": "LM62",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      32
    ],
    "regions": [
      "BR"
    ]
  },
  "LM627BPUA": {
    "series": "LM62",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "US"
    ]
  },
  "LM6300PCB": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      32,
      43
    ],
    "regions": [
      "HK"
    ]
  },
  "LM6300PLA": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32,
      43
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "LM6300PSB": {
    "series": "LM63",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".BWZ",
    "sizes": [
      43
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "LM6300PTB": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".ANR",
    "sizes": [
      43
    ],
    "regions": [
      "AU",
      "NZ",
      "VN"
    ]
  },
  "LM6300PVB": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".AFFZ",
    "sizes": [
      43
    ],
    "regions": [
      "AE",
      "ZA"
    ]
  },
  "LM630BPLA": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      32
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "LM630BPSB": {
    "series": "LM63",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AWF",
    "sizes": [
      32
    ],
    "regions": [
      "PE"
    ]
  },
  "LM630BPTB": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".ANR",
    "sizes": [
      32
    ],
    "regions": [
      "AU",
      "ID",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "LM630BPUB": {
    "series": "LM63",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "suffix": ".AWM",
    "sizes": [
      32
    ],
    "regions": [
      "MX"
    ]
  },
  "LM630BPVB": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".AFFZ",
    "sizes": [
      32
    ],
    "regions": [
      "AE",
      "ZA"
    ]
  },
  "LM6350KNA": {
    "series": "LM63",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "sizes": [
      43
    ],
    "regions": [
      "KR"
    ]
  },
  "LM6350PLA": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".AMCB",
    "sizes": [
      32
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "LM635BENA": {
    "series": "LM63",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LM635BKNA": {
    "series": "LM63",
    "broadcast": "atsc",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LM6360PTB": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      32,
      43
    ],
    "regions": [
      "IN",
      "VN"
    ]
  },
  "LM636BPTB": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN",
      "SG",
      "VN"
    ]
  },
  "LM6390PLC": {
    "series": "LM63",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".ARU",
    "sizes": [
      32
    ],
    "regions": [
      "RU"
    ]
  },
  "LM6500PLB": {
    "series": "LM65",
    "broadcast": "dvb",
    "machine": "m3r",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19R_AFAAABAA",
    "suffix": ".ADGZ",
    "sizes": [
      43
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "LQ570B6LA": {
    "series": "LQ57",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AEU",
    "sizes": [
      32
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE"
    ]
  },
  "LQ570BPSA": {
    "series": "LQ57",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "ID",
      "IN",
      "PH"
    ]
  },
  "LQ573BPSA": {
    "series": "LQ57",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LQ576BPSA": {
    "series": "LQ57",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN",
      "VN"
    ]
  },
  "LQ60006LA": {
    "series": "LQ60",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AEKQ",
    "sizes": [
      43
    ],
    "regions": [
      "UK"
    ]
  },
  "LQ620BPSB": {
    "series": "LQ62",
    "broadcast": "isdb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AWZ",
    "sizes": [
      32
    ],
    "regions": [
      "BR"
    ]
  },
  "LQ63006LA": {
    "series": "LQ63",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AEK",
    "sizes": [
      32
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "RU",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "LQ630B6LA": {
    "series": "LQ63",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AEK",
    "sizes": [
      32
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "LQ630B6LB": {
    "series": "LQ63",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AMVE",
    "sizes": [
      32
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "LQ630BPSA": {
    "series": "LQ63",
    "broadcast": "isdb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AWF",
    "sizes": [
      32
    ],
    "regions": [
      "CO",
      "ID",
      "MX",
      "PE",
      "PH",
      "SG",
      "TH"
    ]
  },
  "LQ630BPUA": {
    "series": "LQ63",
    "broadcast": "atsc",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "LQ63506LA": {
    "series": "LQ63",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".ARU",
    "sizes": [
      32
    ],
    "regions": [
      "RU"
    ]
  },
  "LQ6350PCA": {
    "series": "LQ63",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AHKG",
    "sizes": [
      32
    ],
    "regions": [
      "HK"
    ]
  },
  "LQ635BCNA": {
    "series": "LQ63",
    "broadcast": "atsc",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LQ635BENA": {
    "series": "LQ63",
    "broadcast": "atsc",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LQ635BGNA": {
    "series": "LQ63",
    "broadcast": "atsc",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LQ635BKNA": {
    "series": "LQ63",
    "broadcast": "atsc",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LQ635BPSA": {
    "series": "LQ63",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LQ6360PSA": {
    "series": "LQ63",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LQ636BPSA": {
    "series": "LQ63",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN",
      "SG",
      "VN"
    ]
  },
  "LQ63806LC": {
    "series": "LQ63",
    "broadcast": "dvb",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAATAA",
    "suffix": ".AEK",
    "sizes": [
      32
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "LR56006LC": {
    "series": "LR56",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      43
    ],
    "regions": [
      "IN"
    ]
  },
  "LR570B6LA": {
    "series": "LR57",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LR573B6LA": {
    "series": "LR57",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LR576B6LA": {
    "series": "LR57",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LR595B6LA": {
    "series": "LR59",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LR650BPSA": {
    "series": "LR65",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".AAU",
    "sizes": [
      32
    ],
    "regions": [
      "AU",
      "BR",
      "CO",
      "ID",
      "MX",
      "NZ",
      "PE"
    ]
  },
  "LR655BPUA": {
    "series": "LR65",
    "broadcast": "atsc",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "LR656B6LA": {
    "series": "LR65",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LR656BPSA": {
    "series": "LR65",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LR6700PSA": {
    "series": "LR67",
    "broadcast": "isdb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".AWR",
    "sizes": [
      43
    ],
    "regions": [
      "BR",
      "MX"
    ]
  },
  "LR686B6LA": {
    "series": "LR68",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LR686BPSA": {
    "series": "LR68",
    "broadcast": "dvb",
    "machine": "kf23f",
    "codename": "number1",
    "otaId": "HE_DTV_W23L_AFAAATAA",
    "suffix": ".ATR",
    "sizes": [
      32
    ],
    "regions": [
      "IN"
    ]
  },
  "LX1Q3LA": {
    "series": "LX1Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55
    ],
    "regions": [
      "CZ",
      "HU",
      "IT",
      "PL"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX1Q6LA": {
    "series": "LX1Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "LX1Q9LA": {
    "series": "LX1Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55
    ],
    "regions": [
      "AT",
      "DE"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX1QKNA": {
    "series": "LX1Q",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      42,
      48,
      55
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX1QKNB": {
    "series": "LX1Q",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX1QKNC": {
    "series": "LX1Q",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX1QPCA": {
    "series": "LX1Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      42,
      48,
      55
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX1QPSA": {
    "series": "LX1Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      42,
      55
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "TW"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX1QPUA": {
    "series": "LX1Q",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "LX1T6LA": {
    "series": "LX1T",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55
    ],
    "regions": [
      "AE",
      "AT",
      "DE",
      "ES",
      "HU",
      "IT",
      "KZ",
      "RU",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".ARUB"
      }
    ]
  },
  "LX1TKNA": {
    "series": "LX1T",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "LX1TKNB": {
    "series": "LX1T",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "sizes": [
      42,
      48
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "LX1TPSA": {
    "series": "LX1T",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55
    ],
    "regions": [
      "AU",
      "NZ",
      "PH",
      "SG",
      "TH"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "broadcast": "isdb",
        "codename": "queue",
        "suffix": ".APH"
      }
    ]
  },
  "LX3Q3LA": {
    "series": "LX3Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42
    ],
    "regions": [
      "CZ",
      "HU",
      "IT",
      "PL"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "LX3Q6LA": {
    "series": "LX3Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "SA",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "LX3Q9LA": {
    "series": "LX3Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "IT",
      "PL"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX3QKNA": {
    "series": "LX3Q",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      42
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX3QPCA": {
    "series": "LX3Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AHK",
    "sizes": [
      42
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX3QPJA": {
    "series": "LX3Q",
    "broadcast": "arib",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      42
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "LX3QPSA": {
    "series": "LX3Q",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      42
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "MX",
      "MY",
      "NZ",
      "PE",
      "SG",
      "TW"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX3QPUA": {
    "series": "LX3Q",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      42
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "LX5QKNA": {
    "series": "LX5Q",
    "broadcast": "atsc",
    "machine": "k8hpt",
    "codename": "mullet",
    "otaId": "HE_DTV_N22D_AFAAATAA",
    "sizes": [
      27
    ],
    "regions": [
      "KR",
      "UK",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "LX5QMNA": {
    "series": "LX5Q",
    "broadcast": "atsc",
    "machine": "k8hpt",
    "codename": "mullet",
    "otaId": "HE_DTV_N22D_AFAAATAA",
    "sizes": [
      27
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "LX6900PJA": {
    "series": "LX69",
    "broadcast": "arib",
    "machine": "k6lpfhd",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20L_AFAAJAAA",
    "suffix": ".AJL",
    "sizes": [
      32
    ],
    "regions": [
      "JP"
    ]
  },
  "LX6BDGA": {
    "series": "LX6B",
    "broadcast": "dvb",
    "machine": "k26t",
    "codename": "queue",
    "otaId": "HE_DTV_N26D_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      32
    ],
    "regions": [
      "NZ"
    ]
  },
  "LX6BEGA": {
    "series": "LX6B",
    "broadcast": "atsc",
    "machine": "k26t",
    "codename": "queue",
    "otaId": "HE_DTV_N26D_AFADATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LX6BEGB": {
    "series": "LX6B",
    "broadcast": "atsc",
    "machine": "k26t",
    "codename": "queue",
    "otaId": "HE_DTV_N26D_AFADATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LX6BKGA": {
    "series": "LX6B",
    "broadcast": "atsc",
    "machine": "k26t",
    "codename": "queue",
    "otaId": "HE_DTV_N26D_AFADATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR"
    ]
  },
  "LX6BPGA": {
    "series": "LX6B",
    "broadcast": "atsc",
    "machine": "k26t",
    "codename": "queue",
    "otaId": "HE_DTV_N26D_AFADATAA",
    "sizes": [
      32
    ],
    "regions": [
      "KR",
      "SA"
    ]
  },
  "LX6BWGA": {
    "series": "LX6B",
    "broadcast": "atsc",
    "machine": "k26t",
    "codename": "queue",
    "otaId": "HE_DTV_N26D_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      32
    ],
    "regions": [
      "CA",
      "JP",
      "US"
    ]
  },
  "LX7000PJB": {
    "series": "LX70",
    "broadcast": "arib",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAJAAA",
    "suffix": ".AJLG",
    "sizes": [
      32
    ],
    "regions": [
      "JP"
    ]
  },
  "LX8000PJB": {
    "series": "LX80",
    "broadcast": "arib",
    "machine": "k8ap",
    "codename": "mullet",
    "otaId": "HE_DTV_W22L_AFAAJAAA",
    "suffix": ".AJLG",
    "sizes": [
      32
    ],
    "regions": [
      "JP"
    ]
  },
  "MRGB85BCA": {
    "series": "MRGB85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HK"
    ]
  },
  "MRGB85BSC": {
    "series": "MRGB85",
    "broadcast": "isdb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AWR",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "MRGB86B6A": {
    "series": "MRGB86",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "CZ",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "MRGB86B9A": {
    "series": "MRGB86",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "NL"
    ]
  },
  "MRGB86BJA": {
    "series": "MRGB86",
    "broadcast": "arib",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "JP"
    ]
  },
  "MRGB86BKA": {
    "series": "MRGB86",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "MRGB86BSA": {
    "series": "MRGB86",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ATI",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "ID",
      "MX",
      "MY",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "MRGB87B3B": {
    "series": "MRGB87",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HU"
    ]
  },
  "MRGB87B6B": {
    "series": "MRGB87",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "ES",
      "FR",
      "IT",
      "PL",
      "SE",
      "TR"
    ]
  },
  "MRGB87B9B": {
    "series": "MRGB87",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "NL"
    ]
  },
  "MRGB88B6B": {
    "series": "MRGB88",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "ES",
      "FR",
      "IT",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "MRGB88B9B": {
    "series": "MRGB88",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "NL"
    ]
  },
  "MRGB95BCA": {
    "series": "MRGB95",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "MRGB95BSA": {
    "series": "MRGB95",
    "broadcast": "isdb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AWC",
    "sizes": [
      86
    ],
    "regions": [
      "CL",
      "CO",
      "MX"
    ]
  },
  "MRGB95BU": {
    "series": "MRGB95",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      100
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "MRGB95BUA": {
    "series": "MRGB95",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "MRGB96B3": {
    "series": "MRGB96",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      100
    ],
    "regions": [
      "HU"
    ]
  },
  "MRGB96B6": {
    "series": "MRGB96",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      100
    ],
    "regions": [
      "AU",
      "CZ",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NZ",
      "PL",
      "PT",
      "RU",
      "TR",
      "UK"
    ]
  },
  "MRGB96B6B": {
    "series": "MRGB96",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "CZ",
      "ES",
      "FR",
      "IT",
      "PL",
      "PT",
      "RU",
      "TR",
      "UK"
    ]
  },
  "MRGB96B9": {
    "series": "MRGB96",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      100
    ],
    "regions": [
      "AT",
      "DE",
      "NL"
    ]
  },
  "MRGB96B9B": {
    "series": "MRGB96",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "NL",
      "PL"
    ]
  },
  "MRGB96BC": {
    "series": "MRGB96",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      100
    ],
    "regions": [
      "HK"
    ]
  },
  "MRGB96BKA": {
    "series": "MRGB96",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "MRGB96BS": {
    "series": "MRGB96",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      100
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "MRGB96BSA": {
    "series": "MRGB96",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "MRGB9MB9B": {
    "series": "MRGB9M",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "ES",
      "IT"
    ]
  },
  "MRGB9MBKA": {
    "series": "MRGB9M",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "NA1C80ANA": {
    "series": "NA1C",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      55,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NA1C90AKA": {
    "series": "NA1C",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "NA1C90AMA": {
    "series": "NA1C",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO73SQA": {
    "series": "NANO73",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "NANO73TPZ": {
    "series": "NANO73",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "NANO753PA": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL",
      "PT"
    ]
  },
  "NANO753PR": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO753QC": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "HU"
    ]
  },
  "NANO756PA": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO756PR": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "NANO756QA": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "KZ",
      "NZ",
      "PT",
      "RU"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ],
        "regions": [
          "DE",
          "KZ",
          "NL",
          "RU"
        ]
      }
    ]
  },
  "NANO756QC": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT"
    ]
  },
  "NANO759PA": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "HU",
      "PT"
    ]
  },
  "NANO759PR": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "NANO75EPA": {
    "series": "NANO75",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO75JPA": {
    "series": "NANO75",
    "broadcast": "arib",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO75KPA": {
    "series": "NANO75",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA"
      }
    ]
  },
  "NANO75KQA": {
    "series": "NANO75",
    "broadcast": "atsc",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO75MPA": {
    "series": "NANO75",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO75SPA": {
    "series": "NANO75",
    "broadcast": "isdb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".BWZ",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE",
      "PH"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "suffix": ".AWZ",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO75SQA": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO75TPA": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO75TPZ": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "IN"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "suffix": ".ATRG",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO75UPA": {
    "series": "NANO75",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO75UQA": {
    "series": "NANO75",
    "broadcast": "atsc",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".ACC",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".ACC",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO75VPA": {
    "series": "NANO75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO763QA": {
    "series": "NANO76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO766PA": {
    "series": "NANO76",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ADKB",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "NANO766QA": {
    "series": "NANO76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO769QA": {
    "series": "NANO76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEUD",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "KZ",
      "PL",
      "RU",
      "UK"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".AEU",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".AEU",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO76CPA": {
    "series": "NANO76",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "NANO76CQA": {
    "series": "NANO76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "NANO76JPA": {
    "series": "NANO76",
    "broadcast": "arib",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO76SQA": {
    "series": "NANO76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".UTTFLJK",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "TW",
      "VN"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".ATV",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO773PA": {
    "series": "NANO77",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "NANO776PA": {
    "series": "NANO77",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE"
    ]
  },
  "NANO776QA": {
    "series": "NANO77",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "NANO776RA": {
    "series": "NANO77",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AMVG",
    "sizes": [
      50,
      86
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "lm21ann",
        "otaId": "HE_DTV_W23A_AFADATAA",
        "suffix": ".AFFE",
        "sizes": [
          55,
          65,
          75
        ]
      },
      {
        "machine": "lm21ann",
        "codename": "ombre",
        "otaId": "HE_DTV_W23A_AFADATAA",
        "suffix": ".AFFE",
        "sizes": [
          55,
          65,
          75
        ],
        "swMajor": "23"
      },
      {
        "machine": "lm21ann",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23A_AFADATAA",
        "suffix": ".AFFE",
        "sizes": [
          55,
          65,
          75
        ],
        "swMajor": "33"
      }
    ]
  },
  "NANO779PA": {
    "series": "NANO77",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "NANO77CQA": {
    "series": "NANO77",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "NANO77SRA": {
    "series": "NANO77",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "IN",
      "MX",
      "PE",
      "PH",
      "TW"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "broadcast": "isdb",
        "machine": "k8hpp",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "suffix": ".AWF",
        "sizes": [
          86
        ]
      },
      {
        "broadcast": "isdb",
        "machine": "k8hpp",
        "codename": "ombre",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "suffix": ".AWF",
        "sizes": [
          86
        ],
        "swMajor": "23"
      },
      {
        "broadcast": "isdb",
        "machine": "k8hpp",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "suffix": ".AWF",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "NANO77TPA": {
    "series": "NANO77",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ",
      "TH",
      "VN"
    ]
  },
  "NANO783QA": {
    "series": "NANO78",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO786QA": {
    "series": "NANO78",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ADRB",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "BE",
      "ES",
      "FR",
      "IT",
      "NL",
      "RU",
      "SE"
    ]
  },
  "NANO789QA": {
    "series": "NANO78",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "NANO78TNG": {
    "series": "NANO78",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATV",
    "sizes": [
      43
    ],
    "regions": [
      "VN"
    ]
  },
  "NANO793PB": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO796NE": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO796NF": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO796PB": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "ES",
      "IT",
      "SE"
    ]
  },
  "NANO796QA": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AMAE",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".AFFG",
        "sizes": [
          86
        ]
      }
    ]
  },
  "NANO79CNF": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "NANO79CRA": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      50,
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "NANO79DNA": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "NANO79KNH": {
    "series": "NANO79",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO79SNA": {
    "series": "NANO79",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "NANO79SND": {
    "series": "NANO79",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50,
      55
    ],
    "regions": [
      "BR"
    ]
  },
  "NANO79TND": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "NANO79UNA": {
    "series": "NANO79",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "NANO79VND": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AFB",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "NANO79VNE": {
    "series": "NANO79",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AFB",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "ZA"
    ]
  },
  "NANO803NA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO803PA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL",
      "PT"
    ]
  },
  "NANO806NA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "IT",
      "NL",
      "PL",
      "RU",
      "SE"
    ]
  },
  "NANO806PA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "NANO806QA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ADGG",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "AU",
      "KZ",
      "NZ",
      "RU"
    ]
  },
  "NANO809PA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "HU",
      "PT"
    ]
  },
  "NANO80A3B": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HU"
    ]
  },
  "NANO80A6A": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "NANO80A6B": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NZ",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO80ACA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "NANO80AEA": {
    "series": "NANO80",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO80AJA": {
    "series": "NANO80",
    "broadcast": "arib",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO80ANA": {
    "series": "NANO80",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      43,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO80AQA": {
    "series": "NANO80",
    "broadcast": "atsc",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "NANO80ASA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "NANO80AUA": {
    "series": "NANO80",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA"
    ],
    "variants": [
      {
        "machine": "o22n3",
        "otaId": "HE_DTV_W25G_AFABATAA"
      }
    ]
  },
  "NANO80PNA": {
    "series": "NANO80",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "NANO80SPA": {
    "series": "NANO80",
    "broadcast": "isdb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE",
      "PH"
    ]
  },
  "NANO80SQA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "MY",
      "PE",
      "TH",
      "VN"
    ]
  },
  "NANO80T6A": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".ARUB",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "ID",
      "IN",
      "KZ",
      "RU",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k24",
        "otaId": "HE_DTV_W24H_AFADATAA"
      },
      {
        "machine": "k24",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "swMajor": "33"
      }
    ]
  },
  "NANO80TCA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "NANO80TNA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "NZ",
      "SG",
      "TH"
    ]
  },
  "NANO80TPA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATC",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "ID",
      "MY",
      "SG",
      "TH",
      "VN"
    ]
  },
  "NANO80TPZ": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "NANO80TSA": {
    "series": "NANO80",
    "broadcast": "isdb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k24",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k24",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "NANO80UNA": {
    "series": "NANO80",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "NANO80UPA": {
    "series": "NANO80",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "NANO80VNA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "NANO80VPA": {
    "series": "NANO80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AU",
      "IN",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "NANO813NA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "IT",
      "PL"
    ]
  },
  "NANO813PA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "PT"
    ]
  },
  "NANO813QA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO816NA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO816PA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO816QA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AU",
      "ES",
      "FR",
      "NZ",
      "PL",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO819PA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "HU",
      "PT"
    ]
  },
  "NANO819QA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "NANO81A3A": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HU"
    ]
  },
  "NANO81A6A": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "NANO81ANA": {
    "series": "NANO81",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      49,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "NANO81SNA": {
    "series": "NANO81",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "NANO81T3A": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      55,
      75,
      86
    ],
    "regions": [
      "PL"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k8lpn2",
        "otaId": "HE_DTV_W24P_AFADATAA",
        "sizes": [
          50,
          65
        ],
        "regions": [
          "HU"
        ]
      },
      {
        "machine": "k8lpn2",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24P_AFADATAA",
        "sizes": [
          50,
          65
        ],
        "regions": [
          "HU"
        ],
        "swMajor": "33"
      }
    ]
  },
  "NANO81T6A": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "ID",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      },
      {
        "machine": "k24",
        "otaId": "HE_DTV_W24H_AFADATAA"
      },
      {
        "machine": "k24",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "swMajor": "33"
      }
    ]
  },
  "NANO81TKA": {
    "series": "NANO81",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k24",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k24",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "NANO81TNA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATS",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "MY",
      "VN"
    ]
  },
  "NANO81TSA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k24",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k24",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "NANO81TTA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "NANO81UNA": {
    "series": "NANO81",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "NANO81WNA": {
    "series": "NANO81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATT",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "NANO823QB": {
    "series": "NANO82",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO826QB": {
    "series": "NANO82",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ADRB",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "BE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE"
    ]
  },
  "NANO829QB": {
    "series": "NANO82",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "RU"
    ]
  },
  "NANO82A6B": {
    "series": "NANO82",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HU",
      "SE"
    ]
  },
  "NANO82T3B": {
    "series": "NANO82",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "NANO82T6B": {
    "series": "NANO82",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "NANO83ASB": {
    "series": "NANO83",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "NANO83KPA": {
    "series": "NANO83",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO83KQA": {
    "series": "NANO83",
    "broadcast": "atsc",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO83TPZ": {
    "series": "NANO83",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "NANO846QA": {
    "series": "NANO84",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "SA",
      "TR"
    ]
  },
  "NANO853PA": {
    "series": "NANO85",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "PT"
    ]
  },
  "NANO856PA": {
    "series": "NANO85",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "ES",
      "HU",
      "IT",
      "PT",
      "RU",
      "SE"
    ]
  },
  "NANO85APA": {
    "series": "NANO85",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "NANO85JPA": {
    "series": "NANO85",
    "broadcast": "arib",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      50
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO85SPA": {
    "series": "NANO85",
    "broadcast": "isdb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "NANO85TNA": {
    "series": "NANO85",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      75
    ],
    "regions": [
      "AU",
      "NZ",
      "VN"
    ]
  },
  "NANO85UNA": {
    "series": "NANO85",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      49,
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "NANO85VNA": {
    "series": "NANO85",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      75
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "NANO85VPA": {
    "series": "NANO85",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "NANO863NA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO863PA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL",
      "PT"
    ]
  },
  "NANO866NA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO866PA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO867NA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "NANO869PA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "HU",
      "PT"
    ]
  },
  "NANO86CNA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "NANO86CPA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      50,
      55,
      65,
      86
    ],
    "regions": [
      "HK"
    ]
  },
  "NANO86DNA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "NANO86JNA": {
    "series": "NANO86",
    "broadcast": "arib",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      49
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO86SNA": {
    "series": "NANO86",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "NANO86SPA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".UTTYLJK",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "TW"
    ]
  },
  "NANO86TNA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "NANO86TPA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "NANO86TPZ": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "NANO86UNA": {
    "series": "NANO86",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "CA",
      "MX"
    ]
  },
  "NANO86VNA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "NANO86VPA": {
    "series": "NANO86",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "NANO87KNB": {
    "series": "NANO87",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO883PB": {
    "series": "NANO88",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "PT"
    ]
  },
  "NANO886PB": {
    "series": "NANO88",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "BE",
      "CZ",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "NANO889PB": {
    "series": "NANO88",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "HU",
      "PL",
      "PT"
    ]
  },
  "NANO893PC": {
    "series": "NANO89",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO896PC": {
    "series": "NANO89",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "ES",
      "RU",
      "SE"
    ]
  },
  "NANO8EA6A": {
    "series": "NANO8E",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "SE"
    ]
  },
  "NANO903NA": {
    "series": "NANO90",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO906NA": {
    "series": "NANO90",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO906PB": {
    "series": "NANO90",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "RU"
    ]
  },
  "NANO90A3B": {
    "series": "NANO90",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "HU"
    ]
  },
  "NANO90A6B": {
    "series": "NANO90",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "FR",
      "KZ",
      "RU",
      "TR",
      "UK"
    ]
  },
  "NANO90ABA": {
    "series": "NANO90",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO90AKA": {
    "series": "NANO90",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO90JPA": {
    "series": "NANO90",
    "broadcast": "arib",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO90SNA": {
    "series": "NANO90",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "NANO90SPA": {
    "series": "NANO90",
    "broadcast": "isdb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "NANO90UNA": {
    "series": "NANO90",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "NANO90UPA": {
    "series": "NANO90",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "NANO90VNA": {
    "series": "NANO90",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "NANO90VPA": {
    "series": "NANO90",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AMAG",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "NANO913NA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO913PA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "PT"
    ]
  },
  "NANO916NA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO916PA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO917NA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "NANO919PA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "HU",
      "PT"
    ]
  },
  "NANO91ANA": {
    "series": "NANO91",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      86
    ],
    "regions": [
      "US"
    ]
  },
  "NANO91CNA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      86
    ],
    "regions": [
      "HK"
    ]
  },
  "NANO91JNA": {
    "series": "NANO91",
    "broadcast": "arib",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO91PNA": {
    "series": "NANO91",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      55
    ],
    "regions": [
      "PH"
    ]
  },
  "NANO91SPA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".UTTFLJK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "TW"
    ]
  },
  "NANO91TNA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "NANO91TPA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "IN",
      "NZ",
      "TH"
    ]
  },
  "NANO91TPZ": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "IN"
    ]
  },
  "NANO91VNA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "NANO91VPA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "NANO91WNA": {
    "series": "NANO91",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".ATT",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "TW"
    ]
  },
  "NANO923PB": {
    "series": "NANO92",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "PT"
    ]
  },
  "NANO926PB": {
    "series": "NANO92",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ADKB",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "ES",
      "FR",
      "HU",
      "KZ",
      "PT",
      "RU",
      "SE"
    ]
  },
  "NANO93KNB": {
    "series": "NANO93",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO93KPA": {
    "series": "NANO93",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO953NA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "e60",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20E_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55
    ],
    "regions": [
      "CZ"
    ],
    "variants": [
      {
        "machine": "o208k",
        "otaId": "HE_DTV_W20K_AFADABAA",
        "sizes": [
          65
        ],
        "regions": [
          "HU",
          "PL"
        ]
      }
    ]
  },
  "NANO956NA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "e60",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20E_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55
    ],
    "regions": [
      "ES",
      "SE",
      "TR"
    ],
    "variants": [
      {
        "machine": "o208k",
        "otaId": "HE_DTV_W20K_AFADABAA",
        "sizes": [
          65
        ],
        "regions": [
          "AT",
          "BE",
          "DE",
          "FR",
          "IT",
          "KZ",
          "NL",
          "PT",
          "RU",
          "UK"
        ]
      }
    ]
  },
  "NANO956PA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "NANO959NA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "e60",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20E_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55
    ],
    "regions": [],
    "variants": [
      {
        "machine": "o208k",
        "otaId": "HE_DTV_W20K_AFADABAA",
        "sizes": [
          65
        ],
        "regions": [
          "AT",
          "DE"
        ]
      }
    ]
  },
  "NANO95CNA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "e60",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20E_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      55
    ],
    "regions": [],
    "variants": [
      {
        "machine": "o208k",
        "otaId": "HE_DTV_W20K_AFADABAA",
        "sizes": [
          65,
          75
        ],
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "NANO95DNA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      75
    ],
    "regions": [
      "CO"
    ]
  },
  "NANO95JNA": {
    "series": "NANO95",
    "broadcast": "arib",
    "machine": "e60",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20E_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      55
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO95SNA": {
    "series": "NANO95",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      75
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ],
    "variants": [
      {
        "machine": "e60",
        "otaId": "HE_DTV_W20E_AFADATAA",
        "suffix": ".AWF"
      }
    ]
  },
  "NANO95SPA": {
    "series": "NANO95",
    "broadcast": "isdb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "MX",
      "PE",
      "PH"
    ]
  },
  "NANO95TNA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "e60",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20E_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55
    ],
    "regions": [
      "IN"
    ],
    "variants": [
      {
        "machine": "o208k",
        "otaId": "HE_DTV_W20K_AFADABAA",
        "sizes": [
          65,
          75
        ],
        "regions": [
          "AU",
          "ID",
          "MY",
          "NZ",
          "SG",
          "TH",
          "VN"
        ]
      }
    ]
  },
  "NANO95TPA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AU",
      "MY",
      "NZ",
      "VN"
    ]
  },
  "NANO95UNA": {
    "series": "NANO95",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "CA",
      "MX"
    ]
  },
  "NANO95VNA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ"
    ]
  },
  "NANO95VPA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA"
    ]
  },
  "NANO95WNA": {
    "series": "NANO95",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".ATT",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "TW"
    ]
  },
  "NANO963PA": {
    "series": "NANO96",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO966PA": {
    "series": "NANO96",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "NANO969PA": {
    "series": "NANO96",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AVS",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "UK"
    ]
  },
  "NANO96DNA": {
    "series": "NANO96",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "NANO96JPA": {
    "series": "NANO96",
    "broadcast": "arib",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO96SNA": {
    "series": "NANO96",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "NANO976NA": {
    "series": "NANO97",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      75
    ],
    "regions": [
      "RU"
    ]
  },
  "NANO979NA": {
    "series": "NANO97",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "NANO97KNB": {
    "series": "NANO97",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO97KPA": {
    "series": "NANO97",
    "broadcast": "atsc",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO97UNA": {
    "series": "NANO97",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "NANO97VNA": {
    "series": "NANO97",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AMI",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "NANO98PNA": {
    "series": "NANO98",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      75
    ],
    "regions": [
      "PH"
    ]
  },
  "NANO993NA": {
    "series": "NANO99",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "NANO996NA": {
    "series": "NANO99",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NANO996PB": {
    "series": "NANO99",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      86
    ],
    "regions": [
      "RU"
    ]
  },
  "NANO999NA": {
    "series": "NANO99",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "NANO99JNA": {
    "series": "NANO99",
    "broadcast": "arib",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "JP"
    ]
  },
  "NANO99KNB": {
    "series": "NANO99",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO99KPA": {
    "series": "NANO99",
    "broadcast": "atsc",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NANO99TNA": {
    "series": "NANO99",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH"
    ]
  },
  "NANO99TPZ": {
    "series": "NANO99",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "NANO99UNA": {
    "series": "NANO99",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "NANO99UPA": {
    "series": "NANO99",
    "broadcast": "atsc",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "NU700BPUA": {
    "series": "NU70",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "NU710BAUA": {
    "series": "NU71",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "US"
    ]
  },
  "NU810BENA": {
    "series": "NU81",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NU830BPSA": {
    "series": "NU83",
    "broadcast": "isdb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CO",
      "MX",
      "PE"
    ]
  },
  "NU835BPSA": {
    "series": "NU83",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".ATI",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "ID",
      "PH",
      "TH",
      "VN"
    ]
  },
  "NU840B6LA": {
    "series": "NU84",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "NU845BPSB": {
    "series": "NU84",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".ATI",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "ID",
      "MY"
    ]
  },
  "NU850B3LA": {
    "series": "NU85",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "HU"
    ]
  },
  "NU850B6LA": {
    "series": "NU85",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "NU850B6LB": {
    "series": "NU85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AFAQ",
    "sizes": [
      98
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "NU850BAUA": {
    "series": "NU85",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "NU850BENA": {
    "series": "NU85",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NU850BGNA": {
    "series": "NU85",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "NU850BPJA": {
    "series": "NU85",
    "broadcast": "arib",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "otaId": "HE_DTV_W26N_AFADATAA"
      }
    ]
  },
  "NU850BPSA": {
    "series": "NU85",
    "broadcast": "isdb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AWR",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "BR",
      "CO",
      "ID",
      "MX"
    ]
  },
  "NU850BPUA": {
    "series": "NU85",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "k25lpn",
        "otaId": "HE_DTV_W26P_AFADATAA"
      }
    ]
  },
  "NU850BXNA": {
    "series": "NU85",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "sizes": [
      50,
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "NU851BPJA": {
    "series": "NU85",
    "broadcast": "arib",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "otaId": "HE_DTV_W26N_AFADATAA"
      }
    ]
  },
  "NU851BPSG": {
    "series": "NU85",
    "broadcast": "isdb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AWC",
    "sizes": [
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CO",
      "MX"
    ]
  },
  "NU855BPCA": {
    "series": "NU85",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "NU855BPSA": {
    "series": "NU85",
    "broadcast": "isdb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "NU855BPSB": {
    "series": "NU85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AAUQ",
    "sizes": [
      98
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "ID",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "NU855BPTA": {
    "series": "NU85",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65,
      85
    ],
    "regions": [
      "TW"
    ]
  },
  "NU860BYUA": {
    "series": "NU86",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CA"
    ]
  },
  "NU870BAUA": {
    "series": "NU87",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      85
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "NU875BPSC": {
    "series": "NU87",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".ATV",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "PH",
      "VN"
    ]
  },
  "NU885BPSB": {
    "series": "NU88",
    "broadcast": "isdb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "PH"
    ]
  },
  "NU8E0B3LA": {
    "series": "NU8E",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "SE",
      "TR",
      "UK"
    ]
  },
  "NU8E0B6LA": {
    "series": "NU8E",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AFBE",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "SA",
      "ZA"
    ]
  },
  "NU8E0BPCA": {
    "series": "NU8E",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "NU900B3LA": {
    "series": "NU90",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      65
    ],
    "regions": [
      "HU"
    ]
  },
  "NU900B6LA": {
    "series": "NU90",
    "broadcast": "dvb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDA13LA": {
    "series": "OLEDA1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "BE",
      "CZ",
      "ES",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE"
    ]
  },
  "OLEDA16LA": {
    "series": "OLEDA1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDA19LA": {
    "series": "OLEDA1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "HU",
      "NL",
      "PT"
    ]
  },
  "OLEDA1AUA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDA1ENA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDA1HNA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDA1JNA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDA1KNA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      48
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDA1MNA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDA1NNA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDA1PCA": {
    "series": "OLEDA1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDA1PJA": {
    "series": "OLEDA1",
    "broadcast": "arib",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      48,
      55,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDA1PSA": {
    "series": "OLEDA1",
    "broadcast": "isdb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE",
      "PH",
      "TW"
    ]
  },
  "OLEDA1PTA": {
    "series": "OLEDA1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDA1PTZ": {
    "series": "OLEDA1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "OLEDA1PUA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDA1PVA": {
    "series": "OLEDA1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDA1RLA": {
    "series": "OLEDA1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ADKB",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "OLEDA1SNA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDA1UNA": {
    "series": "OLEDA1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDA23LA": {
    "series": "OLEDA2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "BE",
      "CZ",
      "ES",
      "HU",
      "NL",
      "PL"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA26LA": {
    "series": "OLEDA2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "suffix": ".AEU",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA29LA": {
    "series": "OLEDA2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "IT",
      "NL"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA2ENA": {
    "series": "OLEDA2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA2HNA": {
    "series": "OLEDA2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA2KNA": {
    "series": "OLEDA2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA2MNA": {
    "series": "OLEDA2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA2NNA": {
    "series": "OLEDA2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA2PCA": {
    "series": "OLEDA2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA2PJA": {
    "series": "OLEDA2",
    "broadcast": "arib",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDA2PSA": {
    "series": "OLEDA2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "IN",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA2PUA": {
    "series": "OLEDA2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA2RLA": {
    "series": "OLEDA2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".ADGG",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA3ENA": {
    "series": "OLEDA3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA3HNA": {
    "series": "OLEDA3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA3KNA": {
    "series": "OLEDA3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      48,
      55,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA3MNA": {
    "series": "OLEDA3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA3PCA": {
    "series": "OLEDA3",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA3PJA": {
    "series": "OLEDA3",
    "broadcast": "arib",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA3PSA": {
    "series": "OLEDA3",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "IN",
      "MX",
      "MY",
      "PH",
      "SG",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA3RLA": {
    "series": "OLEDA3",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "KZ"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDA3SNA": {
    "series": "OLEDA3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "ID",
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB13LA": {
    "series": "OLEDB1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL",
      "PT",
      "SE"
    ]
  },
  "OLEDB16LA": {
    "series": "OLEDB1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "BE",
      "CZ",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDB19LA": {
    "series": "OLEDB1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "HU",
      "NL",
      "PT"
    ]
  },
  "OLEDB1FNA": {
    "series": "OLEDB1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB1KNA": {
    "series": "OLEDB1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "IN",
      "KR"
    ]
  },
  "OLEDB1PJA": {
    "series": "OLEDB1",
    "broadcast": "arib",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDB1PTA": {
    "series": "OLEDB1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDB1PTZ": {
    "series": "OLEDB1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "OLEDB1PUA": {
    "series": "OLEDB1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      77
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDB1PVA": {
    "series": "OLEDB1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AU",
      "NZ"
    ]
  },
  "OLEDB1QNA": {
    "series": "OLEDB1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB1RLA": {
    "series": "OLEDB1",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".ADKB",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "OLEDB1VNA": {
    "series": "OLEDB1",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB23LA": {
    "series": "OLEDB2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB26LA": {
    "series": "OLEDB2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "suffix": ".AEU",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB29LA": {
    "series": "OLEDB2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "IT"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2AUA": {
    "series": "OLEDB2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2ENA": {
    "series": "OLEDB2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2FNA": {
    "series": "OLEDB2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2KNA": {
    "series": "OLEDB2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2PCA": {
    "series": "OLEDB2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2PJA": {
    "series": "OLEDB2",
    "broadcast": "arib",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDB2PSA": {
    "series": "OLEDB2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "NZ",
      "PE",
      "SG",
      "TH"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2PUA": {
    "series": "OLEDB2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2QNA": {
    "series": "OLEDB2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2RLA": {
    "series": "OLEDB2",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".ADKB",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB2VNA": {
    "series": "OLEDB2",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB33LA": {
    "series": "OLEDB3",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "SE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB36LA": {
    "series": "OLEDB3",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PT",
      "SA",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB39LA": {
    "series": "OLEDB3",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3AUA": {
    "series": "OLEDB3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      77
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3FNA": {
    "series": "OLEDB3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3NNA": {
    "series": "OLEDB3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3PCA": {
    "series": "OLEDB3",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3PJA": {
    "series": "OLEDB3",
    "broadcast": "arib",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3PSA": {
    "series": "OLEDB3",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "IN",
      "MX",
      "MY",
      "NZ",
      "PE",
      "SG",
      "TH"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3PUA": {
    "series": "OLEDB3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3RLA": {
    "series": "OLEDB3",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3SNA": {
    "series": "OLEDB3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB3XNA": {
    "series": "OLEDB3",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB42LA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "NL",
      "PL",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB43LA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "03"
      }
    ]
  },
  "OLEDB46LA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AU",
      "BE",
      "CZ",
      "ES",
      "FR",
      "IN",
      "IT",
      "NL",
      "NZ",
      "PL",
      "PT",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "o22n2",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24G_AFABATAA",
        "sizes": [
          83
        ],
        "swMajor": "33"
      }
    ]
  },
  "OLEDB49LA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "IT"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "03"
      },
      {
        "machine": "o22n2",
        "otaId": "HE_DTV_W24G_AFABATAA",
        "sizes": [
          83
        ],
        "regions": [
          "AT",
          "DE",
          "PL"
        ]
      }
    ]
  },
  "OLEDB4AUA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "o22n2",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24G_AFABATAA",
        "sizes": [
          83
        ],
        "swMajor": "33"
      },
      {
        "machine": "o22n2",
        "codename": "queue",
        "otaId": "HE_DTV_W24G_AFABATAA",
        "sizes": [
          83
        ]
      }
    ]
  },
  "OLEDB4ECA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDB4EJA": {
    "series": "OLEDB4",
    "broadcast": "arib",
    "machine": "k24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDB4ELA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "suffix": ".AEU",
        "swMajor": "03"
      }
    ]
  },
  "OLEDB4ENA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4FNA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4HNA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4KNA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      48,
      55,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4MNA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4NNA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4PCA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "o22n2",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24G_AFABATAA",
        "sizes": [
          83
        ],
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4PJA": {
    "series": "OLEDB4",
    "broadcast": "arib",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4PSA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "broadcast": "isdb",
        "machine": "o22n2",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24G_AFABATAA",
        "suffix": ".AWH",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4PTA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4PUA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "o22n2",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24G_AFABATAA",
        "sizes": [
          83
        ],
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4RLA": {
    "series": "OLEDB4",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".ARUB",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4SNA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB4XNA": {
    "series": "OLEDB4",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDB53LA": {
    "series": "OLEDB5",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "ES",
      "HU",
      "PL"
    ]
  },
  "OLEDB56LA": {
    "series": "OLEDB5",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AU",
      "BE",
      "CZ",
      "ES",
      "FR",
      "HU",
      "IN",
      "IT",
      "NL",
      "NZ",
      "PL",
      "PT",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "OLEDB59LA": {
    "series": "OLEDB5",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "DE",
      "HU"
    ]
  },
  "OLEDB5AUA": {
    "series": "OLEDB5",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      83
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDB5BNA": {
    "series": "OLEDB5",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB5FNA": {
    "series": "OLEDB5",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB5HNA": {
    "series": "OLEDB5",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB5KNA": {
    "series": "OLEDB5",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      48,
      55,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB5NNA": {
    "series": "OLEDB5",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB5PCA": {
    "series": "OLEDB5",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDB5PJA": {
    "series": "OLEDB5",
    "broadcast": "arib",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDB5PSA": {
    "series": "OLEDB5",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDB5PUA": {
    "series": "OLEDB5",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDB5RLA": {
    "series": "OLEDB5",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".ARUG",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "OLEDB5SNA": {
    "series": "OLEDB5",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB62LA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "HU"
    ]
  },
  "OLEDB65LA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CZ",
      "ES",
      "FR",
      "IT",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDB66LA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AFBE",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDB68LA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ]
  },
  "OLEDB6AUA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      77,
      83
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDB6BNA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB6D": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "OLEDB6ECA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDB6EJA": {
    "series": "OLEDB6",
    "broadcast": "arib",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDB6ELA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "KZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDB6ELB": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      83
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "FR",
      "IT",
      "PT",
      "SE",
      "UK"
    ]
  },
  "OLEDB6ELC": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "OLEDB6ENA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB6ERA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ARUG",
    "sizes": [
      77
    ],
    "regions": [
      "RU"
    ]
  },
  "OLEDB6ESA": {
    "series": "OLEDB6",
    "broadcast": "isdb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE",
      "TH",
      "VN"
    ]
  },
  "OLEDB6EUA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDB6FNA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB6GUA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDB6HNA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB6J": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "OLEDB6K": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB6KNA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      48,
      55,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB6MJA": {
    "series": "OLEDB6",
    "broadcast": "arib",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDB6NNA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB6P": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16K_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W16K_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "OLEDB6PCA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDB6PSA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDB6PTA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "OLEDB6RLA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "OLEDB6SCA": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDB6SNA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB6T": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDB6V": {
    "series": "OLEDB6",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PH",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "OLEDB6XNA": {
    "series": "OLEDB6",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB7A": {
    "series": "OLEDB7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDB7D": {
    "series": "OLEDB7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "NL",
      "UK"
    ]
  },
  "OLEDB7F": {
    "series": "OLEDB7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB7K": {
    "series": "OLEDB7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB7L": {
    "series": "OLEDB7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB7M": {
    "series": "OLEDB7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "OLEDB7P": {
    "series": "OLEDB7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W17H_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "OLEDB7T": {
    "series": "OLEDB7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "CO",
      "MY",
      "NZ",
      "TH"
    ]
  },
  "OLEDB7V": {
    "series": "OLEDB7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "OLEDB8BNA": {
    "series": "OLEDB8",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB8CNA": {
    "series": "OLEDB8",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB8FNA": {
    "series": "OLEDB8",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB8GNA": {
    "series": "OLEDB8",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB8LLA": {
    "series": "OLEDB8",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL",
      "PT"
    ]
  },
  "OLEDB8PCA": {
    "series": "OLEDB8",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDB8PJA": {
    "series": "OLEDB8",
    "broadcast": "arib",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDB8PLA": {
    "series": "OLEDB8",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "OLEDB8PTA": {
    "series": "OLEDB8",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "ID",
      "IN",
      "MY",
      "TH"
    ]
  },
  "OLEDB8PUA": {
    "series": "OLEDB8",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDB8PVA": {
    "series": "OLEDB8",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AMA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "OLEDB8PWA": {
    "series": "OLEDB8",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".STTWLJK",
    "sizes": [
      55
    ],
    "regions": [
      "TW"
    ]
  },
  "OLEDB8SJB": {
    "series": "OLEDB8",
    "broadcast": "arib",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDB8SLB": {
    "series": "OLEDB8",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".ADK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "OLEDB8SLC": {
    "series": "OLEDB8",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "UK"
    ]
  },
  "OLEDB8SSC": {
    "series": "OLEDB8",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "OLEDB8STB": {
    "series": "OLEDB8",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ",
      "SG"
    ]
  },
  "OLEDB97LA": {
    "series": "OLEDB9",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "OLEDB9BNA": {
    "series": "OLEDB9",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB9CNA": {
    "series": "OLEDB9",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB9FNA": {
    "series": "OLEDB9",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB9GNA": {
    "series": "OLEDB9",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB9KNA": {
    "series": "OLEDB9",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDB9PCA": {
    "series": "OLEDB9",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDB9PDB": {
    "series": "OLEDB9",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      55
    ],
    "regions": [
      "CO"
    ]
  },
  "OLEDB9PJA": {
    "series": "OLEDB9",
    "broadcast": "arib",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDB9PLA": {
    "series": "OLEDB9",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDB9PPA": {
    "series": "OLEDB9",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      55
    ],
    "regions": [
      "PH"
    ]
  },
  "OLEDB9PSB": {
    "series": "OLEDB9",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "OLEDB9PTA": {
    "series": "OLEDB9",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "TH",
      "VN"
    ]
  },
  "OLEDB9PUA": {
    "series": "OLEDB9",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDB9PUB": {
    "series": "OLEDB9",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "OLEDB9PVA": {
    "series": "OLEDB9",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDB9SLA": {
    "series": "OLEDB9",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR"
    ]
  },
  "OLEDBX3LB": {
    "series": "OLEDBX",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "OLEDBX6LB": {
    "series": "OLEDBX",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDBX9LB": {
    "series": "OLEDBX",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "OLEDBXAUA": {
    "series": "OLEDBX",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDBXBNA": {
    "series": "OLEDBX",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDBXCNA": {
    "series": "OLEDBX",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDBXENA": {
    "series": "OLEDBX",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDBXFNA": {
    "series": "OLEDBX",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDBXGNA": {
    "series": "OLEDBX",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDBXKNA": {
    "series": "OLEDBX",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDBXPCA": {
    "series": "OLEDBX",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDBXPDA": {
    "series": "OLEDBX",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "OLEDBXPJA": {
    "series": "OLEDBX",
    "broadcast": "arib",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDBXPTA": {
    "series": "OLEDBX",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "TH",
      "VN"
    ]
  },
  "OLEDBXPUA": {
    "series": "OLEDBX",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDBXPVA": {
    "series": "OLEDBX",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ"
    ]
  },
  "OLEDBXPWA": {
    "series": "OLEDBX",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".STTQLJK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "OLEDBXRLB": {
    "series": "OLEDBX",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".ADKB",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "OLEDC11LA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      83
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "OLEDC11LB": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "PL",
      "PT",
      "SE"
    ]
  },
  "OLEDC12LA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL",
      "PT",
      "SE"
    ]
  },
  "OLEDC14LA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      83
    ],
    "regions": [
      "BE",
      "CZ",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDC14LB": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "HU",
      "IT",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDC15LA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "CZ",
      "ES",
      "FR",
      "HU",
      "IT",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "OLEDC16LA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "OLEDC17LA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      83
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "OLEDC17LB": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "HU",
      "PT"
    ]
  },
  "OLEDC18LA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "PL",
      "PT"
    ]
  },
  "OLEDC19LA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "HU",
      "NL",
      "PL",
      "PT",
      "UK"
    ]
  },
  "OLEDC1AUA": {
    "series": "OLEDC1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      83
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDC1AUB": {
    "series": "OLEDC1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".ACC",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "CA"
    ]
  },
  "OLEDC1ENB": {
    "series": "OLEDC1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "sizes": [
      48
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC1KNA": {
    "series": "OLEDC1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "sizes": [
      55,
      65,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC1KNB": {
    "series": "OLEDC1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC1PCA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      83
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDC1PCB": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDC1PJA": {
    "series": "OLEDC1",
    "broadcast": "arib",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      83
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDC1PJB": {
    "series": "OLEDC1",
    "broadcast": "arib",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDC1PSA": {
    "series": "OLEDC1",
    "broadcast": "isdb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AWZ",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE",
      "TW"
    ]
  },
  "OLEDC1PSB": {
    "series": "OLEDC1",
    "broadcast": "isdb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".APH",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "PH",
      "TW"
    ]
  },
  "OLEDC1PTA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      83
    ],
    "regions": [
      "AU",
      "ID",
      "NZ",
      "SG"
    ]
  },
  "OLEDC1PTB": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDC1PTZ": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".ATR",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "IN"
    ]
  },
  "OLEDC1PUA": {
    "series": "OLEDC1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      83
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDC1PUB": {
    "series": "OLEDC1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDC1PVA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDC1PVB": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".ANR",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDC1QNB": {
    "series": "OLEDC1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC1RLA": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".ADKB",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "OLEDC1XTZ": {
    "series": "OLEDC1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".ATR",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "OLEDC21LA": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "HU",
      "NL",
      "PL",
      "PT"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC22LB": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "HU",
      "NL",
      "PL"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC24LA": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "NZ",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC25LB": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "BE",
      "DE",
      "ES",
      "FR",
      "NL",
      "SE"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC26LA": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "CZ",
      "ES",
      "PL",
      "SA",
      "SE",
      "ZA"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC26LB": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC26LD": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC27LA": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEUD",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "NL",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC28LB": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC29LA": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      83
    ],
    "regions": [
      "AT",
      "DE"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC29LB": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "NL",
      "SE"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC29LD": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "RU"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2AUA": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2ENA": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      42,
      48
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2FNA": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2KNA": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      42,
      48,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2KNB": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      42
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2KND": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2PCA": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      42,
      48,
      83
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2PCC": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2PJA": {
    "series": "OLEDC2",
    "broadcast": "arib",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      42,
      48,
      55,
      65,
      83
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDC2PSA": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC2PSC": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "IN",
      "NZ",
      "PH",
      "TH",
      "TW"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2PUA": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC2QNA": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2RLA": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".ADKB",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2RLB": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".ADKG",
    "sizes": [
      42
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2SNC": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2SW": {
    "series": "OLEDC2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "AT",
      "DE",
      "UK",
      "US"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2XSA": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".ATR",
    "sizes": [
      48
    ],
    "regions": [
      "IN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC2XSC": {
    "series": "OLEDC2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "IN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "mullet",
        "swMajor": "03"
      }
    ]
  },
  "OLEDC31LA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "NL",
      "PL",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC32LA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC34LA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDC35LA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC36LA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AU",
      "ES",
      "NZ",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".ADRB"
      }
    ]
  },
  "OLEDC36LC": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "BE",
      "ES",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".ADRB"
      }
    ]
  },
  "OLEDC37LA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "IT",
      "NL",
      "PL",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC38LA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE"
    ],
    "variants": [
      {
        "codename": "queue"
      },
      {
        "codename": "number1",
        "swMajor": "03"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "OLEDC39LA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      83
    ],
    "regions": [
      "AT",
      "DE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC39LC": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3AUA": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      83
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3CNA": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      42
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3ENA": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      42,
      48
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3FNA": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3KNA": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      42,
      48,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3KNB": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      42
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3PCA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3PJA": {
    "series": "OLEDC3",
    "broadcast": "arib",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      42,
      48,
      55,
      65,
      83
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3PSA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3PUA": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3QNA": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      65,
      77,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3RLA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".ADKG",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3SNA": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3XNA": {
    "series": "OLEDC3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC3XSA": {
    "series": "OLEDC3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".ATR",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "IN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC41LA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "BE",
      "HU",
      "IT",
      "NL",
      "PL"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC43LA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "HU",
      "IT",
      "PL",
      "PT",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDC44LA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IN",
      "IT",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDC45LA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "BE",
      "CZ",
      "ES",
      "NL",
      "PL",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".API"
      }
    ]
  },
  "OLEDC46LA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IN",
      "IT",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SA",
      "TR",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".ADRB"
      }
    ]
  },
  "OLEDC47LA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "DE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC48LA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "IT",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC49LA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "IT"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4AUA": {
    "series": "OLEDC4",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4CNA": {
    "series": "OLEDC4",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "sizes": [
      42
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4ENA": {
    "series": "OLEDC4",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "sizes": [
      42,
      48,
      55,
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4FNA": {
    "series": "OLEDC4",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4KNA": {
    "series": "OLEDC4",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "sizes": [
      42,
      48,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4PCA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4PJA": {
    "series": "OLEDC4",
    "broadcast": "arib",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDC4PSA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4PTA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".ATT",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4PUA": {
    "series": "OLEDC4",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4QNA": {
    "series": "OLEDC4",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "sizes": [
      65,
      77,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4RLA": {
    "series": "OLEDC4",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".ARUB",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4SNA": {
    "series": "OLEDC4",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC4XNA": {
    "series": "OLEDC4",
    "broadcast": "atsc",
    "machine": "o22n2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "sizes": [
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC51LA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "NL",
      "PL"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC52LA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "CZ",
      "HU"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC54LA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IN",
      "IT",
      "NL",
      "NZ",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDC55LA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "BE",
      "ES",
      "HU",
      "IT",
      "NL",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDC56LA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AU",
      "BE",
      "CZ",
      "ES",
      "IN",
      "NL",
      "NZ",
      "PL",
      "PT",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC56LB": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDC57LA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC58LA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "HU"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AVS"
      }
    ]
  },
  "OLEDC59LA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      83
    ],
    "regions": [
      "AT",
      "DE",
      "HU"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC59LB": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AVS"
      }
    ]
  },
  "OLEDC5AUA": {
    "series": "OLEDC5",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5ELA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      83
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDC5ELB": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEUD"
      }
    ]
  },
  "OLEDC5ENA": {
    "series": "OLEDC5",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "sizes": [
      42,
      48,
      55,
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5ESA": {
    "series": "OLEDC5",
    "broadcast": "isdb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AWF",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CL",
      "CO",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AWH"
      }
    ]
  },
  "OLEDC5FNA": {
    "series": "OLEDC5",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "sizes": [
      65,
      77,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5KNA": {
    "series": "OLEDC5",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "sizes": [
      42,
      48,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5MJA": {
    "series": "OLEDC5",
    "broadcast": "arib",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDC5PCA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5PJA": {
    "series": "OLEDC5",
    "broadcast": "arib",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDC5PSA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5PTA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".ATT",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5PUA": {
    "series": "OLEDC5",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5QNA": {
    "series": "OLEDC5",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "sizes": [
      65,
      77,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5RLA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".ARUG",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5SNA": {
    "series": "OLEDC5",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5YUA": {
    "series": "OLEDC5",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".ACC",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "CA"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC5ZSA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".ATM",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TH"
    ]
  },
  "OLEDC5ZTA": {
    "series": "OLEDC5",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDC61LA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "HU"
    ]
  },
  "OLEDC64LA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEI",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDC65LA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "ES",
      "IT",
      "SE",
      "UK"
    ]
  },
  "OLEDC66LA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AFBG",
    "sizes": [
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDC66LB": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CZ",
      "ES",
      "FR",
      "IT",
      "PT",
      "SE",
      "UK"
    ]
  },
  "OLEDC67LA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "DE",
      "NL",
      "NZ"
    ]
  },
  "OLEDC68LA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "NL"
    ]
  },
  "OLEDC69LB": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "DE",
      "NL"
    ]
  },
  "OLEDC6AUA": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDC6D": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "OLEDC6DLA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".ARU",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "RU"
    ]
  },
  "OLEDC6ELB": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SA",
      "TR",
      "UK"
    ]
  },
  "OLEDC6ENA": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "sizes": [
      42,
      48,
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC6ESA": {
    "series": "OLEDC6",
    "broadcast": "isdb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AWF",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CL",
      "CO",
      "PE"
    ]
  },
  "OLEDC6FNA": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "sizes": [
      65,
      77,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC6HUA": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDC6HUP": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDC6K": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC6KNA": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "sizes": [
      42,
      48,
      55,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC6L": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC6MJA": {
    "series": "OLEDC6",
    "broadcast": "arib",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDC6P": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16M_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W16M_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "OLEDC6PCA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDC6PJA": {
    "series": "OLEDC6",
    "broadcast": "arib",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      42,
      48,
      55,
      65
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "otaId": "HE_DTV_W26O_AFABATAA"
      }
    ]
  },
  "OLEDC6PSA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDC6PTA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".ATT",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "TW"
    ]
  },
  "OLEDC6PUA": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      42,
      48,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDC6QNA": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC6RLA": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".ARU",
    "sizes": [
      42,
      48,
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "OLEDC6SNA": {
    "series": "OLEDC6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "sizes": [
      65,
      77,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC6T": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "MY",
      "NZ",
      "SG",
      "TH"
    ]
  },
  "OLEDC6V": {
    "series": "OLEDC6",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDC7BO": {
    "series": "OLEDC7",
    "broadcast": "atsc",
    "machine": "m16pbno",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17B_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "ES",
      "MX"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17B_AFADABAA",
        "suffix": ".ATR",
        "regions": [
          "ES",
          "HK",
          "IN"
        ]
      }
    ]
  },
  "OLEDC7D": {
    "series": "OLEDC7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "NL"
    ]
  },
  "OLEDC7K": {
    "series": "OLEDC7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC7L": {
    "series": "OLEDC7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC7P": {
    "series": "OLEDC7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W17H_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "OLEDC7T": {
    "series": "OLEDC7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDC7V": {
    "series": "OLEDC7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "OLEDC8AUA": {
    "series": "OLEDC8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDC8BNA": {
    "series": "OLEDC8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC8CNA": {
    "series": "OLEDC8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC8FNA": {
    "series": "OLEDC8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC8GNA": {
    "series": "OLEDC8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC8KNA": {
    "series": "OLEDC8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC8LLA": {
    "series": "OLEDC8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDC8PCA": {
    "series": "OLEDC8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AHK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDC8PDA": {
    "series": "OLEDC8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AWC",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "OLEDC8PJA": {
    "series": "OLEDC8",
    "broadcast": "arib",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDC8PLA": {
    "series": "OLEDC8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "OLEDC8PPA": {
    "series": "OLEDC8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "suffix": ".APH",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "OLEDC8PSA": {
    "series": "OLEDC8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "OLEDC8PTA": {
    "series": "OLEDC8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDC8PUA": {
    "series": "OLEDC8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDC8PVA": {
    "series": "OLEDC8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AMI",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "OLEDC97LA": {
    "series": "OLEDC9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "OLEDC98LB": {
    "series": "OLEDC9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ]
  },
  "OLEDC9AUA": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDC9AUB": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDC9BNA": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC9CNA": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC9FNA": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC9GNA": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC9KNA": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDC9MLB": {
    "series": "OLEDC9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "HU",
      "IT",
      "NL",
      "PT",
      "RU",
      "UK"
    ]
  },
  "OLEDC9PCA": {
    "series": "OLEDC9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AHK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDC9PJA": {
    "series": "OLEDC9",
    "broadcast": "arib",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDC9PLA": {
    "series": "OLEDC9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDC9PPA": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".APH",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "OLEDC9PSA": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "OLEDC9PSB": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AWZ",
    "sizes": [
      77
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "OLEDC9PTA": {
    "series": "OLEDC9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDC9PUA": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDC9PUB": {
    "series": "OLEDC9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDC9PVA": {
    "series": "OLEDC9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDC9PVB": {
    "series": "OLEDC9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AFB",
    "sizes": [
      77
    ],
    "regions": [
      "AE",
      "ZA"
    ]
  },
  "OLEDC9PWA": {
    "series": "OLEDC9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".STTYLJK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "TW"
    ]
  },
  "OLEDCS3VA": {
    "series": "OLEDCS",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AMVE",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "TR",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".AFKE"
      }
    ]
  },
  "OLEDCS4VA": {
    "series": "OLEDCS",
    "broadcast": "dvb",
    "machine": "o22n2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24G_AFABATAA",
    "suffix": ".AMVE",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "OLEDCS5VA": {
    "series": "OLEDCS",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AMVE",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "SA"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDCS6LA": {
    "series": "OLEDCS",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "NZ",
      "PL",
      "PT",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDCS9LA": {
    "series": "OLEDCS",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEUD",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDCSPSA": {
    "series": "OLEDCS",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "NZ"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDCX3LA": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "PL"
    ]
  },
  "OLEDCX3LB": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      48
    ],
    "regions": [
      "CZ",
      "HU",
      "IT",
      "PL"
    ]
  },
  "OLEDCX5LB": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "ES",
      "PT",
      "UK"
    ]
  },
  "OLEDCX5LC": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      48
    ],
    "regions": [
      "BE",
      "ES",
      "NL",
      "UK"
    ]
  },
  "OLEDCX6LA": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDCX6LB": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      48
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "OLEDCX8LB": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "OLEDCX8LC": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      48
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ]
  },
  "OLEDCX9LA": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "FR",
      "PL"
    ]
  },
  "OLEDCX9LB": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      48
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ]
  },
  "OLEDCXAUA": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDCXBNA": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDCXCNA": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDCXFNA": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDCXGNA": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDCXKNA": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDCXKNB": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "sizes": [
      48
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDCXPCA": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AHK",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDCXPDA": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AWC",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "OLEDCXPJA": {
    "series": "OLEDCX",
    "broadcast": "arib",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDCXPSA": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "OLEDCXPTA": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AAU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDCXPUA": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDCXPUB": {
    "series": "OLEDCX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      48
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDCXPVA": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDCXPWA": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "TW"
    ]
  },
  "OLEDCXRLA": {
    "series": "OLEDCX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".ARU",
    "sizes": [
      48,
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "OLEDE6D": {
    "series": "OLEDE6",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "NL"
    ]
  },
  "OLEDE6K": {
    "series": "OLEDE6",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDE6P": {
    "series": "OLEDE6",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16M_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W16M_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "OLEDE6T": {
    "series": "OLEDE6",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDE6V": {
    "series": "OLEDE6",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "OLEDE7K": {
    "series": "OLEDE7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": "-N",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDE7N": {
    "series": "OLEDE7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDE7P": {
    "series": "OLEDE7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W17H_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "OLEDE7T": {
    "series": "OLEDE7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDE7V": {
    "series": "OLEDE7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "OLEDE8KNA": {
    "series": "OLEDE8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDE8LLA": {
    "series": "OLEDE8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "OLEDE8PCA": {
    "series": "OLEDE8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AHK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDE8PDA": {
    "series": "OLEDE8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AWC",
    "sizes": [
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "OLEDE8PJA": {
    "series": "OLEDE8",
    "broadcast": "arib",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDE8PLA": {
    "series": "OLEDE8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDE8PSA": {
    "series": "OLEDE8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "suffix": ".AWF",
    "sizes": [
      65
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "OLEDE8PTA": {
    "series": "OLEDE8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDE8PUA": {
    "series": "OLEDE8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDE97LA": {
    "series": "OLEDE9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ]
  },
  "OLEDE9AUA": {
    "series": "OLEDE9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDE9KNA": {
    "series": "OLEDE9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDE9PCA": {
    "series": "OLEDE9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AHK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDE9PJA": {
    "series": "OLEDE9",
    "broadcast": "arib",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDE9PLA": {
    "series": "OLEDE9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDE9PSA": {
    "series": "OLEDE9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AWZ",
    "sizes": [
      65
    ],
    "regions": [
      "BR",
      "PE"
    ]
  },
  "OLEDE9PTA": {
    "series": "OLEDE9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "IN",
      "MY",
      "NZ",
      "SG",
      "VN"
    ]
  },
  "OLEDE9PUA": {
    "series": "OLEDE9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDE9PVA": {
    "series": "OLEDE9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".ANR",
    "sizes": [
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "ZA"
    ]
  },
  "OLEDG13LA": {
    "series": "OLEDG1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "PT",
      "SE"
    ]
  },
  "OLEDG16LA": {
    "series": "OLEDG1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "ES",
      "FR",
      "HU",
      "IT",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDG19LA": {
    "series": "OLEDG1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "DE",
      "HU",
      "PT"
    ]
  },
  "OLEDG1KNA": {
    "series": "OLEDG1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "IN",
      "KR"
    ]
  },
  "OLEDG1PCA": {
    "series": "OLEDG1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDG1PJA": {
    "series": "OLEDG1",
    "broadcast": "arib",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDG1PSA": {
    "series": "OLEDG1",
    "broadcast": "isdb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE",
      "PH",
      "TW"
    ]
  },
  "OLEDG1PTA": {
    "series": "OLEDG1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDG1PTZ": {
    "series": "OLEDG1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "IN"
    ]
  },
  "OLEDG1PUA": {
    "series": "OLEDG1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDG1PVA": {
    "series": "OLEDG1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA"
    ]
  },
  "OLEDG1RLA": {
    "series": "OLEDG1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "BE",
      "HU",
      "KZ",
      "NL",
      "PT",
      "RU"
    ]
  },
  "OLEDG23LA": {
    "series": "OLEDG2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "CZ",
      "ES",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDG26LA": {
    "series": "OLEDG2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AE",
      "AU",
      "BE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "NZ",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDG29LA": {
    "series": "OLEDG2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDG2KNA": {
    "series": "OLEDG2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "sizes": [
      65,
      77,
      97
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDG2PCA": {
    "series": "OLEDG2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      77,
      97
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDG2PJA": {
    "series": "OLEDG2",
    "broadcast": "arib",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDG2PSA": {
    "series": "OLEDG2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "broadcast": "isdb",
        "codename": "queue",
        "suffix": ".AWH"
      }
    ]
  },
  "OLEDG2PUA": {
    "series": "OLEDG2",
    "broadcast": "atsc",
    "machine": "o22",
    "codename": "mullet",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "number1",
        "swMajor": "13"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".ACC"
      }
    ]
  },
  "OLEDG2RLA": {
    "series": "OLEDG2",
    "broadcast": "dvb",
    "machine": "o22",
    "codename": "number1",
    "otaId": "HE_DTV_W22O_AFABATAA",
    "suffix": ".ARU",
    "sizes": [
      55,
      65,
      77,
      97
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "OLEDG33LA": {
    "series": "OLEDG3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG36LA": {
    "series": "OLEDG3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".ADRB"
      }
    ]
  },
  "OLEDG39LA": {
    "series": "OLEDG3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "DE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG3KNA": {
    "series": "OLEDG3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG3PCA": {
    "series": "OLEDG3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG3PJA": {
    "series": "OLEDG3",
    "broadcast": "arib",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG3PSA": {
    "series": "OLEDG3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG3PUA": {
    "series": "OLEDG3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG3RLA": {
    "series": "OLEDG3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".ARUB",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG3XSA": {
    "series": "OLEDG3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".ATR",
    "sizes": [
      65
    ],
    "regions": [
      "IN"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG42LW": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "HU",
      "IT",
      "PL",
      "SE"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG43LS": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG45LW": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "BE",
      "CZ",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG46LA": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AMVG",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AE",
      "AU",
      "IN",
      "NZ",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG46LS": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BE",
      "CZ",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG48LW": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AT",
      "DE",
      "IT",
      "SE"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG49LS": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "IT"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG4KNA": {
    "series": "OLEDG4",
    "broadcast": "atsc",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "sizes": [
      55,
      65,
      77,
      97
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG4PCA": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      77,
      97
    ],
    "regions": [
      "HK",
      "IN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG4PJA": {
    "series": "OLEDG4",
    "broadcast": "arib",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      83,
      97
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG4PJB": {
    "series": "OLEDG4",
    "broadcast": "arib",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG4PSA": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG4PTA": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65,
      83
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG4RLA": {
    "series": "OLEDG4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".ARUB",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG4SUB": {
    "series": "OLEDG4",
    "broadcast": "atsc",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG4WUA": {
    "series": "OLEDG4",
    "broadcast": "atsc",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77,
      83,
      97
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG51LW": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG53LS": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG54LW": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "BE",
      "CZ",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDG55LW": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "BE",
      "CZ",
      "ES",
      "HU",
      "IT",
      "NL",
      "NZ",
      "PL",
      "TR"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG56LA": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AMVG",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AE",
      "AU",
      "IN",
      "NZ",
      "SA"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG56LS": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "NZ",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDG57LW": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AT",
      "DE",
      "HU"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG58LW": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "DE",
      "HU"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG59LS": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "HU"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG5KNA": {
    "series": "OLEDG5",
    "broadcast": "atsc",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG5PCA": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      77,
      83,
      97
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG5PJA": {
    "series": "OLEDG5",
    "broadcast": "arib",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      83
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG5PJB": {
    "series": "OLEDG5",
    "broadcast": "arib",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG5PSA": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG5PTA": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65,
      83,
      97
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG5RLA": {
    "series": "OLEDG5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".ARUG",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG5SUA": {
    "series": "OLEDG5",
    "broadcast": "atsc",
    "machine": "o24n",
    "codename": "queue",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      48
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDG5SUB": {
    "series": "OLEDG5",
    "broadcast": "atsc",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".ACC",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG5WUA": {
    "series": "OLEDG5",
    "broadcast": "atsc",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDG61LW": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "HU"
    ]
  },
  "OLEDG62LW": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "UK"
    ]
  },
  "OLEDG64LW": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEI",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "CZ",
      "ES",
      "FR",
      "IT",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDG66LS": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEI",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "OLEDG67LW": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ]
  },
  "OLEDG68LW": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "NL"
    ]
  },
  "OLEDG69LS": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      48,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ]
  },
  "OLEDG6K": {
    "series": "OLEDG6",
    "broadcast": "atsc",
    "machine": "h15",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W15H_AFADATAA",
    "suffix": "-N",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDG6KNA": {
    "series": "OLEDG6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDG6P": {
    "series": "OLEDG6",
    "broadcast": "atsc",
    "machine": "h15",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W15H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W15H_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "OLEDG6PCA": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      48,
      55,
      77,
      83,
      97
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDG6PJA": {
    "series": "OLEDG6",
    "broadcast": "arib",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      83,
      97
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "otaId": "HE_DTV_W26O_AFABATAA"
      }
    ]
  },
  "OLEDG6PJB": {
    "series": "OLEDG6",
    "broadcast": "arib",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "otaId": "HE_DTV_W26O_AFABATAA"
      }
    ]
  },
  "OLEDG6PSA": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDG6PSB": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77,
      83
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "OLEDG6PTA": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "TW"
    ]
  },
  "OLEDG6RLA": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".ARU",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "OLEDG6SUB": {
    "series": "OLEDG6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".ACC",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA"
    ]
  },
  "OLEDG6T": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "h15",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W15H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AU",
      "NZ",
      "SG"
    ]
  },
  "OLEDG6V": {
    "series": "OLEDG6",
    "broadcast": "dvb",
    "machine": "h15",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W15H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PH",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "OLEDG6WUA": {
    "series": "OLEDG6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77,
      83,
      97
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDG7K": {
    "series": "OLEDG7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": "-N",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDG7P": {
    "series": "OLEDG7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDG7T": {
    "series": "OLEDG7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AU",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDG7V": {
    "series": "OLEDG7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "OLEDG8PJA": {
    "series": "OLEDG8",
    "broadcast": "arib",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDG8PLA": {
    "series": "OLEDG8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "NL",
      "PL",
      "UK"
    ]
  },
  "OLEDGX3LA": {
    "series": "OLEDGX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "OLEDGX6LA": {
    "series": "OLEDGX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDGX9LA": {
    "series": "OLEDGX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "NL"
    ]
  },
  "OLEDGXKNA": {
    "series": "OLEDGX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDGXPCA": {
    "series": "OLEDGX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AHK",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDGXPJA": {
    "series": "OLEDGX",
    "broadcast": "arib",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDGXPSA": {
    "series": "OLEDGX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "suffix": ".AWZ",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "OLEDGXPTA": {
    "series": "OLEDGX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDGXPUA": {
    "series": "OLEDGX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDGXPVA": {
    "series": "OLEDGX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".ANR",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDGXRLA": {
    "series": "OLEDGX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".ARU",
    "sizes": [
      55,
      65,
      77
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "OLEDM36LA": {
    "series": "OLEDM3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AMVG",
    "sizes": [
      77,
      83,
      97
    ],
    "regions": [
      "AE",
      "SA"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM39LA": {
    "series": "OLEDM3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      77,
      83,
      97
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM3KNA": {
    "series": "OLEDM3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ombre",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "sizes": [
      77,
      97
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM3PCA": {
    "series": "OLEDM3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AHK",
    "sizes": [
      97
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM3PJA": {
    "series": "OLEDM3",
    "broadcast": "arib",
    "machine": "o22n",
    "codename": "number1",
    "otaId": "HE_DTV_W23O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      77,
      97
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM3PSA": {
    "series": "OLEDM3",
    "broadcast": "dvb",
    "machine": "o22n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      77,
      97
    ],
    "regions": [
      "AU",
      "NZ",
      "SG",
      "TW"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM3PUA": {
    "series": "OLEDM3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77,
      83,
      97
    ],
    "regions": [
      "CA",
      "KR",
      "US"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM3YUA": {
    "series": "OLEDM3",
    "broadcast": "atsc",
    "machine": "o22n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM49LA": {
    "series": "OLEDM4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDM4KNA": {
    "series": "OLEDM4",
    "broadcast": "atsc",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "sizes": [
      65,
      77,
      97
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM4PCA": {
    "series": "OLEDM4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      77,
      83,
      97
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM4PJA": {
    "series": "OLEDM4",
    "broadcast": "arib",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM4PSA": {
    "series": "OLEDM4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "MX",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM4PTA": {
    "series": "OLEDM4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".ATT",
    "sizes": [
      77
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM56LA": {
    "series": "OLEDM5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AMVG",
    "sizes": [
      77,
      83,
      97
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM59LA": {
    "series": "OLEDM5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AT",
      "AU",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NZ",
      "PL",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "OLEDM5KNA": {
    "series": "OLEDM5",
    "broadcast": "atsc",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "sizes": [
      65,
      77,
      83,
      97
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM5PCA": {
    "series": "OLEDM5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      77,
      83,
      97
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM5PJA": {
    "series": "OLEDM5",
    "broadcast": "arib",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      97
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM5PSA": {
    "series": "OLEDM5",
    "broadcast": "dvb",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      77,
      83,
      97
    ],
    "regions": [
      "AU",
      "NZ",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDM5PUA": {
    "series": "OLEDM5",
    "broadcast": "atsc",
    "machine": "o24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDR19LA": {
    "series": "OLEDR1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "FR",
      "IT",
      "NL",
      "PL",
      "RU",
      "UK"
    ]
  },
  "OLEDR1PTA": {
    "series": "OLEDR1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "IN",
      "NZ"
    ]
  },
  "OLEDR1PUA": {
    "series": "OLEDR1",
    "broadcast": "atsc",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDR1PVA": {
    "series": "OLEDR1",
    "broadcast": "dvb",
    "machine": "o20n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21O_AFABATAA",
    "suffix": ".AMV",
    "sizes": [
      65
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "OLEDRXKNA": {
    "series": "OLEDRX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDRXKND": {
    "series": "OLEDRX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDT49LA": {
    "series": "OLEDT4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AEU",
    "sizes": [
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PT",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDT4PCA": {
    "series": "OLEDT4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AHK",
    "sizes": [
      77
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDT4PJA": {
    "series": "OLEDT4",
    "broadcast": "arib",
    "machine": "o24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      77
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDT4PSA": {
    "series": "OLEDT4",
    "broadcast": "dvb",
    "machine": "o24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      77
    ],
    "regions": [
      "AU",
      "MX"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDT4PUA": {
    "series": "OLEDT4",
    "broadcast": "atsc",
    "machine": "o24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "OLEDT6PUA": {
    "series": "OLEDT6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77
    ],
    "regions": [
      "US"
    ]
  },
  "OLEDW66LA": {
    "series": "OLEDW6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AFBG",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "OLEDW69LA": {
    "series": "OLEDW6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AEI",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDW6KNA": {
    "series": "OLEDW6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDW6PCA": {
    "series": "OLEDW6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AHKG",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDW6PJA": {
    "series": "OLEDW6",
    "broadcast": "arib",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABJAAA",
    "suffix": ".AJLG",
    "sizes": [
      83
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDW6PSA": {
    "series": "OLEDW6",
    "broadcast": "dvb",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AAU",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "MX",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDW6PUA": {
    "series": "OLEDW6",
    "broadcast": "atsc",
    "machine": "o26",
    "codename": "queue",
    "otaId": "HE_DTV_W26O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      77,
      83
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDW7K": {
    "series": "OLEDW7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": "-N",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDW7P": {
    "series": "OLEDW7",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W17H_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "OLEDW7T": {
    "series": "OLEDW7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AU",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDW7V": {
    "series": "OLEDW7",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "OLEDW8PDA": {
    "series": "OLEDW8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AWC",
    "sizes": [
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "OLEDW8PJA": {
    "series": "OLEDW8",
    "broadcast": "arib",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDW8PLA": {
    "series": "OLEDW8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDW8PSA": {
    "series": "OLEDW8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "suffix": ".AWZZ",
    "sizes": [
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "OLEDW8PTA": {
    "series": "OLEDW8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDW8PUA": {
    "series": "OLEDW8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "CA",
      "MX",
      "PE",
      "US"
    ]
  },
  "OLEDW8PWA": {
    "series": "OLEDW8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".ATT",
    "sizes": [
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "OLEDW8WNA": {
    "series": "OLEDW8",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDW8XCA": {
    "series": "OLEDW8",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18O_AFABABAA",
    "suffix": ".AHK",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDW9PCA": {
    "series": "OLEDW9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AHK",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDW9PJA": {
    "series": "OLEDW9",
    "broadcast": "arib",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDW9PLA": {
    "series": "OLEDW9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDW9PPA": {
    "series": "OLEDW9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".APH",
    "sizes": [
      77
    ],
    "regions": [
      "PH"
    ]
  },
  "OLEDW9PSA": {
    "series": "OLEDW9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AWF",
    "sizes": [
      65
    ],
    "regions": [
      "PE"
    ]
  },
  "OLEDW9PTA": {
    "series": "OLEDW9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDW9PUA": {
    "series": "OLEDW9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      77
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "OLEDW9PVA": {
    "series": "OLEDW9",
    "broadcast": "dvb",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABABAA",
    "suffix": ".ANR",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "OLEDW9WNA": {
    "series": "OLEDW9",
    "broadcast": "atsc",
    "machine": "o18",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19O_AFABATAA",
    "sizes": [
      77
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDWX9LA": {
    "series": "OLEDWX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AEK",
    "sizes": [
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDWXPCA": {
    "series": "OLEDWX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".AHK",
    "sizes": [
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDWXPJA": {
    "series": "OLEDWX",
    "broadcast": "arib",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABJAAA",
    "suffix": ".AJL",
    "sizes": [
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDWXPUA": {
    "series": "OLEDWX",
    "broadcast": "atsc",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDWXPVA": {
    "series": "OLEDWX",
    "broadcast": "dvb",
    "machine": "o20",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20O_AFABABAA",
    "suffix": ".ANR",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "NZ",
      "ZA"
    ]
  },
  "OLEDZ19LA": {
    "series": "OLEDZ1",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDZ1KNA": {
    "series": "OLEDZ1",
    "broadcast": "atsc",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDZ1PCA": {
    "series": "OLEDZ1",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AHK",
    "sizes": [
      88
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDZ1PJA": {
    "series": "OLEDZ1",
    "broadcast": "arib",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDZ1PSA": {
    "series": "OLEDZ1",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      88
    ],
    "regions": [
      "TW"
    ]
  },
  "OLEDZ1PTA": {
    "series": "OLEDZ1",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "AU",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDZ1PTZ": {
    "series": "OLEDZ1",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".ATRZ",
    "sizes": [
      88
    ],
    "regions": [
      "IN"
    ]
  },
  "OLEDZ1PVA": {
    "series": "OLEDZ1",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AMI",
    "sizes": [
      88
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "OLEDZ26LA": {
    "series": "OLEDZ2",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AMI",
    "sizes": [
      88
    ],
    "regions": [
      "AE",
      "SA"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ29LA": {
    "series": "OLEDZ2",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ2KNA": {
    "series": "OLEDZ2",
    "broadcast": "atsc",
    "machine": "o228k",
    "codename": "ombre",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ2PCA": {
    "series": "OLEDZ2",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AHK",
    "sizes": [
      88
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ2PJA": {
    "series": "OLEDZ2",
    "broadcast": "arib",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      88
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ2PSA": {
    "series": "OLEDZ2",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "IN",
      "MY",
      "NZ",
      "PE",
      "SG",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ2PUA": {
    "series": "OLEDZ2",
    "broadcast": "atsc",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ39LA": {
    "series": "OLEDZ3",
    "broadcast": "dvb",
    "machine": "o22n8k",
    "codename": "number1",
    "otaId": "HE_DTV_W23K_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PL",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ3KNA": {
    "series": "OLEDZ3",
    "broadcast": "atsc",
    "machine": "o22n8k",
    "codename": "ombre",
    "otaId": "HE_DTV_W23K_AFADATAA",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ3PCA": {
    "series": "OLEDZ3",
    "broadcast": "dvb",
    "machine": "o22n8k",
    "codename": "number1",
    "otaId": "HE_DTV_W23K_AFADATAA",
    "suffix": ".AHK",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ3PJA": {
    "series": "OLEDZ3",
    "broadcast": "arib",
    "machine": "o22n8k",
    "codename": "number1",
    "otaId": "HE_DTV_W23K_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      88
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ3PSA": {
    "series": "OLEDZ3",
    "broadcast": "dvb",
    "machine": "o22n8k",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23K_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "AU",
      "BR",
      "IN",
      "MX",
      "NZ",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "broadcast": "isdb",
        "codename": "number1",
        "suffix": ".AWZ"
      },
      {
        "broadcast": "isdb",
        "codename": "ombre",
        "suffix": ".AWZ"
      }
    ]
  },
  "OLEDZ3PUA": {
    "series": "OLEDZ3",
    "broadcast": "atsc",
    "machine": "o22n8k",
    "codename": "number1",
    "otaId": "HE_DTV_W23K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "OLEDZ9KNA": {
    "series": "OLEDZ9",
    "broadcast": "atsc",
    "machine": "o18k",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19K_AFADATAA",
    "sizes": [
      88
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDZ9PJA": {
    "series": "OLEDZ9",
    "broadcast": "arib",
    "machine": "o18k",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19K_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      88
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDZ9PLA": {
    "series": "OLEDZ9",
    "broadcast": "dvb",
    "machine": "o18k",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19K_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      88
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "OLEDZ9PTA": {
    "series": "OLEDZ9",
    "broadcast": "dvb",
    "machine": "o18k",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19K_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      88
    ],
    "regions": [
      "AU",
      "NZ",
      "SG"
    ]
  },
  "OLEDZ9PUA": {
    "series": "OLEDZ9",
    "broadcast": "atsc",
    "machine": "o18k",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      88
    ],
    "regions": [
      "MX",
      "US"
    ]
  },
  "OLEDZX9LA": {
    "series": "OLEDZX",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "OLEDZXKNA": {
    "series": "OLEDZX",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "KR"
    ]
  },
  "OLEDZXPCA": {
    "series": "OLEDZX",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".ACN",
    "sizes": [
      88
    ],
    "regions": [
      "HK"
    ]
  },
  "OLEDZXPJA": {
    "series": "OLEDZX",
    "broadcast": "arib",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "JP"
    ]
  },
  "OLEDZXPTA": {
    "series": "OLEDZX",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "AU",
      "IN",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "OLEDZXPUA": {
    "series": "OLEDZX",
    "broadcast": "atsc",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      77,
      88
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "OLEDZXPVA": {
    "series": "OLEDZX",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".AFBZ",
    "sizes": [
      88
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "OLEDZXPWA": {
    "series": "OLEDZX",
    "broadcast": "dvb",
    "machine": "o208k",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20K_AFADABAA",
    "suffix": ".ATT",
    "sizes": [
      88
    ],
    "regions": [
      "TW"
    ]
  },
  "QN1C70BKA": {
    "series": "QN1C",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED65ABA": {
    "series": "QNED65",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED65BBA": {
    "series": "QNED65",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED65BEA": {
    "series": "QNED65",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED65BNA": {
    "series": "QNED65",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED65BSA": {
    "series": "QNED65",
    "broadcast": "isdb",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AWFQ",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED65TBA": {
    "series": "QNED65",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED70A6A": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "QNED70ABA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED70ACA": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED70AEA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      65,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED70AGA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED70ANA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED70ASA": {
    "series": "QNED70",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "PE",
      "PH",
      "TH",
      "VN"
    ]
  },
  "QNED70ASC": {
    "series": "QNED70",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      75
    ],
    "regions": [
      "CL",
      "MX",
      "PE"
    ]
  },
  "QNED70ATA": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "QNED70AUA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "o22n3",
        "otaId": "HE_DTV_W25G_AFABATAA"
      }
    ]
  },
  "QNED70AUC": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED70B3A": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      75,
      85
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED70B3C": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED70B6A": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      75,
      85
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED70B6C": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED70B6T": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "QNED70BCA": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED70BGA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED70BJA": {
    "series": "QNED70",
    "broadcast": "arib",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "JP"
    ]
  },
  "QNED70BKA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED70BSA": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED70BTA": {
    "series": "QNED70",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "QNED70ERA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED70NRA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED70TEA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED70TNA": {
    "series": "QNED70",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED71B3B": {
    "series": "QNED71",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED71B6B": {
    "series": "QNED71",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "NL",
      "SE",
      "UK"
    ]
  },
  "QNED71BSC": {
    "series": "QNED71",
    "broadcast": "isdb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AWH",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CL",
      "MX"
    ]
  },
  "QNED72B3A": {
    "series": "QNED72",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      75,
      85
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED72B3B": {
    "series": "QNED72",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED72B6A": {
    "series": "QNED72",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      75,
      85
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "QNED72B6B": {
    "series": "QNED72",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "QNED72B6T": {
    "series": "QNED72",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "QNED73ASA": {
    "series": "QNED73",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".BWR",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED73ASC": {
    "series": "QNED73",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      75
    ],
    "regions": [
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED73BZA": {
    "series": "QNED73",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CA"
    ]
  },
  "QNED74BSA": {
    "series": "QNED74",
    "broadcast": "isdb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED74BUA": {
    "series": "QNED74",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      85
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED753RA": {
    "series": "QNED75",
    "broadcast": "dvb",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED756RA": {
    "series": "QNED75",
    "broadcast": "dvb",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED756RB": {
    "series": "QNED75",
    "broadcast": "dvb",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED75AEA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED75AGA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED75ANA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED75ARA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED75BAA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "US"
    ]
  },
  "QNED75BUA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED75CRA": {
    "series": "QNED75",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED75FRA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED75GRA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED75JRA": {
    "series": "QNED75",
    "broadcast": "arib",
    "machine": "k8lpn",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43
    ],
    "regions": [
      "JP"
    ]
  },
  "QNED75KRA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED75SRA": {
    "series": "QNED75",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "IN",
      "MX",
      "MY",
      "NZ",
      "PE",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED75URA": {
    "series": "QNED75",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED773RB": {
    "series": "QNED77",
    "broadcast": "dvb",
    "machine": "m23",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED776RB": {
    "series": "QNED77",
    "broadcast": "dvb",
    "machine": "m23",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "UK"
    ]
  },
  "QNED7EA6B": {
    "series": "QNED7E",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "FR",
      "HU",
      "PT",
      "SE"
    ]
  },
  "QNED7EB3A": {
    "series": "QNED7E",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      75,
      85
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED7EB3C": {
    "series": "QNED7E",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED7EB6T": {
    "series": "QNED7E",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      65,
      75,
      85
    ],
    "regions": [
      "SA",
      "ZA"
    ]
  },
  "QNED7S3QA": {
    "series": "QNED7S",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "IT",
      "PL"
    ]
  },
  "QNED7S6QA": {
    "series": "QNED7S",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "ES",
      "KZ",
      "SA",
      "TR"
    ]
  },
  "QNED7S9QA": {
    "series": "QNED7S",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "QNED7SBAA": {
    "series": "QNED7S",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "US"
    ]
  },
  "QNED7SBUA": {
    "series": "QNED7S",
    "broadcast": "atsc",
    "machine": "k25lpnlm",
    "codename": "queue",
    "otaId": "HE_DTV_W26N_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED7SCQA": {
    "series": "QNED7S",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      50
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED7SKQA": {
    "series": "QNED7S",
    "broadcast": "atsc",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED7SSQA": {
    "series": "QNED7S",
    "broadcast": "isdb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "PE",
      "TH",
      "VN"
    ]
  },
  "QNED806QA": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "RU",
      "SA",
      "ZA"
    ]
  },
  "QNED80A3A": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED80A6A": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "QNED80ACA": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED80AKA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k25lp",
        "otaId": "HE_DTV_W25P_AFADATAA"
      }
    ]
  },
  "QNED80AQA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      86
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED80ARA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      86
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80ASA": {
    "series": "QNED80",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "PE",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED80AUA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA"
    ],
    "variants": [
      {
        "machine": "o22n3",
        "otaId": "HE_DTV_W25G_AFABATAA"
      }
    ]
  },
  "QNED80B6A": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      75,
      85
    ],
    "regions": [
      "AT",
      "AU",
      "CZ",
      "DE",
      "ES",
      "FR",
      "KZ",
      "NZ",
      "PL",
      "RU"
    ]
  },
  "QNED80B6B": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NZ",
      "PL",
      "RU",
      "SE"
    ]
  },
  "QNED80BCA": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED80BEA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED80BSA": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED80BSG": {
    "series": "QNED80",
    "broadcast": "isdb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "PE"
    ]
  },
  "QNED80BTA": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      85
    ],
    "regions": [
      "TW"
    ]
  },
  "QNED80JQA": {
    "series": "QNED80",
    "broadcast": "arib",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      50,
      55
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre"
      },
      {
        "otaId": "HE_DTV_W22H_AFADATAA"
      }
    ]
  },
  "QNED80JRA": {
    "series": "QNED80",
    "broadcast": "arib",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80KQA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED80KRA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "m23",
        "otaId": "HE_DTV_W23M_AFADATAA"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "machine": "m23",
        "codename": "ombre",
        "otaId": "HE_DTV_W23M_AFADATAA",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "m23",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23M_AFADATAA",
        "swMajor": "33"
      }
    ]
  },
  "QNED80MQA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED80SQA": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED80SRA": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80T3A": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80T6A": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "QNED80T6B": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AFFE",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80TCA": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80TJA": {
    "series": "QNED80",
    "broadcast": "arib",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail"
      }
    ]
  },
  "QNED80TKA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80TSA": {
    "series": "QNED80",
    "broadcast": "isdb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80TTA": {
    "series": "QNED80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80TUC": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED80UQA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED80URA": {
    "series": "QNED80",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED813QA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED813RE": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED816QA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED816RA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AU",
      "KZ",
      "NZ",
      "RU",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED816RE": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED819QA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED81A6A": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "ES",
      "FR",
      "SE"
    ]
  },
  "QNED81ASA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "NZ",
      "VN"
    ]
  },
  "QNED81B3A": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED81B6A": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "PT",
      "SE",
      "TR"
    ]
  },
  "QNED81B6C": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "PT",
      "SE",
      "UK"
    ]
  },
  "QNED81BMA": {
    "series": "QNED81",
    "broadcast": "atsc",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED81BSA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".ATV",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "VN"
    ]
  },
  "QNED81BSG": {
    "series": "QNED81",
    "broadcast": "isdb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AWH",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CL",
      "CO",
      "MX"
    ]
  },
  "QNED81CQA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED81CRA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HK",
      "ID"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED81SQA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "IN",
      "MY",
      "PH",
      "TW"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED81SRA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "MY",
      "NZ",
      "TW"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED81TCA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED81TSA": {
    "series": "QNED81",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "NZ"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED823QB": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "SE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED823RE": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED826QB": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "BE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE"
    ]
  },
  "QNED826RE": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED829QB": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED82A3B": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED82A6A": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AFBG",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "QNED82A6B": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED82AAA": {
    "series": "QNED82",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "o22n3",
        "otaId": "HE_DTV_W25G_AFABATAA"
      }
    ]
  },
  "QNED82ACA": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED82AJA": {
    "series": "QNED82",
    "broadcast": "arib",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43
    ],
    "regions": [
      "JP"
    ]
  },
  "QNED82AKA": {
    "series": "QNED82",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED82ASA": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "ID",
      "MY",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED82ASG": {
    "series": "QNED82",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED82ATA": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "TW"
    ]
  },
  "QNED82AUA": {
    "series": "QNED82",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "o22n3",
        "otaId": "HE_DTV_W25G_AFABATAA"
      }
    ]
  },
  "QNED82B6A": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      75,
      85
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "NL",
      "PT",
      "SE"
    ]
  },
  "QNED82B6B": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "NL",
      "PT",
      "SE"
    ]
  },
  "QNED82BCA": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED82BKA": {
    "series": "QNED82",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED82BSA": {
    "series": "QNED82",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ATC",
    "sizes": [
      65,
      75,
      85
    ],
    "regions": [
      "SG"
    ]
  },
  "QNED82BUA": {
    "series": "QNED82",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CA"
    ]
  },
  "QNED83ASG": {
    "series": "QNED83",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWH",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CL",
      "MX"
    ]
  },
  "QNED83B3A": {
    "series": "QNED83",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED83B6A": {
    "series": "QNED83",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "QNED83SRA": {
    "series": "QNED83",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "QNED84A3C": {
    "series": "QNED84",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU"
    ]
  },
  "QNED84A6C": {
    "series": "QNED84",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "UK"
    ]
  },
  "QNED84B6T": {
    "series": "QNED84",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "QNED84BAA": {
    "series": "QNED84",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED84BU": {
    "series": "QNED84",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      100
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED84BUA": {
    "series": "QNED84",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "US"
    ]
  },
  "QNED856QA": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AMVG",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "QNED856RA": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AMVG",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "SA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85A3C": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "HU"
    ]
  },
  "QNED85A6C": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "NL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "QNED85AAA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "US"
    ]
  },
  "QNED85ACA": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED85AGA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED85AKA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k25lp",
        "otaId": "HE_DTV_W25P_AFADATAA"
      }
    ]
  },
  "QNED85AKS": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED85AMA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k25lp",
        "otaId": "HE_DTV_W25P_AFADATAA"
      }
    ]
  },
  "QNED85AQA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      86
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED85ASG": {
    "series": "QNED85",
    "broadcast": "isdb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED85AU": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      100
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED85AUA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED85AXA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k25lp",
        "otaId": "HE_DTV_W25P_AFADATAA"
      }
    ]
  },
  "QNED85AYA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CA"
    ]
  },
  "QNED85B3B": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      75,
      86
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED85B6": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ARUG",
    "sizes": [
      100
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "QNED85B6A": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ARUG",
    "sizes": [
      50
    ],
    "regions": [
      "RU"
    ]
  },
  "QNED85B6B": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "BE",
      "CZ",
      "ES",
      "FR",
      "NL",
      "SE",
      "UK"
    ]
  },
  "QNED85B6C": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ARUG",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "QNED85B6T": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "QNED85B8": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AMVG",
    "sizes": [
      100
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "QNED85BC": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      100
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED85BCA": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED85BS": {
    "series": "QNED85",
    "broadcast": "isdb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AWR",
    "sizes": [
      100
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED85BSG": {
    "series": "QNED85",
    "broadcast": "isdb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CL",
      "CO",
      "PE"
    ]
  },
  "QNED85BUA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED85JQA": {
    "series": "QNED85",
    "broadcast": "arib",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre"
      }
    ]
  },
  "QNED85JRA": {
    "series": "QNED85",
    "broadcast": "arib",
    "machine": "k8hpp",
    "codename": "ombre",
    "otaId": "HE_DTV_W23H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85KQA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED85KRA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "m23",
        "otaId": "HE_DTV_W23M_AFADATAA"
      },
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "machine": "m23",
        "codename": "ombre",
        "otaId": "HE_DTV_W23M_AFADATAA",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "m23",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23M_AFADATAA",
        "swMajor": "33"
      }
    ]
  },
  "QNED85SQA": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "MX",
      "NZ",
      "PE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED85SRA": {
    "series": "QNED85",
    "broadcast": "isdb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85T3A": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50
    ],
    "regions": [
      "AT",
      "DE",
      "HU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85T3C": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "HU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85T6A": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "SE"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85T6C": {
    "series": "QNED85",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85TAA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85TJA": {
    "series": "QNED85",
    "broadcast": "arib",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85TKA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85TSA": {
    "series": "QNED85",
    "broadcast": "isdb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED85TUA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "03"
      }
    ]
  },
  "QNED85TYA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "03"
      }
    ]
  },
  "QNED85UQA": {
    "series": "QNED85",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED863QA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED863RE": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED866QA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED866RE": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED869QA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED86A3A": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED86A3C": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED86A6": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      100
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IN",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "QNED86A6A": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "QNED86A6C": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "QNED86AC": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      100
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED86AGA": {
    "series": "QNED86",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED86AK": {
    "series": "QNED86",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      100
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED86AKA": {
    "series": "QNED86",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k25lp",
        "otaId": "HE_DTV_W25P_AFADATAA"
      }
    ]
  },
  "QNED86AS": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      100
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "ID",
      "MX",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED86ASA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED86AT": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      100
    ],
    "regions": [
      "TW"
    ]
  },
  "QNED86ATA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "TW"
    ]
  },
  "QNED86B3B": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED86B6B": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "machine": "k26",
        "otaId": "HE_DTV_W26H_AFADATAA"
      }
    ]
  },
  "QNED86BK": {
    "series": "QNED86",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      100
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED86BKA": {
    "series": "QNED86",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED86BMA": {
    "series": "QNED86",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED86BS": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      100
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED86BSA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED86BT": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      100
    ],
    "regions": [
      "TW"
    ]
  },
  "QNED86BTA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "TW"
    ]
  },
  "QNED86CRA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED86SQA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".ATRG",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "ID",
      "IN",
      "SG",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED86SRA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "MY",
      "NZ",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED86T3A": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED86T6A": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED86TCA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED86TSA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED86TTA": {
    "series": "QNED86",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED873QB": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED876QB": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "BE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "SE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED876RA": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "ID",
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED879QB": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED87A3B": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED87A3D": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED87A6B": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "SE",
      "UK"
    ]
  },
  "QNED87A6D": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "SE",
      "UK"
    ]
  },
  "QNED87B3": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      100
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED87B3A": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HU"
    ]
  },
  "QNED87B6": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEI",
    "sizes": [
      100
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED87B6A": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "machine": "k26",
        "otaId": "HE_DTV_W26H_AFADATAA"
      }
    ]
  },
  "QNED87T3B": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED87T6B": {
    "series": "QNED87",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED89T6A": {
    "series": "QNED89",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEKQ",
    "sizes": [
      98
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SA",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED89TKA": {
    "series": "QNED89",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      98
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED89TSA": {
    "series": "QNED89",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AAUQ",
    "sizes": [
      98
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "CO",
      "ID",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED89TUA": {
    "series": "QNED89",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      98
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED8EA6B": {
    "series": "QNED8E",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED8EB3A": {
    "series": "QNED8E",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      75,
      85
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED8EB3B": {
    "series": "QNED8E",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "SE",
      "TR"
    ]
  },
  "QNED8EB3F": {
    "series": "QNED8E",
    "broadcast": "dvb",
    "machine": "k25lpn",
    "codename": "queue",
    "otaId": "HE_DTV_W26P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "SE",
      "UK"
    ]
  },
  "QNED8FA6A": {
    "series": "QNED8F",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50
    ],
    "regions": [
      "AT",
      "DE",
      "HU",
      "IT"
    ]
  },
  "QNED8ZASA": {
    "series": "QNED8Z",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ATM",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TH"
    ]
  },
  "QNED90BS": {
    "series": "QNED90",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AWMQ",
    "sizes": [
      115
    ],
    "regions": [
      "MX"
    ]
  },
  "QNED90BSA": {
    "series": "QNED90",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AAUQ",
    "sizes": [
      65,
      75,
      85
    ],
    "regions": [
      "AU",
      "NZ",
      "TH"
    ]
  },
  "QNED90JPA": {
    "series": "QNED90",
    "broadcast": "arib",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "JP"
    ]
  },
  "QNED90JQA": {
    "series": "QNED90",
    "broadcast": "arib",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "IN",
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre"
      }
    ]
  },
  "QNED90KPA": {
    "series": "QNED90",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED90KQA": {
    "series": "QNED90",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED90SPA": {
    "series": "QNED90",
    "broadcast": "isdb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED90SQA": {
    "series": "QNED90",
    "broadcast": "isdb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "IN",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED90TAA": {
    "series": "QNED90",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED90TJA": {
    "series": "QNED90",
    "broadcast": "arib",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED90TSA": {
    "series": "QNED90",
    "broadcast": "isdb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED90TUA": {
    "series": "QNED90",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED90UPA": {
    "series": "QNED90",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED913PA": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "QNED916PA": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED916QA": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AU",
      "BE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PT",
      "SA",
      "SE"
    ]
  },
  "QNED919PA": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "QNED91A6A": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AMVQ",
    "sizes": [
      65,
      75,
      85
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "QNED91AAA": {
    "series": "QNED91",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "US"
    ]
  },
  "QNED91AUA": {
    "series": "QNED91",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".ACCQ",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "CA"
    ]
  },
  "QNED91CPA": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED91SQA": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "IN",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "QNED91T3A": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED91T6A": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED91TKA": {
    "series": "QNED91",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED91TPA": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED91TSA": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "MY",
      "NZ",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED91TTA": {
    "series": "QNED91",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "TW"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "QNED92A6A": {
    "series": "QNED92",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEEQ",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "ES",
      "HU",
      "IT",
      "KZ",
      "PT",
      "SE",
      "UK"
    ]
  },
  "QNED92ACA": {
    "series": "QNED92",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AHKQ",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED92ASA": {
    "series": "QNED92",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".ATSQ",
    "sizes": [
      65,
      75,
      85
    ],
    "regions": [
      "ID",
      "MX",
      "MY",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED92AUA": {
    "series": "QNED92",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      65,
      75,
      85
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "QNED92BU": {
    "series": "QNED92",
    "broadcast": "atsc",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      115
    ],
    "regions": [
      "US"
    ]
  },
  "QNED93A6A": {
    "series": "QNED93",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEEQ",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED93AGA": {
    "series": "QNED93",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED93AKA": {
    "series": "QNED93",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k24n",
        "otaId": "HE_DTV_W25H_AFADATAA",
        "sizes": [
          75
        ]
      }
    ]
  },
  "QNED93ASA": {
    "series": "QNED93",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AAUQ",
    "sizes": [
      65,
      75,
      85
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "QNED93B6": {
    "series": "QNED93",
    "broadcast": "dvb",
    "machine": "k26",
    "codename": "queue",
    "otaId": "HE_DTV_W26H_AFADATAA",
    "suffix": ".AEKQ",
    "sizes": [
      115
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "PT",
      "UK"
    ]
  },
  "QNED93B6A": {
    "series": "QNED93",
    "broadcast": "dvb",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AEEQ",
    "sizes": [
      55,
      65,
      75,
      85
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "FR",
      "IT",
      "KZ",
      "NL",
      "SA",
      "SE",
      "UK"
    ]
  },
  "QNED95KPA": {
    "series": "QNED95",
    "broadcast": "atsc",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED95KQA": {
    "series": "QNED95",
    "broadcast": "atsc",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "QNED963QA": {
    "series": "QNED96",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "ponytail",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "QNED966PA": {
    "series": "QNED96",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "RU",
      "SE"
    ]
  },
  "QNED966QA": {
    "series": "QNED96",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "BE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "QNED969QA": {
    "series": "QNED96",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "ponytail",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "QNED96SQA": {
    "series": "QNED96",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "ponytail",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".ATI",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "ID",
      "SG",
      "TW"
    ],
    "variants": [
      {
        "codename": "mullet",
        "suffix": ".ATT"
      },
      {
        "codename": "number1",
        "suffix": ".ATT"
      },
      {
        "codename": "ombre",
        "suffix": ".ATT"
      }
    ]
  },
  "QNED96TPA": {
    "series": "QNED96",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "NZ"
    ]
  },
  "QNED996PB": {
    "series": "QNED99",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "QNED999PB": {
    "series": "QNED99",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "QNED999QB": {
    "series": "QNED99",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "ponytail",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      86
    ],
    "regions": [
      "ES",
      "HU",
      "IT"
    ]
  },
  "QNED99CPB": {
    "series": "QNED99",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "HK"
    ]
  },
  "QNED99JPA": {
    "series": "QNED99",
    "broadcast": "arib",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      86
    ],
    "regions": [
      "JP"
    ]
  },
  "QNED99KPA": {
    "series": "QNED99",
    "broadcast": "atsc",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "QNED99KQA": {
    "series": "QNED99",
    "broadcast": "atsc",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "QNED99SPA": {
    "series": "QNED99",
    "broadcast": "isdb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED99SQA": {
    "series": "QNED99",
    "broadcast": "isdb",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AWC",
    "sizes": [
      75
    ],
    "regions": [
      "CO",
      "MX"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "QNED99SQB": {
    "series": "QNED99",
    "broadcast": "dvb",
    "machine": "o228k",
    "codename": "mullet",
    "otaId": "HE_DTV_W22K_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "number1"
      },
      {
        "codename": "ombre"
      },
      {
        "codename": "ponytail"
      }
    ]
  },
  "QNED99T9B": {
    "series": "QNED99",
    "broadcast": "dvb",
    "machine": "o22n28k",
    "codename": "ombre",
    "otaId": "HE_DTV_W24K_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "PT",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail"
      }
    ]
  },
  "QNED99TKB": {
    "series": "QNED99",
    "broadcast": "atsc",
    "machine": "o22n28k",
    "codename": "ombre",
    "otaId": "HE_DTV_W24K_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail"
      }
    ]
  },
  "QNED99TPB": {
    "series": "QNED99",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AU",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "QNED99TPZ": {
    "series": "QNED99",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".ATRZ",
    "sizes": [
      86
    ],
    "regions": [
      "IN"
    ]
  },
  "QNED99TSA": {
    "series": "QNED99",
    "broadcast": "isdb",
    "machine": "o22n28k",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24K_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "CO",
      "MX",
      "PE"
    ]
  },
  "QNED99TUA": {
    "series": "QNED99",
    "broadcast": "atsc",
    "machine": "o22n28k",
    "codename": "ombre",
    "otaId": "HE_DTV_W24K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail"
      }
    ]
  },
  "QNED99UPA": {
    "series": "QNED99",
    "broadcast": "atsc",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "QNED99VPA": {
    "series": "QNED99",
    "broadcast": "dvb",
    "machine": "e60n",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21K_AFADATAA",
    "suffix": ".AMI",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "QNED9MA6A": {
    "series": "QNED9M",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AMVG",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "SA"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "QNED9MA6B": {
    "series": "QNED9M",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "PL",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "queue",
        "suffix": ".AEU"
      }
    ]
  },
  "QNED9MAKA": {
    "series": "QNED9M",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "QNED9MASA": {
    "series": "QNED9M",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AWM",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "MX",
      "VN"
    ],
    "variants": [
      {
        "codename": "queue"
      }
    ]
  },
  "QNED9MATA": {
    "series": "QNED9M",
    "broadcast": "dvb",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".ATT",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "TW"
    ]
  },
  "QNED9MAUA": {
    "series": "QNED9M",
    "broadcast": "atsc",
    "machine": "o22n3",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25G_AFABATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "queue"
      },
      {
        "machine": "k25lp",
        "otaId": "HE_DTV_W25P_AFADATAA",
        "suffix": ".ACC"
      }
    ]
  },
  "SJ8000": {
    "series": "SJ80",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W17H_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "SJ800T": {
    "series": "SJ80",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "SJ800V": {
    "series": "SJ80",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "SJ8109": {
    "series": "SJ81",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "SJ810V": {
    "series": "SJ81",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "SJ8500": {
    "series": "SJ85",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W17H_AFADJAAA",
        "suffix": ".AJL",
        "sizes": [
          55,
          60,
          65
        ],
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "SJ8509": {
    "series": "SJ85",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "SJ850A": {
    "series": "SJ85",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "SJ850T": {
    "series": "SJ85",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "SJ850V": {
    "series": "SJ85",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "SJ8570": {
    "series": "SJ85",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "SJ857A": {
    "series": "SJ85",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "SJ930V": {
    "series": "SJ93",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".ADK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "SJ9500": {
    "series": "SJ95",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "SJ9509": {
    "series": "SJ95",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "SJ950T": {
    "series": "SJ95",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "CO",
      "NZ",
      "SG"
    ]
  },
  "SJ950V": {
    "series": "SJ95",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "KZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "SJ9550": {
    "series": "SJ95",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "SJ955T": {
    "series": "SJ95",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      75
    ],
    "regions": [
      "AU",
      "CO",
      "MY",
      "NZ"
    ]
  },
  "SJ955V": {
    "series": "SJ95",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SA",
      "SE",
      "UK"
    ]
  },
  "SJ9570": {
    "series": "SJ95",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      86
    ],
    "regions": [
      "BR",
      "CA",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W17H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "SJ957T": {
    "series": "SJ95",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      86
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "TW",
      "VN"
    ]
  },
  "SJ957V": {
    "series": "SJ95",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "SK7900PLA": {
    "series": "SK79",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR"
    ]
  },
  "SK8000AUB": {
    "series": "SK80",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "SK8000PCA": {
    "series": "SK80",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      55,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "SK8000PJA": {
    "series": "SK80",
    "broadcast": "arib",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      75
    ],
    "regions": [
      "JP"
    ]
  },
  "SK8000PLB": {
    "series": "SK80",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "SK8000PSA": {
    "series": "SK80",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "SK8000PTA": {
    "series": "SK80",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      65,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "SK8000PUA": {
    "series": "SK80",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "SK8000PVA": {
    "series": "SK80",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AMI",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "SK8050PUA": {
    "series": "SK80",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      49,
      55,
      65,
      75
    ],
    "regions": [
      "MX"
    ]
  },
  "SK8070AUB": {
    "series": "SK80",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "SK8070PUA": {
    "series": "SK80",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "SK8100LLA": {
    "series": "SK81",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "SK8100PLA": {
    "series": "SK81",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "SK8100PVA": {
    "series": "SK81",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AMA",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "SK8500LLA": {
    "series": "SK85",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "PL"
    ]
  },
  "SK8500PCA": {
    "series": "SK85",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "SK8500PJA": {
    "series": "SK85",
    "broadcast": "arib",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "SK8500PLA": {
    "series": "SK85",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "SK8500PSA": {
    "series": "SK85",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL"
    ]
  },
  "SK8500PTA": {
    "series": "SK85",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "SK8500PVA": {
    "series": "SK85",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "ID",
      "NZ",
      "SA"
    ]
  },
  "SK8500PWA": {
    "series": "SK85",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".STTWLJK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "SK8550PUA": {
    "series": "SK85",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "SK8900KNA": {
    "series": "SK89",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "SK9000PUA": {
    "series": "SK90",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "SK9500LLA": {
    "series": "SK95",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "SK9500PCA": {
    "series": "SK95",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "SK9500PDA": {
    "series": "SK95",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "SK9500PLA": {
    "series": "SK95",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "SK9500PSA": {
    "series": "SK95",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      65
    ],
    "regions": [
      "PE"
    ]
  },
  "SK9500PTA": {
    "series": "SK95",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "SK9500PUA": {
    "series": "SK95",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "SK9500PVA": {
    "series": "SK95",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "ZA"
    ]
  },
  "SK9550PUA": {
    "series": "SK95",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "SM8000PLA": {
    "series": "SM80",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "RU",
      "TR"
    ]
  },
  "SM8000PSA": {
    "series": "SM80",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "SM8050PLC": {
    "series": "SM80",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "SM8100AUA": {
    "series": "SM81",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "SM8100PJB": {
    "series": "SM81",
    "broadcast": "arib",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "SM8100PSA": {
    "series": "SM81",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "SM8100PTA": {
    "series": "SM81",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "SM8100PUA": {
    "series": "SM81",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "SM8100PVA": {
    "series": "SM81",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "SM8100PWA": {
    "series": "SM81",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".STTYLJK",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "TW"
    ]
  },
  "SM82007LA": {
    "series": "SM82",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "SM8200PLA": {
    "series": "SM82",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "SM8500PLA": {
    "series": "SM85",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "PL",
      "RU",
      "SE",
      "UK"
    ]
  },
  "SM86007LA": {
    "series": "SM86",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "SM8600AUA": {
    "series": "SM86",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "SM8600PCA": {
    "series": "SM86",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "SM8600PJB": {
    "series": "SM86",
    "broadcast": "arib",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      75
    ],
    "regions": [
      "JP"
    ]
  },
  "SM8600PLA": {
    "series": "SM86",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "SM8600PPA": {
    "series": "SM86",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "SM8600PSA": {
    "series": "SM86",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "SM8600PTA": {
    "series": "SM86",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      65,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "SM8600PUA": {
    "series": "SM86",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "SM8600PWA": {
    "series": "SM86",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".STTYLJK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "SM8610PLA": {
    "series": "SM86",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "SM8670AUA": {
    "series": "SM86",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "SM8670PUA": {
    "series": "SM86",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "SM90007LA": {
    "series": "SM90",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "SM9000PCA": {
    "series": "SM90",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      55,
      65,
      75,
      86
    ],
    "regions": [
      "HK"
    ]
  },
  "SM9000PJB": {
    "series": "SM90",
    "broadcast": "arib",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "SM9000PLA": {
    "series": "SM90",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "SM9000PPA": {
    "series": "SM90",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "SM9000PSA": {
    "series": "SM90",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL"
    ]
  },
  "SM9000PUA": {
    "series": "SM90",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "SM9000PVA": {
    "series": "SM90",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "SM9000PWA": {
    "series": "SM90",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".STTYLJK",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "TW"
    ]
  },
  "SM90107LA": {
    "series": "SM90",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "SM9010PLA": {
    "series": "SM90",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "SM9070PDA": {
    "series": "SM90",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      86
    ],
    "regions": [
      "CO"
    ]
  },
  "SM9070PSA": {
    "series": "SM90",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "SM9070PUA": {
    "series": "SM90",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "SM9400PTA": {
    "series": "SM94",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "AU",
      "IN",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "SM9450PTA": {
    "series": "SM94",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "SM9500PSA": {
    "series": "SM95",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      65
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "SM9500PUA": {
    "series": "SM95",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "SM9500PVA": {
    "series": "SM95",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AFB",
    "sizes": [
      65
    ],
    "regions": [
      "ZA"
    ]
  },
  "SM9600KNB": {
    "series": "SM96",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "SM98007LA": {
    "series": "SM98",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "SM9800PLA": {
    "series": "SM98",
    "broadcast": "dvb",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "SM9900PLA": {
    "series": "SM99",
    "broadcast": "dvb",
    "machine": "o18k",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19K_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "SM9900PTA": {
    "series": "SM99",
    "broadcast": "dvb",
    "machine": "o18k",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19K_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      75
    ],
    "regions": [
      "AU",
      "NZ",
      "VN"
    ]
  },
  "SM9970PUA": {
    "series": "SM99",
    "broadcast": "atsc",
    "machine": "o18k",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "SM9980KNB": {
    "series": "SM99",
    "broadcast": "atsc",
    "machine": "o18k",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19K_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UA7000PUB": {
    "series": "UA70",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UA7050PUB": {
    "series": "UA70",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UA7100AUA": {
    "series": "UA71",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ACCQ",
    "sizes": [
      86
    ],
    "regions": [
      "CA"
    ]
  },
  "UA7100AUB": {
    "series": "UA71",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      55,
      75
    ],
    "regions": [
      "US"
    ]
  },
  "UA74003LB": {
    "series": "UA74",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HU"
    ]
  },
  "UA74006LB": {
    "series": "UA74",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UA75003LA": {
    "series": "UA75",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HU"
    ]
  },
  "UA75006LA": {
    "series": "UA75",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "UA75009LA": {
    "series": "UA75",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ARUG",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UA7500ENA": {
    "series": "UA75",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UA7500GNA": {
    "series": "UA75",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UA7500KNA": {
    "series": "UA75",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      50,
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "UA7500PJA": {
    "series": "UA75",
    "broadcast": "arib",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UA7500PSA": {
    "series": "UA75",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWR",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "ID",
      "MX"
    ]
  },
  "UA7500ZUA": {
    "series": "UA75",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "o22n3",
        "otaId": "HE_DTV_W25G_AFABATAA"
      }
    ]
  },
  "UA7510PSC": {
    "series": "UA75",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UA751C0NA": {
    "series": "UA75",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UA7550PCA": {
    "series": "UA75",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "UA7550PSA": {
    "series": "UA75",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ATI",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "ID"
    ]
  },
  "UA7550PTA": {
    "series": "UA75",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "UA7700AUA": {
    "series": "UA77",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "machine": "o22n3",
        "otaId": "HE_DTV_W25G_AFABATAA"
      }
    ]
  },
  "UA7700PUA": {
    "series": "UA77",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "o22n3",
        "otaId": "HE_DTV_W25G_AFABATAA"
      }
    ]
  },
  "UA7900YUA": {
    "series": "UA79",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CA"
    ],
    "variants": [
      {
        "machine": "o22n3",
        "otaId": "HE_DTV_W25G_AFABATAA"
      }
    ]
  },
  "UA80006LC": {
    "series": "UA80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AFKE",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "SA",
      "ZA"
    ]
  },
  "UA8000PSB": {
    "series": "UA80",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "UA8050PSA": {
    "series": "UA80",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75,
      86
    ],
    "regions": [
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "UA8055PSA": {
    "series": "UA80",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AU",
      "CO",
      "MX",
      "MY",
      "NZ",
      "SG",
      "VN"
    ]
  },
  "UA84006LB": {
    "series": "UA84",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".UPEYLWK",
    "sizes": [
      55
    ],
    "regions": [
      "TR"
    ]
  },
  "UA8450PSA": {
    "series": "UA84",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AU",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UA845ZPSA": {
    "series": "UA84",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".ATM",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "TH"
    ]
  },
  "UA85006LA": {
    "series": "UA85",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AFFE",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "SA",
      "TR",
      "ZA"
    ]
  },
  "UA85506LA": {
    "series": "UA85",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      60,
      75
    ],
    "regions": [
      "SA",
      "ZA"
    ]
  },
  "UA8550PSA": {
    "series": "UA85",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75,
      86
    ],
    "regions": [
      "BR"
    ]
  },
  "UA9000AUC": {
    "series": "UA90",
    "broadcast": "atsc",
    "machine": "k24n",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UB8400": {
    "series": "UB84",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "sizes": [
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UB8500": {
    "series": "UB85",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "sizes": [
      49,
      55,
      60
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1H_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_WT1H_AFAAJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UB850T": {
    "series": "UB85",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      60
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "TW",
      "VN",
      "ZA"
    ]
  },
  "UB850V": {
    "series": "UB85",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      60
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UB856V": {
    "series": "UB85",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UB9300": {
    "series": "UB93",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UB930T": {
    "series": "UB93",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".ANR",
    "sizes": [
      65
    ],
    "regions": [
      "AU",
      "ID",
      "NZ",
      "PH",
      "SG",
      "TH",
      "TW"
    ]
  },
  "UB9500": {
    "series": "UB95",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1H_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_WT1H_AFAAJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UB950T": {
    "series": "UB95",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "TW",
      "VN",
      "ZA"
    ]
  },
  "UB950V": {
    "series": "UB95",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UB9800": {
    "series": "UB98",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "sizes": [
      65,
      79,
      84,
      98
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1H_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_WT1H_AFAAJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UB980T": {
    "series": "UB98",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      65,
      79,
      84,
      98
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "TW",
      "VN",
      "ZA"
    ]
  },
  "UB980V": {
    "series": "UB98",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      79,
      84,
      98
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UB9810": {
    "series": "UB98",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "suffix": ".AUS",
    "sizes": [
      98
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UB9850": {
    "series": "UB98",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "sizes": [
      98
    ],
    "regions": [
      "KR"
    ]
  },
  "UC9": {
    "series": "UC9",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "sizes": [
      105
    ],
    "regions": [
      "BR",
      "CL",
      "KR",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_WT1H_AFAAABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "UC9700": {
    "series": "UC97",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AHK",
    "sizes": [
      65
    ],
    "regions": [
      "CL",
      "HK",
      "MX"
    ],
    "variants": [
      {
        "broadcast": "atsc",
        "otaId": "HE_DTV_WT1H_AFAAATAA",
        "suffix": ".AWZ",
        "sizes": [
          55,
          65
        ],
        "regions": [
          "BR",
          "CL",
          "PE"
        ]
      }
    ]
  },
  "UC970T": {
    "series": "UC97",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "NZ",
      "SA",
      "SG",
      "TH",
      "TW",
      "VN",
      "ZA"
    ]
  },
  "UC970V": {
    "series": "UC97",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR"
    ]
  },
  "UC9T": {
    "series": "UC9T",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      105
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "SG",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "UC9V": {
    "series": "UC9V",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AEE",
    "sizes": [
      105
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UF6400": {
    "series": "UF64",
    "broadcast": "atsc",
    "machine": "lm14alite",
    "codename": "beehive",
    "otaId": "HE_DTV_W15B_AFADATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15B_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "UF6407": {
    "series": "UF64",
    "broadcast": "dvb",
    "machine": "lm14alite",
    "codename": "beehive",
    "otaId": "HE_DTV_W15B_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CZ",
      "ES",
      "IT",
      "PL",
      "TR"
    ]
  },
  "UF6409": {
    "series": "UF64",
    "broadcast": "dvb",
    "machine": "lm14alite",
    "codename": "beehive",
    "otaId": "HE_DTV_W15B_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES"
    ]
  },
  "UF640T": {
    "series": "UF64",
    "broadcast": "dvb",
    "machine": "lm14alite",
    "codename": "beehive",
    "otaId": "HE_DTV_W15B_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "UF640V": {
    "series": "UF64",
    "broadcast": "dvb",
    "machine": "lm14alite",
    "codename": "beehive",
    "otaId": "HE_DTV_W15B_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UF6430": {
    "series": "UF64",
    "broadcast": "atsc",
    "machine": "lm14alite",
    "codename": "beehive",
    "otaId": "HE_DTV_W15B_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "US"
    ]
  },
  "UF6450": {
    "series": "UF64",
    "broadcast": "atsc",
    "machine": "lm14alite",
    "codename": "beehive",
    "otaId": "HE_DTV_W15B_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UF645T": {
    "series": "UF64",
    "broadcast": "dvb",
    "machine": "lm14alite",
    "codename": "beehive",
    "otaId": "HE_DTV_W15B_AFADABAA",
    "suffix": ".ATI",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "ID",
      "MY",
      "PH",
      "SG",
      "TH"
    ]
  },
  "UF6790": {
    "series": "UF67",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UF6800": {
    "series": "UF68",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15A_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "UF6807": {
    "series": "UF68",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "IT",
      "PL",
      "TR"
    ]
  },
  "UF6809": {
    "series": "UF68",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UF680T": {
    "series": "UF68",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "UF680V": {
    "series": "UF68",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UF6857": {
    "series": "UF68",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "CZ",
      "PL"
    ]
  },
  "UF6859": {
    "series": "UF68",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UF685V": {
    "series": "UF68",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR"
    ]
  },
  "UF6900": {
    "series": "UF69",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W15U_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UF6907": {
    "series": "UF69",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CZ",
      "DE",
      "ES",
      "HU",
      "PL",
      "PT"
    ]
  },
  "UF6909": {
    "series": "UF69",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "DE",
      "PL"
    ]
  },
  "UF690T": {
    "series": "UF69",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "CO",
      "ID",
      "IN",
      "MY",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UF690V": {
    "series": "UF69",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "UF7300": {
    "series": "UF73",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      60,
      70
    ],
    "regions": [
      "BR",
      "CA",
      "MX",
      "PE",
      "US"
    ]
  },
  "UF7400": {
    "series": "UF74",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "UF7480": {
    "series": "UF74",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "sizes": [
      70
    ],
    "regions": [
      "KR"
    ]
  },
  "UF7600": {
    "series": "UF76",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "suffix": ".AUST",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "MX",
      "US"
    ]
  },
  "UF7650": {
    "series": "UF76",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      60,
      65,
      70
    ],
    "regions": [
      "CA"
    ]
  },
  "UF7690": {
    "series": "UF76",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UF7700": {
    "series": "UF77",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      65,
      70,
      79
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "PH",
      "US",
      "VN"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "machine": "lm14a",
        "otaId": "HE_DTV_W15A_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15U_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "machine": "lm14a",
        "otaId": "HE_DTV_W15A_AFADATAA",
        "suffix": ".AWZ"
      }
    ]
  },
  "UF7707": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      40,
      43,
      49,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "PL",
      "PT",
      "RU"
    ]
  },
  "UF7709": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55,
      60,
      65,
      79
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA"
      }
    ]
  },
  "UF770T": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      65,
      70,
      79
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SA",
      "SG",
      "TH",
      "TW",
      "VN",
      "ZA"
    ],
    "variants": [
      {
        "machine": "lm14a",
        "otaId": "HE_DTV_W15A_AFADABAA",
        "suffix": ".AWC"
      }
    ]
  },
  "UF770V": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      65,
      79
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA",
        "sizes": [
          43,
          49,
          55,
          60,
          65,
          70,
          79
        ],
        "regions": [
          "AT",
          "AU",
          "BE",
          "DE",
          "ES",
          "NL",
          "NZ",
          "PL",
          "PT",
          "SE",
          "UK"
        ]
      }
    ]
  },
  "UF7710": {
    "series": "UF77",
    "broadcast": "arib",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "JP"
    ]
  },
  "UF771V": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".ADGZ",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      70
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA",
        "suffix": ".ARU"
      }
    ]
  },
  "UF7727": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      40,
      43,
      49,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA"
      }
    ]
  },
  "UF7729": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      65,
      70
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ],
    "variants": [
      {
        "machine": "lm14a",
        "otaId": "HE_DTV_W15A_AFADABAA"
      }
    ]
  },
  "UF772T": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43
    ],
    "regions": [
      "IN"
    ]
  },
  "UF772V": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60,
      65,
      70
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA",
        "sizes": [
          40,
          43,
          49,
          55,
          60,
          65,
          70
        ]
      }
    ]
  },
  "UF7767": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      40,
      43,
      49,
      55
    ],
    "regions": [
      "CZ",
      "IT",
      "PL"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA"
      }
    ]
  },
  "UF7769": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ],
    "variants": [
      {
        "machine": "lm14a",
        "otaId": "HE_DTV_W15A_AFADABAA"
      }
    ]
  },
  "UF776V": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "IT",
      "NL",
      "PL",
      "PT"
    ],
    "variants": [
      {
        "machine": "lm14a",
        "otaId": "HE_DTV_W15A_AFADABAA"
      }
    ]
  },
  "UF7780": {
    "series": "UF77",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      70
    ],
    "regions": [
      "KR"
    ]
  },
  "UF7787": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      40,
      43,
      49,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "PL",
      "TR"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA"
      }
    ]
  },
  "UF7789": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UF778V": {
    "series": "UF77",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      40,
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "PL",
      "PT",
      "ZA"
    ],
    "variants": [
      {
        "machine": "lm14a",
        "otaId": "HE_DTV_W15A_AFADABAA",
        "suffix": ".AEU",
        "regions": [
          "AT",
          "DE",
          "ES",
          "FR",
          "HU",
          "PL",
          "PT",
          "TR"
        ]
      }
    ]
  },
  "UF7790": {
    "series": "UF77",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      79
    ],
    "regions": [
      "KR"
    ]
  },
  "UF8007": {
    "series": "UF80",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL",
      "PT"
    ]
  },
  "UF8009": {
    "series": "UF80",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "DE"
    ]
  },
  "UF800V": {
    "series": "UF80",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "NL",
      "PL",
      "PT",
      "SE"
    ]
  },
  "UF8300": {
    "series": "UF83",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "sizes": [
      50,
      58
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "US"
    ]
  },
  "UF8307": {
    "series": "UF83",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      50,
      58
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "PL"
    ]
  },
  "UF830T": {
    "series": "UF83",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      50,
      58
    ],
    "regions": [
      "AE",
      "AU",
      "ID",
      "NZ",
      "PH",
      "SA",
      "TH",
      "VN"
    ]
  },
  "UF830V": {
    "series": "UF83",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      58
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UF8400": {
    "series": "UF84",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "KR",
      "MX"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15A_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "UF8407": {
    "series": "UF84",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "ES",
      "PL"
    ]
  },
  "UF8409": {
    "series": "UF84",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UF840V": {
    "series": "UF84",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "BE",
      "ES",
      "FR",
      "NL",
      "SE"
    ]
  },
  "UF8500": {
    "series": "UF85",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15U_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W15U_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UF8507": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "IT",
      "PL",
      "PT",
      "RU",
      "TR"
    ]
  },
  "UF8509": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "DE"
    ]
  },
  "UF850T": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "UF850V": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UF8517": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "PL"
    ]
  },
  "UF8519": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UF851V": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "NL",
      "PL",
      "PT",
      "SE"
    ]
  },
  "UF8527": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UF8529": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UF852V": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "NL",
      "PL",
      "PT",
      "SE"
    ]
  },
  "UF8537": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "RU"
    ]
  },
  "UF853V": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "RU"
    ]
  },
  "UF8557": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "PL"
    ]
  },
  "UF8559": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UF855V": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "PL",
      "SE"
    ]
  },
  "UF8567": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "CZ",
      "PL"
    ]
  },
  "UF8569": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UF856V": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      60,
      65
    ],
    "regions": [
      "CZ",
      "PL"
    ]
  },
  "UF8570": {
    "series": "UF85",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UF8577": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "AT",
      "CZ",
      "PL"
    ]
  },
  "UF8579": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "UF857V": {
    "series": "UF85",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "PL",
      "SE"
    ]
  },
  "UF8600": {
    "series": "UF86",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR",
      "US"
    ]
  },
  "UF8607": {
    "series": "UF86",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      55
    ],
    "regions": [
      "CZ",
      "ES",
      "PL"
    ]
  },
  "UF8609": {
    "series": "UF86",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65,
      79
    ],
    "regions": [
      "DE",
      "PL"
    ]
  },
  "UF860T": {
    "series": "UF86",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".ATA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UF860V": {
    "series": "UF86",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65,
      79
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UF9400": {
    "series": "UF94",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UF9450": {
    "series": "UF94",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      79
    ],
    "regions": [
      "KR"
    ]
  },
  "UF9500": {
    "series": "UF95",
    "broadcast": "atsc",
    "machine": "h15",
    "codename": "beehive",
    "otaId": "HE_DTV_W15H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADATAA",
        "suffix": ".AUS",
        "sizes": [
          79
        ]
      },
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W15H_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "dvb",
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA",
        "suffix": ".AHK",
        "sizes": [
          79
        ],
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W15H_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UF9509": {
    "series": "UF95",
    "broadcast": "dvb",
    "machine": "h15",
    "codename": "beehive",
    "otaId": "HE_DTV_W15H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "DE"
    ]
  },
  "UF950T": {
    "series": "UF95",
    "broadcast": "dvb",
    "machine": "h15",
    "codename": "beehive",
    "otaId": "HE_DTV_W15H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "TW",
      "ZA"
    ],
    "variants": [
      {
        "machine": "lm15u",
        "otaId": "HE_DTV_W15U_AFADABAA",
        "sizes": [
          79
        ],
        "regions": [
          "AU",
          "ID",
          "IN",
          "NZ",
          "PH",
          "SG",
          "VN",
          "ZA"
        ]
      }
    ]
  },
  "UF950V": {
    "series": "UF95",
    "broadcast": "dvb",
    "machine": "h15",
    "codename": "beehive",
    "otaId": "HE_DTV_W15H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UG8700": {
    "series": "UG87",
    "broadcast": "atsc",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "PH",
      "VN"
    ]
  },
  "UG8709": {
    "series": "UG87",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "DE",
      "PL"
    ]
  },
  "UG870T": {
    "series": "UG87",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "ID",
      "NZ",
      "PH",
      "SA",
      "SG",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "UG870V": {
    "series": "UG87",
    "broadcast": "dvb",
    "machine": "lm15u",
    "codename": "beehive",
    "otaId": "HE_DTV_W15U_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UG8800": {
    "series": "UG88",
    "broadcast": "atsc",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAATAA",
    "sizes": [
      79
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "KR",
      "MX",
      "PE"
    ]
  },
  "UG880T": {
    "series": "UG88",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AAU",
    "sizes": [
      79
    ],
    "regions": [
      "AE",
      "AU",
      "CO",
      "NZ",
      "VN",
      "ZA"
    ]
  },
  "UG880V": {
    "series": "UG88",
    "broadcast": "dvb",
    "machine": "goldfinger",
    "codename": "afro",
    "otaId": "HE_DTV_WT1H_AFAAABAA",
    "suffix": ".AEE",
    "sizes": [
      79
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "IT",
      "PL",
      "PT",
      "SE",
      "TR"
    ]
  },
  "UH5500": {
    "series": "UH55",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      50,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UH5530": {
    "series": "UH55",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      50
    ],
    "regions": [
      "US"
    ]
  },
  "UH6000": {
    "series": "UH60",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".BWZ",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR"
    ]
  },
  "UH600T": {
    "series": "UH60",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN",
      "ZA"
    ]
  },
  "UH600V": {
    "series": "UH60",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "ZA"
    ]
  },
  "UH6010": {
    "series": "UH60",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "sizes": [
      50,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6030": {
    "series": "UH60",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ]
  },
  "UH6035": {
    "series": "UH60",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      60
    ],
    "regions": [
      "US"
    ]
  },
  "UH603T": {
    "series": "UH60",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CO"
    ]
  },
  "UH603V": {
    "series": "UH60",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "UH605T": {
    "series": "UH60",
    "broadcast": "dvb",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "UH605V": {
    "series": "UH60",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      60
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UH6070": {
    "series": "UH60",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "sizes": [
      50,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6080": {
    "series": "UH60",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "sizes": [
      50,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6090": {
    "series": "UH60",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      49,
      55,
      60
    ],
    "regions": [
      "US"
    ]
  },
  "UH6100": {
    "series": "UH61",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16P_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W16P_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UH6107": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UH6109": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UH610A": {
    "series": "UH61",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "US"
    ]
  },
  "UH610T": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UH610V": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UH6110": {
    "series": "UH61",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "PE"
    ]
  },
  "UH6150": {
    "series": "UH61",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16P_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "UH6157": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "SE"
    ]
  },
  "UH6159": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UH615A": {
    "series": "UH61",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UH615T": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH"
    ]
  },
  "UH615V": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UH617T": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "IN",
      "MY",
      "VN"
    ]
  },
  "UH617V": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AMI",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "VN",
      "ZA"
    ]
  },
  "UH619V": {
    "series": "UH61",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".ARUB",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "RU"
    ]
  },
  "UH6200": {
    "series": "UH62",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6207": {
    "series": "UH62",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UH620V": {
    "series": "UH62",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UH6210": {
    "series": "UH62",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6211": {
    "series": "UH62",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6230": {
    "series": "UH62",
    "broadcast": "atsc",
    "machine": "lm14a",
    "codename": "beehive",
    "otaId": "HE_DTV_W15A_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "CL",
      "MX",
      "PE"
    ]
  },
  "UH6250": {
    "series": "UH62",
    "broadcast": "atsc",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADATAA",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6257": {
    "series": "UH62",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "UH625V": {
    "series": "UH62",
    "broadcast": "dvb",
    "machine": "k2lp",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UH6300": {
    "series": "UH63",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      58
    ],
    "regions": [
      "BR",
      "CL",
      "MX",
      "PE",
      "US"
    ]
  },
  "UH630V": {
    "series": "UH63",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      40,
      50,
      58
    ],
    "regions": [
      "AE",
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "UH6330": {
    "series": "UH63",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70
    ],
    "regions": [
      "US"
    ]
  },
  "UH6350": {
    "series": "UH63",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ]
  },
  "UH635T": {
    "series": "UH63",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      70
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "NZ",
      "VN"
    ]
  },
  "UH635V": {
    "series": "UH63",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      50,
      58
    ],
    "regions": [
      "AE",
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "PL",
      "PT",
      "SA",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "machine": "k2l",
        "otaId": "HE_DTV_W16K_AFADABAA",
        "suffix": ".AFB",
        "sizes": [
          70
        ],
        "regions": [
          "ZA"
        ]
      }
    ]
  },
  "UH6500": {
    "series": "UH65",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "suffix": ".AUSS",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16N_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W16N_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UH6507": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "UH6509": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UH650T": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "ID",
      "IN",
      "MY",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UH650V": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UH651V": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "KZ",
      "NZ",
      "RU",
      "SA"
    ]
  },
  "UH652T": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "UH652V": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      49,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "UH6550": {
    "series": "UH65",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "suffix": ".AUSS",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ],
    "variants": [
      {
        "machine": "m16",
        "otaId": "HE_DTV_W16M_AFADATAA",
        "sizes": [
          75
        ],
        "regions": [
          "BR",
          "CL",
          "PE",
          "US"
        ]
      }
    ]
  },
  "UH655V": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AMI",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UH6560": {
    "series": "UH65",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      75
    ],
    "regions": [
      "PH"
    ]
  },
  "UH656T": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      75
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "NZ",
      "SG",
      "VN"
    ]
  },
  "UH656V": {
    "series": "UH65",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".ARUB",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "RU"
    ]
  },
  "UH6600": {
    "series": "UH66",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "sizes": [
      50,
      58
    ],
    "regions": [
      "KR"
    ]
  },
  "UH661V": {
    "series": "UH66",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UH664V": {
    "series": "UH66",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "PL",
      "PT",
      "SE",
      "TR"
    ]
  },
  "UH6650": {
    "series": "UH66",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "sizes": [
      40
    ],
    "regions": [
      "KR"
    ]
  },
  "UH668V": {
    "series": "UH66",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UH671V": {
    "series": "UH67",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".ARUB",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "UH676V": {
    "series": "UH67",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".ADK",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "UH6800": {
    "series": "UH68",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6810": {
    "series": "UH68",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6850": {
    "series": "UH68",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6870": {
    "series": "UH68",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH6880": {
    "series": "UH68",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH700V": {
    "series": "UH70",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      70
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "NL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UH7500": {
    "series": "UH75",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "CA"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16N_AFADABAA",
        "suffix": ".AHK",
        "sizes": [
          43,
          49,
          55,
          60
        ],
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W16N_AFADJAAA",
        "suffix": ".AJL",
        "sizes": [
          43,
          49,
          55,
          60
        ],
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UH7507": {
    "series": "UH75",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "UH7509": {
    "series": "UH75",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES"
    ]
  },
  "UH750T": {
    "series": "UH75",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      55
    ],
    "regions": [
      "IN",
      "VN"
    ]
  },
  "UH750V": {
    "series": "UH75",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK"
    ]
  },
  "UH755V": {
    "series": "UH75",
    "broadcast": "dvb",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADABAA",
    "suffix": ".ARUB",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "RU",
      "SA"
    ]
  },
  "UH7600": {
    "series": "UH76",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH7650": {
    "series": "UH76",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ]
  },
  "UH7670": {
    "series": "UH76",
    "broadcast": "atsc",
    "machine": "m16lite",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16N_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH7700": {
    "series": "UH77",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16K_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W16K_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UH7707": {
    "series": "UH77",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UH7709": {
    "series": "UH77",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "PL"
    ]
  },
  "UH770T": {
    "series": "UH77",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UH770V": {
    "series": "UH77",
    "broadcast": "dvb",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UH780V": {
    "series": "UH78",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      75
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "IT",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UH7900": {
    "series": "UH79",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH7920": {
    "series": "UH79",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH8500": {
    "series": "UH85",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      60,
      65,
      75
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16M_AFADABAA",
        "suffix": ".AHK",
        "sizes": [
          49,
          55,
          65
        ],
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W16M_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UH8507": {
    "series": "UH85",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UH8509": {
    "series": "UH85",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UH850T": {
    "series": "UH85",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "IN",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UH850V": {
    "series": "UH85",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UH8550": {
    "series": "UH85",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      75
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "broadcast": "atsc",
        "otaId": "HE_DTV_W16M_AFADATAA",
        "suffix": ".AWF",
        "regions": [
          "PE"
        ]
      }
    ]
  },
  "UH855T": {
    "series": "UH85",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      75
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH"
    ]
  },
  "UH855V": {
    "series": "UH85",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UH8700": {
    "series": "UH87",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH8730": {
    "series": "UH87",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "sizes": [
      70
    ],
    "regions": [
      "KR"
    ]
  },
  "UH8750": {
    "series": "UH87",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "sizes": [
      70
    ],
    "regions": [
      "KR"
    ]
  },
  "UH8770": {
    "series": "UH87",
    "broadcast": "atsc",
    "machine": "k2l",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16K_AFADATAA",
    "sizes": [
      70
    ],
    "regions": [
      "KR"
    ]
  },
  "UH9300": {
    "series": "UH93",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH9350": {
    "series": "UH93",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UH9500": {
    "series": "UH95",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65,
      86
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "otaId": "HE_DTV_W16M_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "UH950T": {
    "series": "UH95",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "CO",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UH950V": {
    "series": "UH95",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UH953T": {
    "series": "UH95",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      79
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "NZ",
      "SG"
    ]
  },
  "UH953V": {
    "series": "UH95",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AMI",
    "sizes": [
      79
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UH9550": {
    "series": "UH95",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      86
    ],
    "regions": [
      "HK",
      "PH"
    ],
    "variants": [
      {
        "broadcast": "atsc",
        "otaId": "HE_DTV_W16M_AFADATAA",
        "suffix": ".AWZ",
        "regions": [
          "BR",
          "CL",
          "PE"
        ]
      }
    ]
  },
  "UH955T": {
    "series": "UH95",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      86
    ],
    "regions": [
      "AU",
      "CO",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UH955V": {
    "series": "UH95",
    "broadcast": "dvb",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UH9600": {
    "series": "UH96",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UH9640": {
    "series": "UH96",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "sizes": [
      79
    ],
    "regions": [
      "KR"
    ]
  },
  "UH9650": {
    "series": "UH96",
    "broadcast": "atsc",
    "machine": "m16",
    "codename": "dreadlocks",
    "otaId": "HE_DTV_W16M_AFADATAA",
    "sizes": [
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ6050": {
    "series": "UJ60",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      60
    ],
    "regions": [
      "US"
    ]
  },
  "UJ6100": {
    "series": "UJ61",
    "broadcast": "arib",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "JP"
    ]
  },
  "UJ6200": {
    "series": "UJ62",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "CA",
      "CL",
      "KR",
      "MX",
      "PE",
      "US"
    ]
  },
  "UJ620T": {
    "series": "UJ62",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CO"
    ]
  },
  "UJ620V": {
    "series": "UJ62",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEUQ",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "PL",
      "PT",
      "RU",
      "ZA"
    ]
  },
  "UJ6220": {
    "series": "UJ62",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ6260": {
    "series": "UJ62",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ6300": {
    "series": "UJ63",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CA",
      "CL",
      "MX",
      "PE",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "machine": "k3lp",
        "otaId": "HE_DTV_W17P_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "UJ6307": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "UJ6309": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UJ630A": {
    "series": "UJ63",
    "broadcast": "arib",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UJ630T": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".ATS",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CO",
      "MY",
      "TH"
    ]
  },
  "UJ630V": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UJ632T": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "ID",
      "IN",
      "MY",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UJ633T": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".ATV",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "VN"
    ]
  },
  "UJ634T": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "UJ634V": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "UJ635T": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CO"
    ]
  },
  "UJ635V": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UJ639V": {
    "series": "UJ63",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "RU"
    ]
  },
  "UJ6450": {
    "series": "UJ64",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "UJ6470": {
    "series": "UJ64",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "UJ6500": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "machine": "k3lp",
        "otaId": "HE_DTV_W17P_AFADABAA",
        "suffix": ".AHK",
        "sizes": [
          43,
          49,
          55,
          60
        ],
        "regions": [
          "HK"
        ]
      },
      {
        "broadcast": "arib",
        "machine": "k3lp",
        "otaId": "HE_DTV_W17P_AFADJAAA",
        "suffix": ".AJL",
        "sizes": [
          43,
          49,
          55,
          60
        ],
        "regions": [
          "JP"
        ]
      }
    ]
  },
  "UJ6510": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "UJ6517": {
    "series": "UJ65",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "PL"
    ]
  },
  "UJ6519": {
    "series": "UJ65",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UJ651T": {
    "series": "UJ65",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AWP",
    "sizes": [
      49
    ],
    "regions": [
      "CO"
    ]
  },
  "UJ651V": {
    "series": "UJ65",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UJ6520": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      43,
      49,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "MX",
      "PH"
    ]
  },
  "UJ6525": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR"
    ]
  },
  "UJ652T": {
    "series": "UJ65",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "ID",
      "IN",
      "MY",
      "TH",
      "VN"
    ]
  },
  "UJ6540": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UJ6545": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "BR"
    ]
  },
  "UJ654T": {
    "series": "UJ65",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AU",
      "NZ",
      "TH"
    ]
  },
  "UJ654V": {
    "series": "UJ65",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AU",
      "NZ",
      "SG"
    ]
  },
  "UJ655V": {
    "series": "UJ65",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "RU"
    ]
  },
  "UJ6560": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CL",
      "MX",
      "PE"
    ]
  },
  "UJ6565": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR"
    ]
  },
  "UJ6570": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "CA",
      "PH",
      "US"
    ],
    "variants": [
      {
        "broadcast": "dvb",
        "machine": "k3lp",
        "otaId": "HE_DTV_W17P_AFADABAA",
        "suffix": ".AHK",
        "regions": [
          "HK"
        ]
      }
    ]
  },
  "UJ657A": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UJ657T": {
    "series": "UJ65",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UJ6580": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "CL",
      "MX",
      "PE"
    ]
  },
  "UJ6585": {
    "series": "UJ65",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "BR"
    ]
  },
  "UJ6600": {
    "series": "UJ66",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ6620": {
    "series": "UJ66",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ6640": {
    "series": "UJ66",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ6680": {
    "series": "UJ66",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ670V": {
    "series": "UJ67",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK",
      "ZA"
    ]
  },
  "UJ675V": {
    "series": "UJ67",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SA",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UJ701V": {
    "series": "UJ70",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UJ7220": {
    "series": "UJ72",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ7240": {
    "series": "UJ72",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ7250": {
    "series": "UJ72",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ7260": {
    "series": "UJ72",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ7270": {
    "series": "UJ72",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ7290": {
    "series": "UJ72",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ740V": {
    "series": "UJ74",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".ADR",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "RU"
    ]
  },
  "UJ7500": {
    "series": "UJ75",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "broadcast": "arib",
        "otaId": "HE_DTV_W17H_AFADJAAA",
        "suffix": ".AJL",
        "regions": [
          "JP"
        ]
      },
      {
        "broadcast": "atsc",
        "otaId": "HE_DTV_W17H_AFADATAA",
        "suffix": ".AWZ",
        "regions": [
          "BR",
          "CL",
          "PE",
          "PH"
        ]
      }
    ]
  },
  "UJ7507": {
    "series": "UJ75",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UJ7509": {
    "series": "UJ75",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ]
  },
  "UJ750T": {
    "series": "UJ75",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".ATC",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "ID",
      "SG",
      "VN"
    ]
  },
  "UJ750V": {
    "series": "UJ75",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UJ752T": {
    "series": "UJ75",
    "broadcast": "dvb",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "IN",
      "NZ"
    ]
  },
  "UJ760R": {
    "series": "UJ76",
    "broadcast": "atsc",
    "machine": "m16plite",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17M_AFADATAA",
    "sizes": [
      48
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ7700": {
    "series": "UJ77",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UJ7750": {
    "series": "UJ77",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UJ7800": {
    "series": "UJ78",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ7860": {
    "series": "UJ78",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ8800": {
    "series": "UJ88",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ9400": {
    "series": "UJ94",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ9800": {
    "series": "UJ98",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ9810": {
    "series": "UJ98",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ9860": {
    "series": "UJ98",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UJ9870": {
    "series": "UJ98",
    "broadcast": "atsc",
    "machine": "m16p",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17H_AFADATAA",
    "sizes": [
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6090PUA": {
    "series": "UK60",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      50,
      55,
      60,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UK6100PLA": {
    "series": "UK61",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".ADK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "UK6100PLB": {
    "series": "UK61",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR"
    ]
  },
  "UK6100PTA": {
    "series": "UK61",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "PH",
      "TH",
      "VN"
    ]
  },
  "UK6100PVA": {
    "series": "UK61",
    "broadcast": "dvb",
    "machine": "k3lp",
    "codename": "dreadlocks2",
    "otaId": "HE_DTV_W17P_AFADABAA",
    "suffix": ".AFB",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UK6190PUB": {
    "series": "UK61",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UK6200BNA": {
    "series": "UK62",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      43,
      49,
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6200ENA": {
    "series": "UK62",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6200GNA": {
    "series": "UK62",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6200KNB": {
    "series": "UK62",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6200PCA": {
    "series": "UK62",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "HK"
    ]
  },
  "UK6200PDA": {
    "series": "UK62",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      43,
      49,
      60
    ],
    "regions": [
      "CO"
    ]
  },
  "UK6200PJA": {
    "series": "UK62",
    "broadcast": "arib",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      60
    ],
    "regions": [
      "JP"
    ]
  },
  "UK6200PLA": {
    "series": "UK62",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UK6200PLB": {
    "series": "UK62",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UK6200PSA": {
    "series": "UK62",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "UK6200PTA": {
    "series": "UK62",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      60
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "TH",
      "VN"
    ]
  },
  "UK6200PUA": {
    "series": "UK62",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UK6200PVA": {
    "series": "UK62",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AFB",
    "sizes": [
      55
    ],
    "regions": [
      "ZA"
    ]
  },
  "UK6250PUB": {
    "series": "UK62",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "MX"
    ]
  },
  "UK6300BUB": {
    "series": "UK63",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UK6300LLB": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "PL"
    ]
  },
  "UK6300MLB": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UK6300PCD": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "UK6300PDB": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CO"
    ]
  },
  "UK6300PJF": {
    "series": "UK63",
    "broadcast": "arib",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UK6300PLB": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UK6300PPB": {
    "series": "UK63",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "PH"
    ]
  },
  "UK6300PPE": {
    "series": "UK63",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "UK6300PSB": {
    "series": "UK63",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      43,
      49,
      50
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "UK6300PTE": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ATI",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "ID",
      "MY",
      "PH",
      "TH",
      "VN"
    ]
  },
  "UK6300PUE": {
    "series": "UK63",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UK6300PVB": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AMA",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "TR",
      "ZA"
    ]
  },
  "UK6310PSE": {
    "series": "UK63",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".BWZ",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "BR"
    ]
  },
  "UK6320PTE": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ATS",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "MY",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UK6340PTF": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ",
      "VN"
    ]
  },
  "UK6350PSC": {
    "series": "UK63",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "UK6360PSF": {
    "series": "UK63",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55
    ],
    "regions": [
      "BR"
    ]
  },
  "UK6360PTE": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "UK6390PLG": {
    "series": "UK63",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ADR",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "RU"
    ]
  },
  "UK6400EJC": {
    "series": "UK64",
    "broadcast": "arib",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      50
    ],
    "regions": [
      "JP"
    ]
  },
  "UK6400PLF": {
    "series": "UK64",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "SE",
      "TR",
      "UK",
      "ZA"
    ]
  },
  "UK6400PVC": {
    "series": "UK64",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "SG",
      "ZA"
    ]
  },
  "UK6410PLC": {
    "series": "UK64",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ADK",
    "sizes": [
      50
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UK6450PLC": {
    "series": "UK64",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ADGZ",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UK6470PLC": {
    "series": "UK64",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UK6500AUA": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UK6500EJD": {
    "series": "UK65",
    "broadcast": "arib",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UK6500LLA": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "PL"
    ]
  },
  "UK6500MLA": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "HU",
      "PL"
    ]
  },
  "UK6500PCB": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "UK6500PCC": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "HK"
    ]
  },
  "UK6500PDA": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      50
    ],
    "regions": [
      "CO"
    ]
  },
  "UK6500PLA": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADABAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UK6500PLB": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      70
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UK6500PPB": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "PH"
    ]
  },
  "UK6500PPC": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "UK6500PTB": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      75
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "TH"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADABAA",
        "sizes": [
          86
        ],
        "regions": [
          "AU",
          "ID",
          "MY",
          "NZ",
          "SG",
          "VN"
        ]
      }
    ]
  },
  "UK6500PTC": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "ID",
      "IN",
      "MY",
      "SG",
      "TH"
    ]
  },
  "UK6500PVA": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AMA",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "UK6500PWB": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADABAA",
    "suffix": ".ATT",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "TW"
    ]
  },
  "UK6500PWC": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".STTWLJK",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "UK6510PLB": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ADK",
    "sizes": [
      43,
      50,
      55
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "UK6510PSF": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "BR"
    ]
  },
  "UK6520PSA": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      75
    ],
    "regions": [
      "BR"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UK6530PSF": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR"
    ]
  },
  "UK6540PSA": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      70
    ],
    "regions": [
      "BR"
    ]
  },
  "UK6540PSB": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR"
    ]
  },
  "UK6540PTA": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      70
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UK6540PTD": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AU",
      "ID",
      "NZ",
      "TH",
      "VN"
    ]
  },
  "UK6550PCD": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "UK6550PLD": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      50,
      55
    ],
    "regions": [
      "RU"
    ]
  },
  "UK6550PSA": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      70
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "UK6550PSB": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "UK6550PUB": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UK6560PTC": {
    "series": "UK65",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "IN"
    ]
  },
  "UK6570AUA": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UK6570AUB": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UK6570PSA": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      75
    ],
    "regions": [
      "PE"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADATAA",
        "sizes": [
          86
        ],
        "regions": [
          "CL",
          "PE"
        ]
      }
    ]
  },
  "UK6570PUA": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      75
    ],
    "regions": [
      "MX"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UK6570PUB": {
    "series": "UK65",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "MX",
      "US"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UK6700PVD": {
    "series": "UK67",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "SG",
      "ZA"
    ]
  },
  "UK6710PLA": {
    "series": "UK67",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ADG",
    "sizes": [
      70
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "UK6710PLB": {
    "series": "UK67",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "UK6750PLB": {
    "series": "UK67",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ADG",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADABAA",
        "suffix": ".ADR",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UK6750PLD": {
    "series": "UK67",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UK6780PTE": {
    "series": "UK67",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43
    ],
    "regions": [
      "IN"
    ]
  },
  "UK6800BNC": {
    "series": "UK68",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      50
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6800GNC": {
    "series": "UK68",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      43,
      49,
      50,
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6800HNC": {
    "series": "UK68",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6820ENF": {
    "series": "UK68",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6860BNF": {
    "series": "UK68",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UK6950PLA": {
    "series": "UK69",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      70
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UK6950PLB": {
    "series": "UK69",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UK7000PVA": {
    "series": "UK70",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AMA",
    "sizes": [
      70
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UK7050PVA": {
    "series": "UK70",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AMA",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADABAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UK7400KNA": {
    "series": "UK74",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "m16pp",
        "otaId": "HE_DTV_W18H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UK7460BND": {
    "series": "UK74",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "UK7460GND": {
    "series": "UK74",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      55
    ],
    "regions": [
      "KR"
    ]
  },
  "UK7460KND": {
    "series": "UK74",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      43
    ],
    "regions": [
      "KR"
    ]
  },
  "UK7500PCA": {
    "series": "UK75",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "UK7500PJA": {
    "series": "UK75",
    "broadcast": "arib",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UK7500PLC": {
    "series": "UK75",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "RU"
    ]
  },
  "UK7500PSA": {
    "series": "UK75",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "UK7500PTA": {
    "series": "UK75",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "IN",
      "MY",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UK7500PUA": {
    "series": "UK75",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UK7500PVA": {
    "series": "UK75",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UK7550LLA": {
    "series": "UK75",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "UK7550MLA": {
    "series": "UK75",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEE",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UK7550PLA": {
    "series": "UK75",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UK7550PTA": {
    "series": "UK75",
    "broadcast": "dvb",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "UK7570PUB": {
    "series": "UK75",
    "broadcast": "atsc",
    "machine": "m16pp",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      86
    ],
    "regions": [
      "US"
    ]
  },
  "UK7700AUB": {
    "series": "UK77",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UK7700PUD": {
    "series": "UK77",
    "broadcast": "atsc",
    "machine": "lm18a",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UK7800KNA": {
    "series": "UK78",
    "broadcast": "atsc",
    "machine": "m16pplite",
    "codename": "goldilocks",
    "otaId": "HE_DTV_W18M_AFADATAA",
    "sizes": [
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UM6900PUA": {
    "series": "UM69",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      49,
      50,
      60,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UM6910PUC": {
    "series": "UM69",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UM6950DUB": {
    "series": "UM69",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UM6970PUA": {
    "series": "UM69",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UM6970PUB": {
    "series": "UM69",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UM7000PLA": {
    "series": "UM70",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UM7000PLC": {
    "series": "UM70",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UM7020PLA": {
    "series": "UM70",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      75
    ],
    "regions": [
      "RU"
    ]
  },
  "UM7020PLF": {
    "series": "UM70",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "RU"
    ]
  },
  "UM7050PLA": {
    "series": "UM70",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UM7050PLC": {
    "series": "UM70",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UM7050PLF": {
    "series": "UM70",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UM7090PLA": {
    "series": "UM70",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      49,
      75
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "UM71007LB": {
    "series": "UM71",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "UM7100DUA": {
    "series": "UM71",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      60
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UM7100KNB": {
    "series": "UM71",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UM7100PCA": {
    "series": "UM71",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "UM7100PJA": {
    "series": "UM71",
    "broadcast": "arib",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      49
    ],
    "regions": [
      "JP"
    ]
  },
  "UM7100PLA": {
    "series": "UM71",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      70
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UM7100PLB": {
    "series": "UM71",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UM7100PPA": {
    "series": "UM71",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "PH"
    ]
  },
  "UM7100PSA": {
    "series": "UM71",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      43,
      49,
      55,
      65,
      75
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "UM7100PTA": {
    "series": "UM71",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ATC",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "ID",
      "MY",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UM7100PUA": {
    "series": "UM71",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      43,
      49,
      55,
      65,
      75
    ],
    "regions": [
      "MX"
    ]
  },
  "UM7100PVB": {
    "series": "UM71",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AFB",
    "sizes": [
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "ZA"
    ]
  },
  "UM7110PLB": {
    "series": "UM71",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UM7150PTA": {
    "series": "UM71",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      60
    ],
    "regions": [
      "AU",
      "IN",
      "NZ"
    ]
  },
  "UM7170DUA": {
    "series": "UM71",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      70
    ],
    "regions": [
      "CA"
    ]
  },
  "UM7200PDA": {
    "series": "UM72",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      60
    ],
    "regions": [
      "CO"
    ]
  },
  "UM7200PSA": {
    "series": "UM72",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      60
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "UM7270PSA": {
    "series": "UM72",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      60
    ],
    "regions": [
      "BR"
    ]
  },
  "UM7290PTD": {
    "series": "UM72",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      49,
      50,
      55,
      65
    ],
    "regions": [
      "ID",
      "IN",
      "MY",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UM7290PTF": {
    "series": "UM72",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43
    ],
    "regions": [
      "IN"
    ]
  },
  "UM7300AUE": {
    "series": "UM73",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UM7300EJA": {
    "series": "UM73",
    "broadcast": "arib",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UM7300PDA": {
    "series": "UM73",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      49,
      50
    ],
    "regions": [
      "CO"
    ]
  },
  "UM7300PLB": {
    "series": "UM73",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ADGZ",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UM7300PPA": {
    "series": "UM73",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      49,
      55,
      65,
      70
    ],
    "regions": [
      "PH"
    ]
  },
  "UM7300PSA": {
    "series": "UM73",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      49,
      50
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "UM7300PTA": {
    "series": "UM73",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UM7300PUA": {
    "series": "UM73",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UM7300PWA": {
    "series": "UM73",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".UTTYLJK",
    "sizes": [
      43,
      49,
      55,
      65,
      70
    ],
    "regions": [
      "TW"
    ]
  },
  "UM7340PVA": {
    "series": "UM73",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UM7350PUA": {
    "series": "UM73",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      70
    ],
    "regions": [
      "MX"
    ]
  },
  "UM7360PSA": {
    "series": "UM73",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50
    ],
    "regions": [
      "BR"
    ]
  },
  "UM7370AUB": {
    "series": "UM73",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UM7370PDA": {
    "series": "UM73",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      70
    ],
    "regions": [
      "CO"
    ]
  },
  "UM7370PSA": {
    "series": "UM73",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      70
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "UM7370PUA": {
    "series": "UM73",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70
    ],
    "regions": [
      "US"
    ]
  },
  "UM7380PJE": {
    "series": "UM73",
    "broadcast": "arib",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      55
    ],
    "regions": [
      "JP"
    ]
  },
  "UM7380PVA": {
    "series": "UM73",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      70
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UM7390PLC": {
    "series": "UM73",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ADRB",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UM7400PCA": {
    "series": "UM74",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "UM7400PDA": {
    "series": "UM74",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "UM7400PLB": {
    "series": "UM74",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UM7400PPA": {
    "series": "UM74",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      55
    ],
    "regions": [
      "PH"
    ]
  },
  "UM7400PSA": {
    "series": "UM74",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "UM7400PTA": {
    "series": "UM74",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ",
      "VN"
    ]
  },
  "UM7400PUA": {
    "series": "UM74",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UM74507LA": {
    "series": "UM74",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UM7450PLA": {
    "series": "UM74",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UM7450PVA": {
    "series": "UM74",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UM7470PSA": {
    "series": "UM74",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR"
    ]
  },
  "UM7490PLC": {
    "series": "UM74",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ADGZ",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "UM7500PJA": {
    "series": "UM75",
    "broadcast": "arib",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UM7500PLA": {
    "series": "UM75",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "HU",
      "IT",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UM7500PPA": {
    "series": "UM75",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "PH"
    ]
  },
  "UM7500PSB": {
    "series": "UM75",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".BWZ",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "UM7500PTA": {
    "series": "UM75",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ATI",
    "sizes": [
      75
    ],
    "regions": [
      "ID",
      "MY",
      "TH"
    ],
    "variants": [
      {
        "machine": "m16p3",
        "otaId": "HE_DTV_W19H_AFADABAA",
        "sizes": [
          82,
          86
        ],
        "regions": [
          "ID",
          "VN"
        ]
      }
    ]
  },
  "UM7500PWA": {
    "series": "UM75",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".STTYLJK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "UM7510PLA": {
    "series": "UM75",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UM751C0SB": {
    "series": "UM75",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".BWZ",
    "sizes": [
      43
    ],
    "regions": [
      "BR"
    ]
  },
  "UM7570AUE": {
    "series": "UM75",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UM7570PDB": {
    "series": "UM75",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      75,
      82
    ],
    "regions": [
      "CO"
    ]
  },
  "UM7570PSB": {
    "series": "UM75",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      75
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ],
    "variants": [
      {
        "machine": "m16p3",
        "otaId": "HE_DTV_W19H_AFADATAA",
        "sizes": [
          82
        ]
      }
    ]
  },
  "UM7570PUB": {
    "series": "UM75",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      75,
      82,
      86
    ],
    "regions": [
      "MX"
    ]
  },
  "UM7570PUD": {
    "series": "UM75",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "UM7580PVA": {
    "series": "UM75",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "machine": "m16p3",
        "otaId": "HE_DTV_W19H_AFADABAA",
        "sizes": [
          82,
          86
        ]
      }
    ]
  },
  "UM76007LB": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UM7600PCA": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "UM7600PLB": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      75
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "machine": "m16p3",
        "otaId": "HE_DTV_W19H_AFADABAA",
        "sizes": [
          82,
          86
        ],
        "regions": [
          "AT",
          "BE",
          "CZ",
          "DE",
          "FR",
          "HU",
          "IT",
          "PL",
          "SE",
          "UK"
        ]
      }
    ]
  },
  "UM7600PTA": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      82
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "machine": "m16p3",
        "otaId": "HE_DTV_W19H_AFADABAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UM7600PUB": {
    "series": "UM76",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      50
    ],
    "regions": [
      "MX"
    ]
  },
  "UM7600PVA": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      50
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "UM7600PWA": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".STTJLJK",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "TW"
    ]
  },
  "UM76107LB": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UM7610PLB": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UM7650PDB": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      65
    ],
    "regions": [
      "CO"
    ]
  },
  "UM7650PLA": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ADG",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "machine": "m16p3",
        "otaId": "HE_DTV_W19H_AFADABAA",
        "suffix": ".ADK",
        "sizes": [
          82
        ]
      }
    ]
  },
  "UM7650PSB": {
    "series": "UM76",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".BWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "UM7650PUB": {
    "series": "UM76",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UM7660PLA": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "KZ",
      "NL",
      "PL",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UM7660PVA": {
    "series": "UM76",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA"
    ]
  },
  "UM7700PTA": {
    "series": "UM77",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      50
    ],
    "regions": [
      "IN"
    ]
  },
  "UM7780PTA": {
    "series": "UM77",
    "broadcast": "dvb",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43
    ],
    "regions": [
      "IN"
    ]
  },
  "UM7800BNA": {
    "series": "UM78",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "KR"
    ]
  },
  "UM7800ENA": {
    "series": "UM78",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "KR"
    ]
  },
  "UM7800GNA": {
    "series": "UM78",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "KR"
    ]
  },
  "UM7800HNA": {
    "series": "UM78",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      50
    ],
    "regions": [
      "KR"
    ]
  },
  "UM7800KNA": {
    "series": "UM78",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UM781C0NB": {
    "series": "UM78",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      43,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UM781C3NA": {
    "series": "UM78",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UM7820KNA": {
    "series": "UM78",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UM7900BNA": {
    "series": "UM79",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UM7900GNA": {
    "series": "UM79",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UM7900KNA": {
    "series": "UM79",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "sizes": [
      82
    ],
    "regions": [
      "KR"
    ]
  },
  "UM791C0NA": {
    "series": "UM79",
    "broadcast": "atsc",
    "machine": "k5lp",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19P_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UM8070AUB": {
    "series": "UM80",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UM8070PUA": {
    "series": "UM80",
    "broadcast": "atsc",
    "machine": "m16p3",
    "codename": "goldilocks2",
    "otaId": "HE_DTV_W19H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75,
      82,
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UN6900PTF": {
    "series": "UN69",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATV",
    "sizes": [
      50
    ],
    "regions": [
      "VN"
    ]
  },
  "UN6950ZUD": {
    "series": "UN69",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "UN6951ZUA": {
    "series": "UN69",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      55,
      60,
      65
    ],
    "regions": [
      "CA",
      "MX"
    ]
  },
  "UN6951ZUD": {
    "series": "UN69",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      75
    ],
    "regions": [
      "CA"
    ]
  },
  "UN6951ZUF": {
    "series": "UN69",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      50
    ],
    "regions": [
      "CA",
      "MX"
    ]
  },
  "UN6955ZUF": {
    "series": "UN69",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UN6970PUD": {
    "series": "UN69",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "UN70003LA": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEEQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "UN70006LA": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEKQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UN7000KNC": {
    "series": "UN70",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7000PUB": {
    "series": "UN70",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UN7000PUC": {
    "series": "UN70",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UN7000PUD": {
    "series": "UN70",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UN70703LB": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      70
    ],
    "regions": [
      "CZ",
      "PL"
    ]
  },
  "UN70703LD": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      75
    ],
    "regions": [
      "CZ",
      "PL"
    ]
  },
  "UN70706LA": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      70
    ],
    "regions": [
      "RU"
    ]
  },
  "UN70706LB": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      70
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "IT",
      "NL",
      "PT",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UN70706LC": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ARU",
    "sizes": [
      75
    ],
    "regions": [
      "RU"
    ]
  },
  "UN70706LD": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      75
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "IT",
      "NL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UN7070PTA": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATV",
    "sizes": [
      70
    ],
    "regions": [
      "VN"
    ]
  },
  "UN7070PUA": {
    "series": "UN70",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      70
    ],
    "regions": [
      "CA"
    ]
  },
  "UN7070PUC": {
    "series": "UN70",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UN7070PVA": {
    "series": "UN70",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AFB",
    "sizes": [
      70
    ],
    "regions": [
      "ZA"
    ]
  },
  "UN71003LA": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      70
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UN71003LB": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "IT",
      "PL"
    ]
  },
  "UN71003LC": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UN71006LA": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      70
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UN71006LB": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEKD",
    "sizes": [
      43,
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UN71006LC": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UN7100PCA": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      49,
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "UN7100PCC": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AHKG",
    "sizes": [
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "UN7100PDA": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      49,
      65,
      70
    ],
    "regions": [
      "CO"
    ]
  },
  "UN7100PJA": {
    "series": "UN71",
    "broadcast": "arib",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      49,
      55,
      60
    ],
    "regions": [
      "JP"
    ]
  },
  "UN7100PSA": {
    "series": "UN71",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      49,
      55,
      65,
      70
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ]
  },
  "UN7100PSD": {
    "series": "UN71",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      75
    ],
    "regions": [
      "CL",
      "PE"
    ]
  },
  "UN7100PTA": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATI",
    "sizes": [
      43,
      60
    ],
    "regions": [
      "ID",
      "MY",
      "SG",
      "TH"
    ]
  },
  "UN7100PUA": {
    "series": "UN71",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      43,
      49,
      55,
      65,
      70
    ],
    "regions": [
      "MX"
    ]
  },
  "UN7100PUD": {
    "series": "UN71",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      75
    ],
    "regions": [
      "MX"
    ]
  },
  "UN7100PVA": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AMVG",
    "sizes": [
      49,
      55,
      60,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UN7150PTA": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      60
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "UN7180PVC": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AMA",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UN7190PTA": {
    "series": "UN71",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "IN",
      "VN"
    ]
  },
  "UN7200PPF": {
    "series": "UN72",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      55
    ],
    "regions": [
      "PH"
    ]
  },
  "UN7200PTD": {
    "series": "UN72",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATS",
    "sizes": [
      75
    ],
    "regions": [
      "MY",
      "TH"
    ]
  },
  "UN7200PTF": {
    "series": "UN72",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATC",
    "sizes": [
      49,
      50,
      55,
      65
    ],
    "regions": [
      "ID",
      "MY",
      "SG",
      "TH"
    ]
  },
  "UN7290PTD": {
    "series": "UN72",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATV",
    "sizes": [
      75
    ],
    "regions": [
      "VN"
    ]
  },
  "UN7290PTF": {
    "series": "UN72",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATV",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "VN"
    ]
  },
  "UN73003LA": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      49,
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "UN73003LC": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UN73006LA": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      49,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UN73006LC": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UN7300AUD": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UN7300PPC": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      49,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "PH"
    ]
  },
  "UN7300PSA": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      60
    ],
    "regions": [
      "PE"
    ]
  },
  "UN7300PSC": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "BR",
      "CL"
    ]
  },
  "UN7300PTC": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      49,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UN7300PUB": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      49,
      55,
      65
    ],
    "regions": [
      "CA"
    ]
  },
  "UN7300PUC": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UN7300PUD": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43
    ],
    "regions": [
      "CA"
    ]
  },
  "UN7300PUF": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UN7300PWC": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATT",
    "sizes": [
      43,
      49,
      55,
      65,
      70
    ],
    "regions": [
      "TW"
    ]
  },
  "UN7310PSA": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      60
    ],
    "regions": [
      "BR",
      "CL"
    ]
  },
  "UN7310PSC": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50,
      55,
      65,
      70
    ],
    "regions": [
      "BR",
      "CL"
    ]
  },
  "UN7340PVC": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UN73506LB": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AMCB",
    "sizes": [
      49,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UN73506LD": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ADGG",
    "sizes": [
      43
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UN7350PTD": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      49,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "IN",
      "VN"
    ]
  },
  "UN7370AUD": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      70
    ],
    "regions": [
      "CA"
    ]
  },
  "UN7370AUH": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UN7370PUB": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      75
    ],
    "regions": [
      "CA"
    ]
  },
  "UN7370PUC": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70
    ],
    "regions": [
      "MX",
      "US"
    ]
  },
  "UN7370PUE": {
    "series": "UN73",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ]
  },
  "UN7380PVC": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      70
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UN73903LE": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "IT",
      "PL"
    ]
  },
  "UN73906LE": {
    "series": "UN73",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UN74003LA": {
    "series": "UN74",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      70
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UN74003LB": {
    "series": "UN74",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "IT",
      "PL"
    ]
  },
  "UN74006LA": {
    "series": "UN74",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "AE",
      "AT",
      "DE",
      "ES",
      "FR",
      "KZ",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UN74006LB": {
    "series": "UN74",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      49,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UN74007LB": {
    "series": "UN74",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UN7400PCA": {
    "series": "UN74",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      43,
      49,
      55
    ],
    "regions": [
      "HK"
    ]
  },
  "UN7400PJA": {
    "series": "UN74",
    "broadcast": "arib",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      49,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UN7400PPA": {
    "series": "UN74",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "UN7800BNA": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      49,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7800BNC": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      43
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7800ENA": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7800ENC": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      43
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7800GNA": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      49,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7800GNC": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      43
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7800KNA": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      70
    ],
    "regions": [
      "KR"
    ]
  },
  "UN781C0NA": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      49,
      70,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UN781C0NC": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      43
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7820KNA": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      49
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7820KNC": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      43
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7850GNA": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7850KNA": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      49,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UN7850KNC": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      43
    ],
    "regions": [
      "KR"
    ]
  },
  "UN78GV0NA": {
    "series": "UN78",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UN80003LA": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UN80003LC": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UN80006LA": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "IT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UN80006LC": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "IT",
      "NL",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UN8000PDB": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AWC",
    "sizes": [
      50,
      75,
      82,
      86
    ],
    "regions": [
      "CO"
    ]
  },
  "UN8000PPA": {
    "series": "UN80",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "PH"
    ]
  },
  "UN8000PPB": {
    "series": "UN80",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "PH"
    ]
  },
  "UN8000PSB": {
    "series": "UN80",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "PE"
    ],
    "variants": [
      {
        "machine": "k6hp",
        "otaId": "HE_DTV_W20H_AFADATAA",
        "sizes": [
          82,
          86
        ]
      }
    ]
  },
  "UN8000PSD": {
    "series": "UN80",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50
    ],
    "regions": [
      "BR"
    ]
  },
  "UN8000PTA": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "IN",
      "SG"
    ]
  },
  "UN8000PTB": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATR",
    "sizes": [
      75
    ],
    "regions": [
      "IN",
      "VN"
    ],
    "variants": [
      {
        "machine": "k6hp",
        "otaId": "HE_DTV_W20H_AFADABAA",
        "suffix": ".ATM",
        "sizes": [
          82,
          86
        ],
        "regions": [
          "TH",
          "VN"
        ]
      }
    ]
  },
  "UN8000PUB": {
    "series": "UN80",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "MX"
    ]
  },
  "UN8000PWA": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".UTTFLJK",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "UN8050PUD": {
    "series": "UN80",
    "broadcast": "atsc",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UN8060PVB": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AMIG",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "UN8080PVA": {
    "series": "UN80",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA"
    ],
    "variants": [
      {
        "machine": "k6hp",
        "otaId": "HE_DTV_W20H_AFADABAA",
        "sizes": [
          82,
          86
        ],
        "regions": [
          "AU",
          "NZ",
          "SA",
          "ZA"
        ]
      }
    ]
  },
  "UN81003LB": {
    "series": "UN81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UN81006LB": {
    "series": "UN81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UN8100PCA": {
    "series": "UN81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AHK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "UN8100PJA": {
    "series": "UN81",
    "broadcast": "arib",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADJAAA",
    "suffix": ".AJL",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UN8100PTA": {
    "series": "UN81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATV",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "VN"
    ]
  },
  "UN8100PTB": {
    "series": "UN81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".AAU",
    "sizes": [
      75
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ"
    ],
    "variants": [
      {
        "machine": "k6hp",
        "otaId": "HE_DTV_W20H_AFADABAA",
        "sizes": [
          82,
          86
        ],
        "regions": [
          "AU",
          "ID",
          "NZ",
          "SG"
        ]
      }
    ]
  },
  "UN8100PWA": {
    "series": "UN81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ATT",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "TW"
    ]
  },
  "UN8100PWB": {
    "series": "UN81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".UTTFLJK",
    "sizes": [
      75
    ],
    "regions": [
      "TW"
    ]
  },
  "UN8160PVA": {
    "series": "UN81",
    "broadcast": "dvb",
    "machine": "k6lp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20P_AFADABAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "AU",
      "NZ"
    ]
  },
  "UN85003LA": {
    "series": "UN85",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75,
      82,
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UN85006LA": {
    "series": "UN85",
    "broadcast": "dvb",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADABAA",
    "suffix": ".AEK",
    "sizes": [
      65,
      75,
      82,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UN8500AUJ": {
    "series": "UN85",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UN8500PUI": {
    "series": "UN85",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UN8570AUD": {
    "series": "UN85",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75,
      82,
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UN8570PUB": {
    "series": "UN85",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      82,
      86
    ],
    "regions": [
      "MX"
    ]
  },
  "UN8570PUC": {
    "series": "UN85",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      86
    ],
    "regions": [
      "US"
    ]
  },
  "UN8900KNA": {
    "series": "UN89",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      82,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "UN8950KNA": {
    "series": "UN89",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "sizes": [
      82
    ],
    "regions": [
      "KR"
    ]
  },
  "UN9000AUJ": {
    "series": "UN90",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UN9070AUD": {
    "series": "UN90",
    "broadcast": "atsc",
    "machine": "k6hp",
    "codename": "jhericurl",
    "otaId": "HE_DTV_W20H_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UP7000PUA": {
    "series": "UP70",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ACCQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UP7070PUD": {
    "series": "UP70",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      75
    ],
    "regions": [
      "CA"
    ]
  },
  "UP7070PUE": {
    "series": "UP70",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UP7100ZUF": {
    "series": "UP71",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CA"
    ]
  },
  "UP7170ZUC": {
    "series": "UP71",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      70
    ],
    "regions": [
      "CA"
    ]
  },
  "UP75003LC": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UP75003LF": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "BE",
      "CZ",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT"
    ]
  },
  "UP75006LC": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UP75006LF": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UP75009LC": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UP75009LF": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "HU",
      "PT"
    ]
  },
  "UP7500KNA": {
    "series": "UP75",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UP7500PSC": {
    "series": "UP75",
    "broadcast": "isdb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "CL",
      "CO",
      "PE"
    ]
  },
  "UP7500PSF": {
    "series": "UP75",
    "broadcast": "isdb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "UP7500PTC": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATM",
    "sizes": [
      43,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "ID",
      "TH",
      "VN"
    ]
  },
  "UP7500PTZ": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "IN"
    ]
  },
  "UP7500PVG": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UP7550PSF": {
    "series": "UP75",
    "broadcast": "isdb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".BWZ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "BR",
      "PH"
    ]
  },
  "UP7550PTC": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATC",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "ID",
      "MY",
      "SG",
      "VN"
    ]
  },
  "UP7550PTZ": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "UP7550PVC": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UP7550PVD": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      70
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UP7550PVG": {
    "series": "UP75",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UP7560AUD": {
    "series": "UP75",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UP7570AUD": {
    "series": "UP75",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UP7570AUE": {
    "series": "UP75",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      75
    ],
    "regions": [
      "CA"
    ]
  },
  "UP76006LC": {
    "series": "UP76",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ADGG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UP76506LD": {
    "series": "UP76",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "RU"
    ]
  },
  "UP76703LB": {
    "series": "UP76",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "HU"
    ]
  },
  "UP76706LB": {
    "series": "UP76",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "BE",
      "ES",
      "IT",
      "NL",
      "UK"
    ]
  },
  "UP76709LB": {
    "series": "UP76",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UP7670PUB": {
    "series": "UP76",
    "broadcast": "atsc",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "CA"
    ]
  },
  "UP7670PUC": {
    "series": "UP76",
    "broadcast": "atsc",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UP76903LE": {
    "series": "UP76",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UP76906LE": {
    "series": "UP76",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UP76909LE": {
    "series": "UP76",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UP77003LB": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "CZ",
      "DE",
      "ES",
      "HU",
      "PL",
      "PT"
    ]
  },
  "UP77006LB": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UP77009LB": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "HU",
      "NL",
      "PL",
      "PT"
    ]
  },
  "UP7700PJB": {
    "series": "UP77",
    "broadcast": "arib",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      50,
      55
    ],
    "regions": [
      "JP"
    ]
  },
  "UP7700PSB": {
    "series": "UP77",
    "broadcast": "isdb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AWF",
    "sizes": [
      43,
      50,
      55,
      60,
      65
    ],
    "regions": [
      "CL",
      "MX",
      "PE"
    ]
  },
  "UP7700PUB": {
    "series": "UP77",
    "broadcast": "atsc",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      50,
      55,
      60,
      65
    ],
    "regions": [
      "CA"
    ]
  },
  "UP77026LB": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "RU"
    ]
  },
  "UP77106LB": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".HPDGLWK",
    "sizes": [
      55
    ],
    "regions": [
      "TR"
    ]
  },
  "UP77109LC": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      75
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR",
      "SE",
      "TR"
    ]
  },
  "UP7710PSB": {
    "series": "UP77",
    "broadcast": "atsc",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "MX"
    ]
  },
  "UP7720PTC": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ATV",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "VN"
    ]
  },
  "UP7720PTY": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "UP7740PTZ": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "UP77506LA": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AMCB",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UP7750PSB": {
    "series": "UP77",
    "broadcast": "isdb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE",
      "PH",
      "TW"
    ]
  },
  "UP7750PTB": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ATC",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "ID",
      "MY",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UP7750PTZ": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "IN"
    ]
  },
  "UP7750PVB": {
    "series": "UP77",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ]
  },
  "UP7760PSB": {
    "series": "UP77",
    "broadcast": "isdb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AWH",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CL",
      "CO",
      "MX",
      "PE"
    ]
  },
  "UP7770PUB": {
    "series": "UP77",
    "broadcast": "atsc",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "CA"
    ]
  },
  "UP78003LB": {
    "series": "UP78",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ]
  },
  "UP78006LB": {
    "series": "UP78",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UP78006LC": {
    "series": "UP78",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ADKB",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UP78009LB": {
    "series": "UP78",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UP7800PCB": {
    "series": "UP78",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "UP7800PTB": {
    "series": "UP78",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".ATV",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "VN"
    ]
  },
  "UP80003LA": {
    "series": "UP80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL",
      "PT"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          82,
          86
        ]
      }
    ]
  },
  "UP80003LR": {
    "series": "UP80",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UP80006LA": {
    "series": "UP80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          82,
          86
        ],
        "regions": [
          "AT",
          "BE",
          "DE",
          "ES",
          "FR",
          "IT",
          "NL",
          "PT",
          "RU",
          "SE",
          "UK"
        ]
      }
    ]
  },
  "UP80006LR": {
    "series": "UP80",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR",
      "SE",
      "UK"
    ]
  },
  "UP80009LA": {
    "series": "UP80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          82,
          86
        ]
      }
    ]
  },
  "UP80009LR": {
    "series": "UP80",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UP8000PJB": {
    "series": "UP80",
    "broadcast": "arib",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "JP"
    ]
  },
  "UP8000PTB": {
    "series": "UP80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "MY",
      "NZ",
      "SG",
      "TH"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          82,
          86
        ],
        "regions": [
          "AU",
          "ID",
          "NZ",
          "TH",
          "VN"
        ]
      }
    ]
  },
  "UP8000PTZ": {
    "series": "UP80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "IN"
    ]
  },
  "UP8000PUA": {
    "series": "UP80",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      50,
      55,
      60,
      65
    ],
    "regions": [
      "CA"
    ]
  },
  "UP8000PUR": {
    "series": "UP80",
    "broadcast": "atsc",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UP8050PSB": {
    "series": "UP80",
    "broadcast": "isdb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".BWZ",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "MX",
      "PH"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "suffix": ".AWZ",
        "sizes": [
          82,
          86
        ],
        "regions": [
          "BR",
          "MX",
          "PE",
          "TW"
        ]
      }
    ]
  },
  "UP8050PVB": {
    "series": "UP80",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          82,
          86
        ],
        "regions": [
          "AU",
          "NZ",
          "ZA"
        ]
      }
    ]
  },
  "UP8070PUA": {
    "series": "UP80",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "CA"
    ]
  },
  "UP8070PUR": {
    "series": "UP80",
    "broadcast": "atsc",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UP81003LA": {
    "series": "UP81",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL",
      "PT"
    ]
  },
  "UP81003LR": {
    "series": "UP81",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UP81006LA": {
    "series": "UP81",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "suffix": ".ADKB",
        "sizes": [
          82,
          86
        ]
      }
    ]
  },
  "UP81006LR": {
    "series": "UP81",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "ES",
      "FR",
      "IT",
      "PT",
      "UK"
    ]
  },
  "UP81009LA": {
    "series": "UP81",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UP81009LR": {
    "series": "UP81",
    "broadcast": "dvb",
    "machine": "k7lp",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UP8100PCB": {
    "series": "UP81",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "UP8100PTB": {
    "series": "UP81",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ATS",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "MY",
      "VN"
    ]
  },
  "UP8150PVB": {
    "series": "UP81",
    "broadcast": "dvb",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA"
    ]
  },
  "UP8200KNA": {
    "series": "UP82",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UP8300ENA": {
    "series": "UP83",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UP8300KNA": {
    "series": "UP83",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          82,
          86
        ]
      }
    ]
  },
  "UP8300MNA": {
    "series": "UP83",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UP8300NNA": {
    "series": "UP83",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UP8300SNA": {
    "series": "UP83",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      55,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UP831C0NA": {
    "series": "UP83",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UP83GC0NA": {
    "series": "UP83",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "lm21u",
        "otaId": "HE_DTV_W21U_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UP83RC0NA": {
    "series": "UP83",
    "broadcast": "atsc",
    "machine": "lm21a",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21A_AFADATAA",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UP8770PUA": {
    "series": "UP87",
    "broadcast": "atsc",
    "machine": "lm21u",
    "codename": "kisscurl",
    "otaId": "HE_DTV_W21U_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      82,
      86
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UQ70003LB": {
    "series": "UQ70",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEEQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UQ70006LB": {
    "series": "UQ70",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEKQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SA",
      "SE",
      "UK"
    ]
  },
  "UQ7030PUD": {
    "series": "UQ70",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "US"
    ]
  },
  "UQ7050ZUD": {
    "series": "UQ70",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55
    ],
    "regions": [
      "US"
    ]
  },
  "UQ7070ZUD": {
    "series": "UQ70",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      70,
      75
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ7070ZUE": {
    "series": "UQ70",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UQ7400PSF": {
    "series": "UQ74",
    "broadcast": "isdb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AWC",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CO",
      "MX"
    ]
  },
  "UQ75001LG": {
    "series": "UQ75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "RU",
      "ZA"
    ]
  },
  "UQ75003LF": {
    "series": "UQ75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "IT",
      "PL"
    ]
  },
  "UQ75006LF": {
    "series": "UQ75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "AU",
      "BE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UQ75006LG": {
    "series": "UQ75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AMAE",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UQ75009LF": {
    "series": "UQ75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "UQ7500PSF": {
    "series": "UQ75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "ID",
      "IN",
      "PE",
      "PH",
      "TH",
      "VN"
    ]
  },
  "UQ7550PSF": {
    "series": "UQ75",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "ID",
      "IN",
      "MY",
      "PH",
      "SG",
      "VN"
    ]
  },
  "UQ7570PUJ": {
    "series": "UQ75",
    "broadcast": "atsc",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "MX",
      "US"
    ]
  },
  "UQ7590PUB": {
    "series": "UQ75",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UQ7590PUD": {
    "series": "UQ75",
    "broadcast": "atsc",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      86
    ],
    "regions": [
      "CA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      }
    ]
  },
  "UQ76003LD": {
    "series": "UQ76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ADGG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "KZ",
      "RU"
    ]
  },
  "UQ76009LC": {
    "series": "UQ76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "RU"
    ]
  },
  "UQ76903LE": {
    "series": "UQ76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UQ76906LE": {
    "series": "UQ76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43
    ],
    "regions": [
      "AE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "PT",
      "RU",
      "SE",
      "UK"
    ]
  },
  "UQ76909LE": {
    "series": "UQ76",
    "broadcast": "dvb",
    "machine": "k8lp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UQ79003LA": {
    "series": "UQ79",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "IT",
      "PL"
    ]
  },
  "UQ79006LA": {
    "series": "UQ79",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "BE",
      "ES",
      "FR",
      "NL"
    ]
  },
  "UQ79006LD": {
    "series": "UQ79",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      60
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "UQ79009LA": {
    "series": "UQ79",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UQ7950PSB": {
    "series": "UQ79",
    "broadcast": "isdb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".BWZ",
    "sizes": [
      50,
      55,
      60,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "PE"
    ]
  },
  "UQ80001LA": {
    "series": "UQ80",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AMCB",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "RU"
    ]
  },
  "UQ80003LB": {
    "series": "UQ80",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "CZ",
      "ES",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ80006LB": {
    "series": "UQ80",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "AU",
      "BE",
      "ES",
      "FR",
      "KZ",
      "NL",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ80006LD": {
    "series": "UQ80",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AMAE",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UQ80009LB": {
    "series": "UQ80",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE",
      "ES"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ8000AUB": {
    "series": "UQ80",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      70,
      75
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".ACC",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".ACC",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ8000PJC": {
    "series": "UQ80",
    "broadcast": "arib",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "JP"
    ]
  },
  "UQ8000PSB": {
    "series": "UQ80",
    "broadcast": "isdb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AWC",
    "sizes": [
      43,
      50,
      55,
      60,
      65
    ],
    "regions": [
      "CO",
      "MX"
    ]
  },
  "UQ8000PSC": {
    "series": "UQ80",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "ID",
      "PH",
      "TH",
      "VN"
    ]
  },
  "UQ8020PSB": {
    "series": "UQ80",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "UQ8040PSB": {
    "series": "UQ80",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "IN"
    ]
  },
  "UQ8050PSB": {
    "series": "UQ80",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "ID",
      "IN",
      "MX",
      "MY",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ]
  },
  "UQ81003LA": {
    "series": "UQ81",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".ARU",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "RU"
    ]
  },
  "UQ81003LB": {
    "series": "UQ81",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "IT",
      "PL"
    ]
  },
  "UQ81006LB": {
    "series": "UQ81",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "AE",
      "BE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ]
  },
  "UQ81009LB": {
    "series": "UQ81",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "PL"
    ]
  },
  "UQ81009LC": {
    "series": "UQ81",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".ADGG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "UQ8100PCB": {
    "series": "UQ81",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "HK"
    ]
  },
  "UQ8150PSB": {
    "series": "UQ81",
    "broadcast": "isdb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      50,
      55,
      60,
      65,
      70
    ],
    "regions": [
      "PH",
      "VN"
    ]
  },
  "UQ8200KNF": {
    "series": "UQ82",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UQ8300ENA": {
    "series": "UQ83",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ8300ENF": {
    "series": "UQ83",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UQ8300NNA": {
    "series": "UQ83",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UQ8300NNF": {
    "series": "UQ83",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      65
    ],
    "regions": [
      "KR"
    ]
  },
  "UQ8300QNA": {
    "series": "UQ83",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ]
  },
  "UQ90003LA": {
    "series": "UQ90",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UQ90006LA": {
    "series": "UQ90",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      75
    ],
    "regions": [
      "ES",
      "SE",
      "UK"
    ]
  },
  "UQ90006LC": {
    "series": "UQ90",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".HFBFLWK",
    "sizes": [
      70,
      75
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".HFBYLWK",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ90006LD": {
    "series": "UQ90",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "suffix": ".ADGG",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ90009LA": {
    "series": "UQ90",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ]
  },
  "UQ9000PSD": {
    "series": "UQ90",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "NZ",
      "PH",
      "SG",
      "TH"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ],
        "regions": [
          "AU",
          "ID",
          "MY",
          "NZ",
          "SG",
          "TH"
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ9000PUD": {
    "series": "UQ90",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UQ9050PSC": {
    "series": "UQ90",
    "broadcast": "isdb",
    "machine": "k8hp",
    "codename": "mullet",
    "otaId": "HE_DTV_W22H_AFADATAA",
    "suffix": ".AWH",
    "sizes": [
      65,
      75,
      86
    ],
    "regions": [
      "MX",
      "PE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "machine": "lm21an",
        "otaId": "HE_DTV_W22A_AFADATAA",
        "sizes": [
          50,
          55
        ],
        "regions": [
          "CL",
          "MX"
        ]
      }
    ]
  },
  "UQ91003LA": {
    "series": "UQ91",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ91006LA": {
    "series": "UQ91",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "AU",
      "BE",
      "ES",
      "NL",
      "NZ",
      "PT",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ],
        "regions": [
          "DE",
          "FR",
          "NL",
          "RU",
          "UK"
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ],
        "regions": [
          "DE",
          "UK"
        ]
      }
    ]
  },
  "UQ91006LC": {
    "series": "UQ91",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AMAE",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "UQ91009LA": {
    "series": "UQ91",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "DE"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hp",
        "codename": "ombre",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ91009LD": {
    "series": "UQ91",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      55,
      60,
      65,
      70,
      75
    ],
    "regions": [
      "KZ",
      "RU"
    ]
  },
  "UQ9100PCD": {
    "series": "UQ91",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ]
  },
  "UQ9100PJD": {
    "series": "UQ91",
    "broadcast": "arib",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "JP"
    ]
  },
  "UQ9100PSD": {
    "series": "UQ91",
    "broadcast": "dvb",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "suffix": ".ATS",
    "sizes": [
      43,
      50,
      55,
      60,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "MY",
      "TW",
      "VN"
    ]
  },
  "UQ9300KNA": {
    "series": "UQ93",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ931C0NA": {
    "series": "UQ93",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          43,
          50,
          55,
          65,
          75,
          86
        ]
      }
    ]
  },
  "UQ93GC0NA": {
    "series": "UQ93",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "machine": "k8hp",
        "otaId": "HE_DTV_W22H_AFADATAA",
        "sizes": [
          86
        ]
      }
    ]
  },
  "UQ93RC0NA": {
    "series": "UQ93",
    "broadcast": "atsc",
    "machine": "lm21an",
    "codename": "mullet",
    "otaId": "HE_DTV_W22A_AFADATAA",
    "sizes": [
      43,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ]
  },
  "UR73003LA": {
    "series": "UR73",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEEQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CZ",
      "HU",
      "IT",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR73006LA": {
    "series": "UR73",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEKQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PL",
      "PT",
      "SA",
      "SE",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR7300PSA": {
    "series": "UR73",
    "broadcast": "isdb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AWFQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CL",
      "CO",
      "PE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR74003LB": {
    "series": "UR74",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEEQ",
    "sizes": [
      43,
      55
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UR74006LB": {
    "series": "UR74",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEEQ",
    "sizes": [
      43,
      55
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UR7410PSA": {
    "series": "UR74",
    "broadcast": "isdb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AWC",
    "sizes": [
      50,
      55,
      65,
      70
    ],
    "regions": [
      "CO"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR75003LK": {
    "series": "UR75",
    "broadcast": "dvb",
    "machine": "m23",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HU"
    ]
  },
  "UR75006LB": {
    "series": "UR75",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      86
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "FR",
      "NL",
      "UK"
    ]
  },
  "UR75006LC": {
    "series": "UR75",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "UR75006LK": {
    "series": "UR75",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "machine": "m23",
        "otaId": "HE_DTV_W23M_AFADATAA",
        "sizes": [
          43,
          50,
          55,
          65,
          75
        ]
      }
    ]
  },
  "UR7500PJC": {
    "series": "UR75",
    "broadcast": "arib",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR7500PSC": {
    "series": "UR75",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "ID",
      "IN",
      "PH"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR75506LC": {
    "series": "UR75",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "IN"
    ]
  },
  "UR7550PSC": {
    "series": "UR75",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "ID",
      "IN",
      "MY",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR76003LC": {
    "series": "UR76",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      86
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR76003LL": {
    "series": "UR76",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ]
  },
  "UR76006LC": {
    "series": "UR76",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      86
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR76006LL": {
    "series": "UR76",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "SE"
    ]
  },
  "UR7790PSA": {
    "series": "UR77",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43
    ],
    "regions": [
      "IN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR78001LJ": {
    "series": "UR78",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".ARUB",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR78003LB": {
    "series": "UR78",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR78003LK": {
    "series": "UR78",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "ES",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR78006LB": {
    "series": "UR78",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      86
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "PT",
      "RU",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR78006LC": {
    "series": "UR78",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      86
    ],
    "regions": [
      "AE",
      "SA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR78006LK": {
    "series": "UR78",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR78006LL": {
    "series": "UR78",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".ANR",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "codename": "number1",
        "suffix": ".AMVE",
        "swMajor": "03"
      },
      {
        "codename": "ombre",
        "suffix": ".AMVE",
        "swMajor": "23"
      }
    ]
  },
  "UR78009LL": {
    "series": "UR78",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KZ",
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR7800PSA": {
    "series": "UR78",
    "broadcast": "isdb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43
    ],
    "regions": [
      "BR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR7800PSB": {
    "series": "UR78",
    "broadcast": "isdb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AWH",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CO",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR7800PSM": {
    "series": "UR78",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AWM",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "MX"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR7800PUA": {
    "series": "UR78",
    "broadcast": "atsc",
    "machine": "k8lpn",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      86
    ],
    "regions": [
      "CA"
    ]
  },
  "UR78066LK": {
    "series": "UR78",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "AE",
      "SA"
    ]
  },
  "UR80003LJ": {
    "series": "UR80",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR80006LA": {
    "series": "UR80",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      86
    ],
    "regions": [
      "AE",
      "AU",
      "NZ",
      "SA",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR80006LJ": {
    "series": "UR80",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "NL",
      "NZ",
      "PT",
      "SA",
      "SE",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR8000AUA": {
    "series": "UR80",
    "broadcast": "atsc",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      75
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k8hpp",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "suffix": ".ACC",
        "sizes": [
          86
        ],
        "regions": [
          "CA"
        ],
        "swMajor": "33"
      }
    ]
  },
  "UR8000PCB": {
    "series": "UR80",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50
    ],
    "regions": [
      "HK"
    ]
  },
  "UR8000PJB": {
    "series": "UR80",
    "broadcast": "arib",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR8000PSA": {
    "series": "UR80",
    "broadcast": "isdb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      50,
      55
    ],
    "regions": [
      "PH"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR8020PSB": {
    "series": "UR80",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "IN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR8040PSB": {
    "series": "UR80",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "IN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR80506LK": {
    "series": "UR80",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "ponytail",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "SA"
    ]
  },
  "UR8050PCB": {
    "series": "UR80",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65,
      70
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR8050PSB": {
    "series": "UR80",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AU",
      "ID",
      "IN",
      "MY",
      "NZ",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k8hpp",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hpp",
        "codename": "ombre",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "23"
      },
      {
        "machine": "k8hpp",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "UR81003LA": {
    "series": "UR81",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      86
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR81003LJ": {
    "series": "UR81",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "IT",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR81006LA": {
    "series": "UR81",
    "broadcast": "dvb",
    "machine": "k8hpp",
    "codename": "number1",
    "otaId": "HE_DTV_W23H_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      86
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR81006LJ": {
    "series": "UR81",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "BE",
      "DE",
      "ES",
      "FR",
      "ID",
      "IT",
      "KZ",
      "NL",
      "NZ",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR81009LK": {
    "series": "UR81",
    "broadcast": "dvb",
    "machine": "lm21ann",
    "codename": "number1",
    "otaId": "HE_DTV_W23A_AFADATAA",
    "suffix": ".ARUB",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "RU"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR8150PSB": {
    "series": "UR81",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATS",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "MY",
      "PH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k8hpp",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "suffix": ".ATV",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hpp",
        "codename": "ombre",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "suffix": ".ATV",
        "sizes": [
          86
        ],
        "swMajor": "23"
      },
      {
        "machine": "k8hpp",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "suffix": ".ATV",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "UR8200KNA": {
    "series": "UR82",
    "broadcast": "atsc",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR8250KNA": {
    "series": "UR82",
    "broadcast": "atsc",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "sizes": [
      50
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR8300ENA": {
    "series": "UR83",
    "broadcast": "atsc",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k8hpp",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hpp",
        "codename": "ombre",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "23"
      },
      {
        "machine": "k8hpp",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "UR8300NNA": {
    "series": "UR83",
    "broadcast": "atsc",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "sizes": [
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR831C0NA": {
    "series": "UR83",
    "broadcast": "atsc",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR8750PSA": {
    "series": "UR87",
    "broadcast": "isdb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR9000PUA": {
    "series": "UR90",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR9050PSJ": {
    "series": "UR90",
    "broadcast": "isdb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      55,
      65
    ],
    "regions": [
      "BR",
      "CL",
      "CO",
      "MX",
      "PE"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR9050PSK": {
    "series": "UR90",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".ATR",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "ID",
      "IN",
      "MY",
      "TH",
      "TW",
      "VN"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR91003LA": {
    "series": "UR91",
    "broadcast": "dvb",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CZ",
      "HU",
      "PL"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR91006LA": {
    "series": "UR91",
    "broadcast": "dvb",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AE",
      "AT",
      "BE",
      "DE",
      "ES",
      "FR",
      "ID",
      "IT",
      "KZ",
      "NL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR9150PCK": {
    "series": "UR91",
    "broadcast": "dvb",
    "machine": "k8lpn",
    "codename": "number1",
    "otaId": "HE_DTV_W23P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UR9300KNA": {
    "series": "UR93",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "ID",
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k8hpp",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hpp",
        "codename": "ombre",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "23"
      },
      {
        "machine": "k8hpp",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "UR931C0NA": {
    "series": "UR93",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k8hpp",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hpp",
        "codename": "ombre",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "23"
      },
      {
        "machine": "k8hpp",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "UR93GC0NA": {
    "series": "UR93",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k8hpp",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hpp",
        "codename": "ombre",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "23"
      },
      {
        "machine": "k8hpp",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "UR93RC0NA": {
    "series": "UR93",
    "broadcast": "atsc",
    "machine": "m23",
    "codename": "number1",
    "otaId": "HE_DTV_W23M_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ombre",
        "swMajor": "23"
      },
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k8hpp",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ]
      },
      {
        "machine": "k8hpp",
        "codename": "ombre",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "23"
      },
      {
        "machine": "k8hpp",
        "codename": "ponytail",
        "otaId": "HE_DTV_W23H_AFADATAA",
        "sizes": [
          86
        ],
        "swMajor": "33"
      }
    ]
  },
  "UT7000PUA": {
    "series": "UT70",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UT7550AUA": {
    "series": "UT75",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT7590PUA": {
    "series": "UT75",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      75,
      86
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT7800PCB": {
    "series": "UT78",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT80003LA": {
    "series": "UT80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT80006LA": {
    "series": "UT80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "PT",
      "RU",
      "SA",
      "SE",
      "UK",
      "ZA"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "UT80006LB": {
    "series": "UT80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AMVE",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "SA",
      "ZA"
    ]
  },
  "UT8000AUA": {
    "series": "UT80",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AUS",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT8000PJB": {
    "series": "UT80",
    "broadcast": "arib",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADJAAA",
    "suffix": ".AJLG",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "JP"
    ],
    "variants": [
      {
        "codename": "ponytail"
      }
    ]
  },
  "UT8000PSA": {
    "series": "UT80",
    "broadcast": "isdb",
    "machine": "k8lpn2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "BR"
    ]
  },
  "UT8000PSB": {
    "series": "UT80",
    "broadcast": "isdb",
    "machine": "k8lpn2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AWC",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "CO",
      "PH"
    ],
    "variants": [
      {
        "codename": "ombre",
        "suffix": ".APH",
        "swMajor": "03"
      }
    ]
  },
  "UT8000PUA": {
    "series": "UT80",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".ACC",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "CA"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT8050PCB": {
    "series": "UT80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT8050PSA": {
    "series": "UT80",
    "broadcast": "isdb",
    "machine": "k8lpn2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AWZ",
    "sizes": [
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "BR"
    ]
  },
  "UT8050PSB": {
    "series": "UT80",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AAU",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "AU",
      "CL",
      "CO",
      "ID",
      "MX",
      "MY",
      "NZ",
      "PE",
      "PH",
      "SG",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT8080PSA": {
    "series": "UT80",
    "broadcast": "isdb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      43,
      55,
      65
    ],
    "regions": [
      "PH"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT81006LA": {
    "series": "UT81",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "AE",
      "AT",
      "AU",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NZ",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      }
    ]
  },
  "UT81009LB": {
    "series": "UT81",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".ADKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "KZ"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT8150PSB": {
    "series": "UT81",
    "broadcast": "isdb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".APH",
    "sizes": [
      50,
      55,
      65
    ],
    "regions": [
      "MY",
      "PH"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT8300ENA": {
    "series": "UT83",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      70,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT8300GNA": {
    "series": "UT83",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT8300NNA": {
    "series": "UT83",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      43,
      65,
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT8350KNA": {
    "series": "UT83",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      50
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT90006LA": {
    "series": "UT90",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AMVQ",
    "sizes": [
      98
    ],
    "regions": [
      "AE",
      "SA"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT9000PUA": {
    "series": "UT90",
    "broadcast": "atsc",
    "machine": "k24",
    "codename": "ombre",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      98
    ],
    "regions": [
      "CA",
      "US"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT9050PCB": {
    "series": "UT90",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AHKG",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT9050PSA": {
    "series": "UT90",
    "broadcast": "dvb",
    "machine": "k24",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24H_AFADATAA",
    "suffix": ".AAUQ",
    "sizes": [
      98
    ],
    "regions": [
      "AU",
      "BR",
      "CL",
      "ID",
      "NZ",
      "PE"
    ],
    "variants": [
      {
        "broadcast": "isdb",
        "machine": "k8lpn2",
        "codename": "ombre",
        "otaId": "HE_DTV_W24P_AFADATAA",
        "suffix": ".AWZ",
        "sizes": [
          55,
          65
        ],
        "regions": [
          "BR",
          "CL",
          "CO",
          "MX",
          "PE"
        ],
        "swMajor": "03"
      },
      {
        "broadcast": "isdb",
        "machine": "k8lpn2",
        "otaId": "HE_DTV_W24P_AFADATAA",
        "suffix": ".AWZ",
        "sizes": [
          55,
          65
        ],
        "regions": [
          "BR",
          "CL",
          "CO",
          "MX",
          "PE"
        ]
      },
      {
        "broadcast": "isdb",
        "codename": "ombre",
        "suffix": ".AWFQ",
        "swMajor": "03"
      }
    ]
  },
  "UT9050PSB": {
    "series": "UT90",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".ATI",
    "sizes": [
      50,
      55,
      65,
      75
    ],
    "regions": [
      "ID",
      "MY",
      "TH",
      "VN"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT91003LA": {
    "series": "UT91",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEU",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "HU"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT91006LA": {
    "series": "UT91",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".AEK",
    "sizes": [
      43,
      50,
      55,
      65,
      75
    ],
    "regions": [
      "AT",
      "CZ",
      "DE",
      "ES",
      "FR",
      "IT",
      "KZ",
      "NL",
      "PL",
      "PT",
      "RU",
      "SE",
      "TR",
      "UK"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "codename": "queue"
      },
      {
        "machine": "k24",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "suffix": ".AEKQ",
        "sizes": [
          98
        ],
        "regions": [
          "AT",
          "BE",
          "DE",
          "HU",
          "PT",
          "UK"
        ]
      },
      {
        "machine": "k24",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "suffix": ".AEKQ",
        "sizes": [
          98
        ],
        "regions": [
          "AT",
          "BE",
          "DE",
          "HU",
          "PT",
          "UK"
        ],
        "swMajor": "33"
      }
    ]
  },
  "UT9150PTA": {
    "series": "UT91",
    "broadcast": "dvb",
    "machine": "k8lpn2",
    "codename": "ponytail",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "suffix": ".ATT",
    "sizes": [
      55,
      65,
      75
    ],
    "regions": [
      "TW"
    ]
  },
  "UT9300BNA": {
    "series": "UT93",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      75
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT9300KNA": {
    "series": "UT93",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      },
      {
        "machine": "k24",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "sizes": [
          98
        ]
      },
      {
        "machine": "k24",
        "codename": "ponytail",
        "otaId": "HE_DTV_W24H_AFADATAA",
        "sizes": [
          98
        ],
        "swMajor": "33"
      }
    ]
  },
  "UT931C0NA": {
    "series": "UT93",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      43,
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT93GC0NA": {
    "series": "UT93",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UT93RC0NA": {
    "series": "UT93",
    "broadcast": "atsc",
    "machine": "k8lpn2",
    "codename": "ombre",
    "otaId": "HE_DTV_W24P_AFADATAA",
    "sizes": [
      50,
      55,
      65,
      75,
      86
    ],
    "regions": [
      "KR"
    ],
    "variants": [
      {
        "codename": "ponytail",
        "swMajor": "33"
      }
    ]
  },
  "UA73006LA": {
    "series": "UA73",
    "broadcast": "dvb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AEEQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "AT",
      "BE",
      "CZ",
      "DE",
      "ES",
      "FR",
      "HU",
      "IT",
      "NL",
      "PT",
      "SE",
      "UK"
    ]
  },
  "UA7700PUB": {
    "series": "UA77",
    "broadcast": "atsc",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AUSQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CA",
      "US"
    ]
  },
  "UA7300PSB": {
    "series": "UA73",
    "broadcast": "isdb",
    "machine": "k25lp",
    "codename": "ponytail",
    "otaId": "HE_DTV_W25P_AFADATAA",
    "suffix": ".AWFQ",
    "sizes": [
      43,
      50,
      55,
      65
    ],
    "regions": [
      "CL",
      "CO",
      "PE"
    ]
  }
}